
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("kqszs", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4eGW1 = parcelRequire("4eGW1");
'use strict';
function $edec65eea23f7436$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $edec65eea23f7436$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $edec65eea23f7436$var$_typeof(o);
}
function $edec65eea23f7436$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $edec65eea23f7436$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $edec65eea23f7436$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $edec65eea23f7436$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $edec65eea23f7436$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $edec65eea23f7436$var$_toPropertyKey(arg) {
    var key = $edec65eea23f7436$var$_toPrimitive(arg, "string");
    return $edec65eea23f7436$var$_typeof(key) === "symbol" ? key : String(key);
}
function $edec65eea23f7436$var$_toPrimitive(input, hint) {
    if ($edec65eea23f7436$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($edec65eea23f7436$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $edec65eea23f7436$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $gEEAX = parcelRequire("gEEAX");
var $edec65eea23f7436$var$_require$codes = $gEEAX.codes, $edec65eea23f7436$var$ERR_AMBIGUOUS_ARGUMENT = $edec65eea23f7436$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $edec65eea23f7436$var$ERR_INVALID_ARG_TYPE = $edec65eea23f7436$var$_require$codes.ERR_INVALID_ARG_TYPE, $edec65eea23f7436$var$ERR_INVALID_ARG_VALUE = $edec65eea23f7436$var$_require$codes.ERR_INVALID_ARG_VALUE, $edec65eea23f7436$var$ERR_INVALID_RETURN_VALUE = $edec65eea23f7436$var$_require$codes.ERR_INVALID_RETURN_VALUE, $edec65eea23f7436$var$ERR_MISSING_ARGS = $edec65eea23f7436$var$_require$codes.ERR_MISSING_ARGS;

var $chzjj = parcelRequire("chzjj");

var $5kn9E = parcelRequire("5kn9E");
var $edec65eea23f7436$var$inspect = $5kn9E.inspect;

var $5kn9E = parcelRequire("5kn9E");
var $edec65eea23f7436$require$_require$types = $5kn9E.types;
var $edec65eea23f7436$var$isPromise = $edec65eea23f7436$require$_require$types.isPromise, $edec65eea23f7436$var$isRegExp = $edec65eea23f7436$require$_require$types.isRegExp;

var $edec65eea23f7436$var$objectAssign = (parcelRequire("kRgO8"))();

var $edec65eea23f7436$var$objectIs = (parcelRequire("jinRP"))();

var $edec65eea23f7436$var$RegExpPrototypeTest = (parcelRequire("azkfu"))('RegExp.prototype.test');
var $edec65eea23f7436$var$errorCache = new Map();
var $edec65eea23f7436$var$isDeepEqual;
var $edec65eea23f7436$var$isDeepStrictEqual;
var $edec65eea23f7436$var$parseExpressionAt;
var $edec65eea23f7436$var$findNodeAround;
var $edec65eea23f7436$var$decoder;

function $edec65eea23f7436$var$lazyLoadComparison() {
    var comparison = (parcelRequire("ISv13"));
    $edec65eea23f7436$var$isDeepEqual = comparison.isDeepEqual;
    $edec65eea23f7436$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $edec65eea23f7436$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $edec65eea23f7436$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $edec65eea23f7436$var$escapeFn = function escapeFn(str) {
    return $edec65eea23f7436$var$meta[str.charCodeAt(0)];
};
var $edec65eea23f7436$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $edec65eea23f7436$var$assert = module.exports = $edec65eea23f7436$var$ok;
var $edec65eea23f7436$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $edec65eea23f7436$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $chzjj(obj);
}
function $edec65eea23f7436$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($edec65eea23f7436$var$warned === false) {
            $edec65eea23f7436$var$warned = true;
            var warn = $4eGW1.emitWarning ? $4eGW1.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $edec65eea23f7436$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $chzjj(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$edec65eea23f7436$var$assert.fail = $edec65eea23f7436$var$fail;
// The AssertionError is defined in internal/error.
$edec65eea23f7436$var$assert.AssertionError = $chzjj;
function $edec65eea23f7436$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $chzjj({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $edec65eea23f7436$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $edec65eea23f7436$var$innerOk.apply(void 0, [
        $edec65eea23f7436$var$ok,
        args.length
    ].concat(args));
}
$edec65eea23f7436$var$assert.ok = $edec65eea23f7436$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $edec65eea23f7436$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $edec65eea23f7436$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $edec65eea23f7436$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$edec65eea23f7436$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $edec65eea23f7436$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $edec65eea23f7436$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$edec65eea23f7436$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $edec65eea23f7436$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($edec65eea23f7436$var$isDeepEqual === undefined) $edec65eea23f7436$var$lazyLoadComparison();
    if (!$edec65eea23f7436$var$isDeepEqual(actual, expected)) $edec65eea23f7436$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$edec65eea23f7436$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $edec65eea23f7436$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($edec65eea23f7436$var$isDeepEqual === undefined) $edec65eea23f7436$var$lazyLoadComparison();
    if ($edec65eea23f7436$var$isDeepEqual(actual, expected)) $edec65eea23f7436$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $edec65eea23f7436$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $edec65eea23f7436$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($edec65eea23f7436$var$isDeepEqual === undefined) $edec65eea23f7436$var$lazyLoadComparison();
    if (!$edec65eea23f7436$var$isDeepStrictEqual(actual, expected)) $edec65eea23f7436$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$edec65eea23f7436$var$assert.notDeepStrictEqual = $edec65eea23f7436$var$notDeepStrictEqual;
function $edec65eea23f7436$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $edec65eea23f7436$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($edec65eea23f7436$var$isDeepEqual === undefined) $edec65eea23f7436$var$lazyLoadComparison();
    if ($edec65eea23f7436$var$isDeepStrictEqual(actual, expected)) $edec65eea23f7436$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $edec65eea23f7436$var$notDeepStrictEqual
    });
}
$edec65eea23f7436$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $edec65eea23f7436$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$edec65eea23f7436$var$objectIs(actual, expected)) $edec65eea23f7436$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$edec65eea23f7436$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $edec65eea23f7436$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($edec65eea23f7436$var$objectIs(actual, expected)) $edec65eea23f7436$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $edec65eea23f7436$var$Comparison = /*#__PURE__*/ $edec65eea23f7436$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $edec65eea23f7436$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $edec65eea23f7436$var$isRegExp(obj[key]) && $edec65eea23f7436$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $edec65eea23f7436$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$edec65eea23f7436$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $edec65eea23f7436$var$Comparison(actual, keys);
            var b = new $edec65eea23f7436$var$Comparison(expected, keys, actual);
            var err = new $chzjj({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $edec65eea23f7436$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $edec65eea23f7436$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($edec65eea23f7436$var$isRegExp(expected)) return $edec65eea23f7436$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $edec65eea23f7436$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($edec65eea23f7436$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $chzjj({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $edec65eea23f7436$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($edec65eea23f7436$var$isDeepEqual === undefined) $edec65eea23f7436$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $edec65eea23f7436$var$isRegExp(expected[key]) && $edec65eea23f7436$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $edec65eea23f7436$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $edec65eea23f7436$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $edec65eea23f7436$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $edec65eea23f7436$var$NO_EXCEPTION_SENTINEL;
}
function $edec65eea23f7436$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $edec65eea23f7436$var$isPromise(obj) || obj !== null && $edec65eea23f7436$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $edec65eea23f7436$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$edec65eea23f7436$var$checkIsPromise(resultPromise)) throw new $edec65eea23f7436$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($edec65eea23f7436$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $edec65eea23f7436$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $edec65eea23f7436$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $edec65eea23f7436$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $edec65eea23f7436$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($edec65eea23f7436$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $edec65eea23f7436$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $edec65eea23f7436$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $edec65eea23f7436$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $edec65eea23f7436$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $edec65eea23f7436$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $edec65eea23f7436$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$edec65eea23f7436$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $edec65eea23f7436$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $edec65eea23f7436$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $edec65eea23f7436$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $edec65eea23f7436$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$edec65eea23f7436$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $edec65eea23f7436$var$expectsError.apply(void 0, [
        throws,
        $edec65eea23f7436$var$getActual(promiseFn)
    ].concat(args));
};
$edec65eea23f7436$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $edec65eea23f7436$var$waitForActual(promiseFn).then(function(result) {
        return $edec65eea23f7436$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$edec65eea23f7436$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $edec65eea23f7436$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $edec65eea23f7436$var$getActual(fn)
    ].concat(args));
};
$edec65eea23f7436$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $edec65eea23f7436$var$waitForActual(fn).then(function(result) {
        return $edec65eea23f7436$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$edec65eea23f7436$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($edec65eea23f7436$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $edec65eea23f7436$var$inspect(err);
        var newErr = new $chzjj({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $edec65eea23f7436$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$edec65eea23f7436$var$isRegExp(regexp)) throw new $edec65eea23f7436$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $edec65eea23f7436$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($edec65eea23f7436$var$_typeof(string), " (").concat($edec65eea23f7436$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($edec65eea23f7436$var$inspect(regexp), ". Input:\n\n").concat($edec65eea23f7436$var$inspect(string), "\n"));
        var err = new $chzjj({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$edec65eea23f7436$var$assert.match = function match(string, regexp, message) {
    $edec65eea23f7436$var$internalMatch(string, regexp, message, match, 'match');
};
$edec65eea23f7436$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $edec65eea23f7436$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $edec65eea23f7436$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $edec65eea23f7436$var$innerOk.apply(void 0, [
        $edec65eea23f7436$var$strict,
        args.length
    ].concat(args));
}
$edec65eea23f7436$var$assert.strict = $edec65eea23f7436$var$objectAssign($edec65eea23f7436$var$strict, $edec65eea23f7436$var$assert, {
    equal: $edec65eea23f7436$var$assert.strictEqual,
    deepEqual: $edec65eea23f7436$var$assert.deepStrictEqual,
    notEqual: $edec65eea23f7436$var$assert.notStrictEqual,
    notDeepEqual: $edec65eea23f7436$var$assert.notDeepStrictEqual
});
$edec65eea23f7436$var$assert.strict.strict = $edec65eea23f7436$var$assert.strict;

});
parcelRegister("gEEAX", function(module, exports) {
$parcel$export(module.exports, "codes", () => $c1ffdf21a42ec016$export$e45cb6485273080e, (v) => $c1ffdf21a42ec016$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $c1ffdf21a42ec016$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $c1ffdf21a42ec016$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c1ffdf21a42ec016$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c1ffdf21a42ec016$var$_typeof(o);
}
function $c1ffdf21a42ec016$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c1ffdf21a42ec016$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c1ffdf21a42ec016$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c1ffdf21a42ec016$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c1ffdf21a42ec016$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c1ffdf21a42ec016$var$_toPropertyKey(arg) {
    var key = $c1ffdf21a42ec016$var$_toPrimitive(arg, "string");
    return $c1ffdf21a42ec016$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c1ffdf21a42ec016$var$_toPrimitive(input, hint) {
    if ($c1ffdf21a42ec016$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c1ffdf21a42ec016$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c1ffdf21a42ec016$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c1ffdf21a42ec016$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c1ffdf21a42ec016$var$_setPrototypeOf(subClass, superClass);
}
function $c1ffdf21a42ec016$var$_setPrototypeOf(o, p) {
    $c1ffdf21a42ec016$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c1ffdf21a42ec016$var$_setPrototypeOf(o, p);
}
function $c1ffdf21a42ec016$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c1ffdf21a42ec016$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c1ffdf21a42ec016$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c1ffdf21a42ec016$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c1ffdf21a42ec016$var$_possibleConstructorReturn(this, result);
    };
}
function $c1ffdf21a42ec016$var$_possibleConstructorReturn(self, call) {
    if (call && ($c1ffdf21a42ec016$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c1ffdf21a42ec016$var$_assertThisInitialized(self);
}
function $c1ffdf21a42ec016$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c1ffdf21a42ec016$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c1ffdf21a42ec016$var$_getPrototypeOf(o) {
    $c1ffdf21a42ec016$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c1ffdf21a42ec016$var$_getPrototypeOf(o);
}
var $c1ffdf21a42ec016$var$codes = {};
// Lazy loaded
var $c1ffdf21a42ec016$var$assert;
var $c1ffdf21a42ec016$var$util;
function $c1ffdf21a42ec016$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $c1ffdf21a42ec016$var$_inherits(NodeError, _Base);
        var _super = $c1ffdf21a42ec016$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $c1ffdf21a42ec016$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $c1ffdf21a42ec016$var$_createClass(NodeError);
    }(Base);
    $c1ffdf21a42ec016$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $c1ffdf21a42ec016$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $c1ffdf21a42ec016$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $c1ffdf21a42ec016$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $c1ffdf21a42ec016$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$c1ffdf21a42ec016$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$c1ffdf21a42ec016$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($c1ffdf21a42ec016$var$assert === undefined) $c1ffdf21a42ec016$var$assert = (parcelRequire("kqszs"));
    $c1ffdf21a42ec016$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $c1ffdf21a42ec016$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($c1ffdf21a42ec016$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($c1ffdf21a42ec016$var$oneOf(expected, 'type'));
    else {
        var type = $c1ffdf21a42ec016$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($c1ffdf21a42ec016$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($c1ffdf21a42ec016$var$_typeof(actual));
    return msg;
}, TypeError);

$c1ffdf21a42ec016$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($c1ffdf21a42ec016$var$util === undefined) $c1ffdf21a42ec016$var$util = (parcelRequire("5kn9E"));
    var inspected = $c1ffdf21a42ec016$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$c1ffdf21a42ec016$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($c1ffdf21a42ec016$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$c1ffdf21a42ec016$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($c1ffdf21a42ec016$var$assert === undefined) $c1ffdf21a42ec016$var$assert = (parcelRequire("kqszs"));
    $c1ffdf21a42ec016$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$c1ffdf21a42ec016$export$e45cb6485273080e = $c1ffdf21a42ec016$var$codes;

});
parcelRegister("5kn9E", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4eGW1 = parcelRequire("4eGW1");
var $3e10c805c6cf24eb$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $3e10c805c6cf24eb$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$3e10c805c6cf24eb$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($3e10c805c6cf24eb$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($3e10c805c6cf24eb$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($3e10c805c6cf24eb$var$isNull(x) || !$3e10c805c6cf24eb$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $3e10c805c6cf24eb$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $4eGW1 !== 'undefined' && $4eGW1.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $4eGW1 === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($4eGW1.throwDeprecation) throw new Error(msg);
            else if ($4eGW1.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $3e10c805c6cf24eb$var$debugs = {};
var $3e10c805c6cf24eb$var$debugEnvRegex = /^$/;
var $3e10c805c6cf24eb$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$3e10c805c6cf24eb$var$debugs[set]) {
        if ($3e10c805c6cf24eb$var$debugEnvRegex.test(set)) {
            var pid = $4eGW1.pid;
            $3e10c805c6cf24eb$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $3e10c805c6cf24eb$var$debugs[set] = function() {};
    }
    return $3e10c805c6cf24eb$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $3e10c805c6cf24eb$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $3e10c805c6cf24eb$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($3e10c805c6cf24eb$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($3e10c805c6cf24eb$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($3e10c805c6cf24eb$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($3e10c805c6cf24eb$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($3e10c805c6cf24eb$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $3e10c805c6cf24eb$var$stylizeWithColor;
    return $3e10c805c6cf24eb$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $3e10c805c6cf24eb$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$3e10c805c6cf24eb$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$3e10c805c6cf24eb$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $3e10c805c6cf24eb$var$stylizeWithColor(str, styleType) {
    var style = $3e10c805c6cf24eb$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $3e10c805c6cf24eb$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $3e10c805c6cf24eb$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $3e10c805c6cf24eb$var$stylizeNoColor(str, styleType) {
    return str;
}
function $3e10c805c6cf24eb$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $3e10c805c6cf24eb$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $3e10c805c6cf24eb$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$3e10c805c6cf24eb$var$isString(ret)) ret = $3e10c805c6cf24eb$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $3e10c805c6cf24eb$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $3e10c805c6cf24eb$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($3e10c805c6cf24eb$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $3e10c805c6cf24eb$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($3e10c805c6cf24eb$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($3e10c805c6cf24eb$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($3e10c805c6cf24eb$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($3e10c805c6cf24eb$var$isError(value)) return $3e10c805c6cf24eb$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($3e10c805c6cf24eb$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($3e10c805c6cf24eb$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($3e10c805c6cf24eb$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($3e10c805c6cf24eb$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($3e10c805c6cf24eb$var$isError(value)) base = ' ' + $3e10c805c6cf24eb$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($3e10c805c6cf24eb$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $3e10c805c6cf24eb$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $3e10c805c6cf24eb$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $3e10c805c6cf24eb$var$reduceToSingleString(output, base, braces);
}
function $3e10c805c6cf24eb$var$formatPrimitive(ctx, value) {
    if ($3e10c805c6cf24eb$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($3e10c805c6cf24eb$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($3e10c805c6cf24eb$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($3e10c805c6cf24eb$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($3e10c805c6cf24eb$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $3e10c805c6cf24eb$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $3e10c805c6cf24eb$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($3e10c805c6cf24eb$var$hasOwnProperty(value, String(i))) output.push($3e10c805c6cf24eb$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($3e10c805c6cf24eb$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $3e10c805c6cf24eb$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$3e10c805c6cf24eb$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($3e10c805c6cf24eb$var$isNull(recurseTimes)) str = $3e10c805c6cf24eb$var$formatValue(ctx, desc.value, null);
            else str = $3e10c805c6cf24eb$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($3e10c805c6cf24eb$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $3e10c805c6cf24eb$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("aEADY"));
function $3e10c805c6cf24eb$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $3e10c805c6cf24eb$var$isArray;
function $3e10c805c6cf24eb$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $3e10c805c6cf24eb$var$isBoolean;
function $3e10c805c6cf24eb$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $3e10c805c6cf24eb$var$isNull;
function $3e10c805c6cf24eb$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $3e10c805c6cf24eb$var$isNullOrUndefined;
function $3e10c805c6cf24eb$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $3e10c805c6cf24eb$var$isNumber;
function $3e10c805c6cf24eb$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $3e10c805c6cf24eb$var$isString;
function $3e10c805c6cf24eb$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $3e10c805c6cf24eb$var$isSymbol;
function $3e10c805c6cf24eb$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $3e10c805c6cf24eb$var$isUndefined;
function $3e10c805c6cf24eb$var$isRegExp(re) {
    return $3e10c805c6cf24eb$var$isObject(re) && $3e10c805c6cf24eb$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $3e10c805c6cf24eb$var$isRegExp;
module.exports.types.isRegExp = $3e10c805c6cf24eb$var$isRegExp;
function $3e10c805c6cf24eb$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $3e10c805c6cf24eb$var$isObject;
function $3e10c805c6cf24eb$var$isDate(d) {
    return $3e10c805c6cf24eb$var$isObject(d) && $3e10c805c6cf24eb$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $3e10c805c6cf24eb$var$isDate;
module.exports.types.isDate = $3e10c805c6cf24eb$var$isDate;
function $3e10c805c6cf24eb$var$isError(e) {
    return $3e10c805c6cf24eb$var$isObject(e) && ($3e10c805c6cf24eb$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $3e10c805c6cf24eb$var$isError;
module.exports.types.isNativeError = $3e10c805c6cf24eb$var$isError;
function $3e10c805c6cf24eb$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $3e10c805c6cf24eb$var$isFunction;
function $3e10c805c6cf24eb$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $3e10c805c6cf24eb$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("q3HAS"));
function $3e10c805c6cf24eb$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $3e10c805c6cf24eb$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $3e10c805c6cf24eb$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $3e10c805c6cf24eb$var$timestamp() {
    var d = new Date();
    var time = [
        $3e10c805c6cf24eb$var$pad(d.getHours()),
        $3e10c805c6cf24eb$var$pad(d.getMinutes()),
        $3e10c805c6cf24eb$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $3e10c805c6cf24eb$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $3e10c805c6cf24eb$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("hhO5F"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$3e10c805c6cf24eb$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $3e10c805c6cf24eb$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $3e10c805c6cf24eb$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($3e10c805c6cf24eb$var$kCustomPromisifiedSymbol && original[$3e10c805c6cf24eb$var$kCustomPromisifiedSymbol]) {
        var fn = original[$3e10c805c6cf24eb$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $3e10c805c6cf24eb$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($3e10c805c6cf24eb$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $3e10c805c6cf24eb$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $3e10c805c6cf24eb$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $3e10c805c6cf24eb$var$kCustomPromisifiedSymbol;
function $3e10c805c6cf24eb$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $3e10c805c6cf24eb$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $4eGW1.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $4eGW1.nextTick($3e10c805c6cf24eb$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $3e10c805c6cf24eb$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $3e10c805c6cf24eb$var$callbackify;

});
parcelRegister("aEADY", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $jiTf3 = parcelRequire("jiTf3");

var $8BZoV = parcelRequire("8BZoV");

var $jRIll = parcelRequire("jRIll");

var $3rI5v = parcelRequire("3rI5v");
function $02006b9f088b7477$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $02006b9f088b7477$var$BigIntSupported = typeof BigInt !== 'undefined';
var $02006b9f088b7477$var$SymbolSupported = typeof Symbol !== 'undefined';
var $02006b9f088b7477$var$ObjectToString = $02006b9f088b7477$var$uncurryThis(Object.prototype.toString);
var $02006b9f088b7477$var$numberValue = $02006b9f088b7477$var$uncurryThis(Number.prototype.valueOf);
var $02006b9f088b7477$var$stringValue = $02006b9f088b7477$var$uncurryThis(String.prototype.valueOf);
var $02006b9f088b7477$var$booleanValue = $02006b9f088b7477$var$uncurryThis(Boolean.prototype.valueOf);
if ($02006b9f088b7477$var$BigIntSupported) var $02006b9f088b7477$var$bigIntValue = $02006b9f088b7477$var$uncurryThis(BigInt.prototype.valueOf);
if ($02006b9f088b7477$var$SymbolSupported) var $02006b9f088b7477$var$symbolValue = $02006b9f088b7477$var$uncurryThis(Symbol.prototype.valueOf);
function $02006b9f088b7477$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $jiTf3;
module.exports.isGeneratorFunction = $8BZoV;
module.exports.isTypedArray = $3rI5v;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $02006b9f088b7477$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $02006b9f088b7477$var$isPromise;
function $02006b9f088b7477$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $3rI5v(value) || $02006b9f088b7477$var$isDataView(value);
}
module.exports.isArrayBufferView = $02006b9f088b7477$var$isArrayBufferView;
function $02006b9f088b7477$var$isUint8Array(value) {
    return $jRIll(value) === 'Uint8Array';
}
module.exports.isUint8Array = $02006b9f088b7477$var$isUint8Array;
function $02006b9f088b7477$var$isUint8ClampedArray(value) {
    return $jRIll(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $02006b9f088b7477$var$isUint8ClampedArray;
function $02006b9f088b7477$var$isUint16Array(value) {
    return $jRIll(value) === 'Uint16Array';
}
module.exports.isUint16Array = $02006b9f088b7477$var$isUint16Array;
function $02006b9f088b7477$var$isUint32Array(value) {
    return $jRIll(value) === 'Uint32Array';
}
module.exports.isUint32Array = $02006b9f088b7477$var$isUint32Array;
function $02006b9f088b7477$var$isInt8Array(value) {
    return $jRIll(value) === 'Int8Array';
}
module.exports.isInt8Array = $02006b9f088b7477$var$isInt8Array;
function $02006b9f088b7477$var$isInt16Array(value) {
    return $jRIll(value) === 'Int16Array';
}
module.exports.isInt16Array = $02006b9f088b7477$var$isInt16Array;
function $02006b9f088b7477$var$isInt32Array(value) {
    return $jRIll(value) === 'Int32Array';
}
module.exports.isInt32Array = $02006b9f088b7477$var$isInt32Array;
function $02006b9f088b7477$var$isFloat32Array(value) {
    return $jRIll(value) === 'Float32Array';
}
module.exports.isFloat32Array = $02006b9f088b7477$var$isFloat32Array;
function $02006b9f088b7477$var$isFloat64Array(value) {
    return $jRIll(value) === 'Float64Array';
}
module.exports.isFloat64Array = $02006b9f088b7477$var$isFloat64Array;
function $02006b9f088b7477$var$isBigInt64Array(value) {
    return $jRIll(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $02006b9f088b7477$var$isBigInt64Array;
function $02006b9f088b7477$var$isBigUint64Array(value) {
    return $jRIll(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $02006b9f088b7477$var$isBigUint64Array;
function $02006b9f088b7477$var$isMapToString(value) {
    return $02006b9f088b7477$var$ObjectToString(value) === '[object Map]';
}
$02006b9f088b7477$var$isMapToString.working = typeof Map !== 'undefined' && $02006b9f088b7477$var$isMapToString(new Map());
function $02006b9f088b7477$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $02006b9f088b7477$var$isMapToString.working ? $02006b9f088b7477$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $02006b9f088b7477$var$isMap;
function $02006b9f088b7477$var$isSetToString(value) {
    return $02006b9f088b7477$var$ObjectToString(value) === '[object Set]';
}
$02006b9f088b7477$var$isSetToString.working = typeof Set !== 'undefined' && $02006b9f088b7477$var$isSetToString(new Set());
function $02006b9f088b7477$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $02006b9f088b7477$var$isSetToString.working ? $02006b9f088b7477$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $02006b9f088b7477$var$isSet;
function $02006b9f088b7477$var$isWeakMapToString(value) {
    return $02006b9f088b7477$var$ObjectToString(value) === '[object WeakMap]';
}
$02006b9f088b7477$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $02006b9f088b7477$var$isWeakMapToString(new WeakMap());
function $02006b9f088b7477$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $02006b9f088b7477$var$isWeakMapToString.working ? $02006b9f088b7477$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $02006b9f088b7477$var$isWeakMap;
function $02006b9f088b7477$var$isWeakSetToString(value) {
    return $02006b9f088b7477$var$ObjectToString(value) === '[object WeakSet]';
}
$02006b9f088b7477$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $02006b9f088b7477$var$isWeakSetToString(new WeakSet());
function $02006b9f088b7477$var$isWeakSet(value) {
    return $02006b9f088b7477$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $02006b9f088b7477$var$isWeakSet;
function $02006b9f088b7477$var$isArrayBufferToString(value) {
    return $02006b9f088b7477$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$02006b9f088b7477$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $02006b9f088b7477$var$isArrayBufferToString(new ArrayBuffer());
function $02006b9f088b7477$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $02006b9f088b7477$var$isArrayBufferToString.working ? $02006b9f088b7477$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $02006b9f088b7477$var$isArrayBuffer;
function $02006b9f088b7477$var$isDataViewToString(value) {
    return $02006b9f088b7477$var$ObjectToString(value) === '[object DataView]';
}
$02006b9f088b7477$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $02006b9f088b7477$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $02006b9f088b7477$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $02006b9f088b7477$var$isDataViewToString.working ? $02006b9f088b7477$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $02006b9f088b7477$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $02006b9f088b7477$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $02006b9f088b7477$var$isSharedArrayBufferToString(value) {
    return $02006b9f088b7477$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $02006b9f088b7477$var$isSharedArrayBuffer(value) {
    if (typeof $02006b9f088b7477$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $02006b9f088b7477$var$isSharedArrayBufferToString.working === 'undefined') $02006b9f088b7477$var$isSharedArrayBufferToString.working = $02006b9f088b7477$var$isSharedArrayBufferToString(new $02006b9f088b7477$var$SharedArrayBufferCopy());
    return $02006b9f088b7477$var$isSharedArrayBufferToString.working ? $02006b9f088b7477$var$isSharedArrayBufferToString(value) : value instanceof $02006b9f088b7477$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $02006b9f088b7477$var$isSharedArrayBuffer;
function $02006b9f088b7477$var$isAsyncFunction(value) {
    return $02006b9f088b7477$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $02006b9f088b7477$var$isAsyncFunction;
function $02006b9f088b7477$var$isMapIterator(value) {
    return $02006b9f088b7477$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $02006b9f088b7477$var$isMapIterator;
function $02006b9f088b7477$var$isSetIterator(value) {
    return $02006b9f088b7477$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $02006b9f088b7477$var$isSetIterator;
function $02006b9f088b7477$var$isGeneratorObject(value) {
    return $02006b9f088b7477$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $02006b9f088b7477$var$isGeneratorObject;
function $02006b9f088b7477$var$isWebAssemblyCompiledModule(value) {
    return $02006b9f088b7477$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $02006b9f088b7477$var$isWebAssemblyCompiledModule;
function $02006b9f088b7477$var$isNumberObject(value) {
    return $02006b9f088b7477$var$checkBoxedPrimitive(value, $02006b9f088b7477$var$numberValue);
}
module.exports.isNumberObject = $02006b9f088b7477$var$isNumberObject;
function $02006b9f088b7477$var$isStringObject(value) {
    return $02006b9f088b7477$var$checkBoxedPrimitive(value, $02006b9f088b7477$var$stringValue);
}
module.exports.isStringObject = $02006b9f088b7477$var$isStringObject;
function $02006b9f088b7477$var$isBooleanObject(value) {
    return $02006b9f088b7477$var$checkBoxedPrimitive(value, $02006b9f088b7477$var$booleanValue);
}
module.exports.isBooleanObject = $02006b9f088b7477$var$isBooleanObject;
function $02006b9f088b7477$var$isBigIntObject(value) {
    return $02006b9f088b7477$var$BigIntSupported && $02006b9f088b7477$var$checkBoxedPrimitive(value, $02006b9f088b7477$var$bigIntValue);
}
module.exports.isBigIntObject = $02006b9f088b7477$var$isBigIntObject;
function $02006b9f088b7477$var$isSymbolObject(value) {
    return $02006b9f088b7477$var$SymbolSupported && $02006b9f088b7477$var$checkBoxedPrimitive(value, $02006b9f088b7477$var$symbolValue);
}
module.exports.isSymbolObject = $02006b9f088b7477$var$isSymbolObject;
function $02006b9f088b7477$var$isBoxedPrimitive(value) {
    return $02006b9f088b7477$var$isNumberObject(value) || $02006b9f088b7477$var$isStringObject(value) || $02006b9f088b7477$var$isBooleanObject(value) || $02006b9f088b7477$var$isBigIntObject(value) || $02006b9f088b7477$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $02006b9f088b7477$var$isBoxedPrimitive;
function $02006b9f088b7477$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($02006b9f088b7477$var$isArrayBuffer(value) || $02006b9f088b7477$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $02006b9f088b7477$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("jiTf3", function(module, exports) {
'use strict';

var $e0da8ca06f8b9420$var$hasToStringTag = (parcelRequire("iL8BG"))();

var $azkfu = parcelRequire("azkfu");
var $e0da8ca06f8b9420$var$$toString = $azkfu('Object.prototype.toString');
var $e0da8ca06f8b9420$var$isStandardArguments = function isArguments(value) {
    if ($e0da8ca06f8b9420$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $e0da8ca06f8b9420$var$$toString(value) === '[object Arguments]';
};
var $e0da8ca06f8b9420$var$isLegacyArguments = function isArguments(value) {
    if ($e0da8ca06f8b9420$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $e0da8ca06f8b9420$var$$toString(value) !== '[object Array]' && $e0da8ca06f8b9420$var$$toString(value.callee) === '[object Function]';
};
var $e0da8ca06f8b9420$var$supportsStandardArguments = function() {
    return $e0da8ca06f8b9420$var$isStandardArguments(arguments);
}();
$e0da8ca06f8b9420$var$isStandardArguments.isLegacyArguments = $e0da8ca06f8b9420$var$isLegacyArguments; // for tests
module.exports = $e0da8ca06f8b9420$var$supportsStandardArguments ? $e0da8ca06f8b9420$var$isStandardArguments : $e0da8ca06f8b9420$var$isLegacyArguments;

});
parcelRegister("azkfu", function(module, exports) {
'use strict';

var $c9Gut = parcelRequire("c9Gut");

var $iBdXg = parcelRequire("iBdXg");
var $7b1ce145d7c6cd8e$var$$indexOf = $iBdXg($c9Gut('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $c9Gut(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $7b1ce145d7c6cd8e$var$$indexOf(name, '.prototype.') > -1) return $iBdXg(intrinsic);
    return intrinsic;
};

});


parcelRegister("8BZoV", function(module, exports) {
'use strict';
var $6451686451a16c20$var$toStr = Object.prototype.toString;
var $6451686451a16c20$var$fnToStr = Function.prototype.toString;
var $6451686451a16c20$var$isFnRegex = /^\s*(?:function)?\*/;

var $6451686451a16c20$var$hasToStringTag = (parcelRequire("iL8BG"))();
var $6451686451a16c20$var$getProto = Object.getPrototypeOf;
var $6451686451a16c20$var$getGeneratorFunc = function() {
    if (!$6451686451a16c20$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
var $6451686451a16c20$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($6451686451a16c20$var$isFnRegex.test($6451686451a16c20$var$fnToStr.call(fn))) return true;
    if (!$6451686451a16c20$var$hasToStringTag) {
        var str = $6451686451a16c20$var$toStr.call(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$6451686451a16c20$var$getProto) return false;
    if (typeof $6451686451a16c20$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $6451686451a16c20$var$getGeneratorFunc();
        $6451686451a16c20$var$GeneratorFunction = generatorFunc ? $6451686451a16c20$var$getProto(generatorFunc) : false;
    }
    return $6451686451a16c20$var$getProto(fn) === $6451686451a16c20$var$GeneratorFunction;
};

});


parcelRegister("q3HAS", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});



parcelRegister("chzjj", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $4eGW1 = parcelRequire("4eGW1");
'use strict';
function $8f1276782eab4044$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8f1276782eab4044$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8f1276782eab4044$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8f1276782eab4044$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8f1276782eab4044$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8f1276782eab4044$var$_defineProperty(obj, key, value) {
    key = $8f1276782eab4044$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8f1276782eab4044$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8f1276782eab4044$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $8f1276782eab4044$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $8f1276782eab4044$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8f1276782eab4044$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8f1276782eab4044$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $8f1276782eab4044$var$_toPropertyKey(arg) {
    var key = $8f1276782eab4044$var$_toPrimitive(arg, "string");
    return $8f1276782eab4044$var$_typeof(key) === "symbol" ? key : String(key);
}
function $8f1276782eab4044$var$_toPrimitive(input, hint) {
    if ($8f1276782eab4044$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($8f1276782eab4044$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $8f1276782eab4044$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $8f1276782eab4044$var$_setPrototypeOf(subClass, superClass);
}
function $8f1276782eab4044$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8f1276782eab4044$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $8f1276782eab4044$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $8f1276782eab4044$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $8f1276782eab4044$var$_possibleConstructorReturn(this, result);
    };
}
function $8f1276782eab4044$var$_possibleConstructorReturn(self, call) {
    if (call && ($8f1276782eab4044$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $8f1276782eab4044$var$_assertThisInitialized(self);
}
function $8f1276782eab4044$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $8f1276782eab4044$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $8f1276782eab4044$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$8f1276782eab4044$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $8f1276782eab4044$var$_construct(Class, arguments, $8f1276782eab4044$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $8f1276782eab4044$var$_setPrototypeOf(Wrapper, Class);
    };
    return $8f1276782eab4044$var$_wrapNativeSuper(Class);
}
function $8f1276782eab4044$var$_construct(Parent, args, Class) {
    if ($8f1276782eab4044$var$_isNativeReflectConstruct()) $8f1276782eab4044$var$_construct = Reflect.construct.bind();
    else $8f1276782eab4044$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $8f1276782eab4044$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $8f1276782eab4044$var$_construct.apply(null, arguments);
}
function $8f1276782eab4044$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $8f1276782eab4044$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $8f1276782eab4044$var$_setPrototypeOf(o, p) {
    $8f1276782eab4044$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $8f1276782eab4044$var$_setPrototypeOf(o, p);
}
function $8f1276782eab4044$var$_getPrototypeOf(o) {
    $8f1276782eab4044$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8f1276782eab4044$var$_getPrototypeOf(o);
}
function $8f1276782eab4044$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8f1276782eab4044$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8f1276782eab4044$var$_typeof(o);
}

var $5kn9E = parcelRequire("5kn9E");
var $8f1276782eab4044$var$inspect = $5kn9E.inspect;

var $gEEAX = parcelRequire("gEEAX");
var $8f1276782eab4044$var$ERR_INVALID_ARG_TYPE = $gEEAX.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $8f1276782eab4044$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $8f1276782eab4044$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $8f1276782eab4044$var$blue = '';
var $8f1276782eab4044$var$green = '';
var $8f1276782eab4044$var$red = '';
var $8f1276782eab4044$var$white = '';
var $8f1276782eab4044$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $8f1276782eab4044$var$kMaxShortLength = 10;
function $8f1276782eab4044$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $8f1276782eab4044$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $8f1276782eab4044$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $8f1276782eab4044$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $8f1276782eab4044$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $8f1276782eab4044$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $8f1276782eab4044$var$_typeof(actual) === 'object' && $8f1276782eab4044$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $8f1276782eab4044$var$kMaxShortLength) {
            if (($8f1276782eab4044$var$_typeof(actual) !== 'object' || actual === null) && ($8f1276782eab4044$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($8f1276782eab4044$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $4eGW1.stderr && $4eGW1.stderr.isTTY ? $4eGW1.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($8f1276782eab4044$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($8f1276782eab4044$var$blue, "...").concat($8f1276782eab4044$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($8f1276782eab4044$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($8f1276782eab4044$var$blue, "...").concat($8f1276782eab4044$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $8f1276782eab4044$var$kReadableOperator[operator] + "\n".concat($8f1276782eab4044$var$green, "+ actual").concat($8f1276782eab4044$var$white, " ").concat($8f1276782eab4044$var$red, "- expected").concat($8f1276782eab4044$var$white);
    var skippedMsg = " ".concat($8f1276782eab4044$var$blue, "...").concat($8f1276782eab4044$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($8f1276782eab4044$var$blue, "...").concat($8f1276782eab4044$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($8f1276782eab4044$var$red, "-").concat($8f1276782eab4044$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($8f1276782eab4044$var$blue, "...").concat($8f1276782eab4044$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($8f1276782eab4044$var$green, "+").concat($8f1276782eab4044$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$8f1276782eab4044$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $8f1276782eab4044$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($8f1276782eab4044$var$blue, "...").concat($8f1276782eab4044$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($8f1276782eab4044$var$green, "+").concat($8f1276782eab4044$var$white, " ").concat(actualLine);
                other += "\n".concat($8f1276782eab4044$var$red, "-").concat($8f1276782eab4044$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($8f1276782eab4044$var$blue, "...").concat($8f1276782eab4044$var$white).concat(other, "\n") + "".concat($8f1276782eab4044$var$blue, "...").concat($8f1276782eab4044$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $8f1276782eab4044$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $8f1276782eab4044$var$_inherits(AssertionError, _Error);
    var _super = $8f1276782eab4044$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $8f1276782eab4044$var$_classCallCheck(this, AssertionError);
        if ($8f1276782eab4044$var$_typeof(options) !== 'object' || options === null) throw new $8f1276782eab4044$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($4eGW1.stderr && $4eGW1.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($4eGW1.stderr && $4eGW1.stderr.getColorDepth && $4eGW1.stderr.getColorDepth() !== 1) {
                    $8f1276782eab4044$var$blue = "\x1B[34m";
                    $8f1276782eab4044$var$green = "\x1B[32m";
                    $8f1276782eab4044$var$white = "\x1B[39m";
                    $8f1276782eab4044$var$red = "\x1B[31m";
                } else {
                    $8f1276782eab4044$var$blue = '';
                    $8f1276782eab4044$var$green = '';
                    $8f1276782eab4044$var$white = '';
                    $8f1276782eab4044$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($8f1276782eab4044$var$_typeof(actual) === 'object' && actual !== null && $8f1276782eab4044$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $8f1276782eab4044$var$copyError(actual);
                expected = $8f1276782eab4044$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $8f1276782eab4044$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $8f1276782eab4044$var$kReadableOperator[operator];
                var res = $8f1276782eab4044$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $8f1276782eab4044$var$_typeof(actual) === 'object' && actual !== null) base = $8f1276782eab4044$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($8f1276782eab4044$var$blue, "...").concat($8f1276782eab4044$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $8f1276782eab4044$var$inspectValue(actual);
                var other = '';
                var knownOperators = $8f1276782eab4044$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($8f1276782eab4044$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($8f1276782eab4044$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($8f1276782eab4044$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($8f1276782eab4044$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $8f1276782eab4044$var$_possibleConstructorReturn(_this);
    }
    $8f1276782eab4044$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $8f1276782eab4044$var$inspect(this, $8f1276782eab4044$var$_objectSpread($8f1276782eab4044$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $8f1276782eab4044$var$_wrapNativeSuper(Error), $8f1276782eab4044$var$inspect.custom);
module.exports = $8f1276782eab4044$var$AssertionError;

});

parcelRegister("kRgO8", function(module, exports) {
'use strict';

var $fJN6x = parcelRequire("fJN6x");
var $f2f5cb8a8a22ca56$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $f2f5cb8a8a22ca56$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $fJN6x;
    if ($f2f5cb8a8a22ca56$var$lacksProperEnumerationOrder()) return $fJN6x;
    if ($f2f5cb8a8a22ca56$var$assignHasPendingExceptions()) return $fJN6x;
    return Object.assign;
};

});
parcelRegister("fJN6x", function(module, exports) {
'use strict';

var $lAXvK = parcelRequire("lAXvK");

var $b751261d62c78467$var$hasSymbols = (parcelRequire("ivYev"))();

var $kdnt5 = parcelRequire("kdnt5");

var $5Xb5B = parcelRequire("5Xb5B");
var $b751261d62c78467$var$$push = $kdnt5('Array.prototype.push');
var $b751261d62c78467$var$$propIsEnumerable = $kdnt5('Object.prototype.propertyIsEnumerable');
var $b751261d62c78467$var$originalGetSymbols = $b751261d62c78467$var$hasSymbols ? $5Xb5B.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $5Xb5B(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $5Xb5B(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $lAXvK(from);
        var getSymbols = $b751261d62c78467$var$hasSymbols && ($5Xb5B.getOwnPropertySymbols || $b751261d62c78467$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($b751261d62c78467$var$$propIsEnumerable(from, key)) $b751261d62c78467$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($b751261d62c78467$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("lAXvK", function(module, exports) {
'use strict';
var $fb8b1f6ffcb9c7ed$var$slice = Array.prototype.slice;

var $2Mpmm = parcelRequire("2Mpmm");
var $fb8b1f6ffcb9c7ed$var$origKeys = Object.keys;

var $fb8b1f6ffcb9c7ed$var$keysShim = $fb8b1f6ffcb9c7ed$var$origKeys ? function keys(o) {
    return $fb8b1f6ffcb9c7ed$var$origKeys(o);
} : (parcelRequire("1uUqg"));
var $fb8b1f6ffcb9c7ed$var$originalKeys = Object.keys;
$fb8b1f6ffcb9c7ed$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($2Mpmm(object)) return $fb8b1f6ffcb9c7ed$var$originalKeys($fb8b1f6ffcb9c7ed$var$slice.call(object));
            return $fb8b1f6ffcb9c7ed$var$originalKeys(object);
        };
    } else Object.keys = $fb8b1f6ffcb9c7ed$var$keysShim;
    return Object.keys || $fb8b1f6ffcb9c7ed$var$keysShim;
};
module.exports = $fb8b1f6ffcb9c7ed$var$keysShim;

});
parcelRegister("2Mpmm", function(module, exports) {
'use strict';
var $2063bc625da6a4fc$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $2063bc625da6a4fc$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $2063bc625da6a4fc$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("1uUqg", function(module, exports) {
'use strict';
var $11745c1fb4f13235$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $11745c1fb4f13235$var$has = Object.prototype.hasOwnProperty;
    var $11745c1fb4f13235$var$toStr = Object.prototype.toString;
    var $11745c1fb4f13235$var$isArgs = (parcelRequire("2Mpmm")); // eslint-disable-line global-require
    var $11745c1fb4f13235$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $11745c1fb4f13235$var$hasDontEnumBug = !$11745c1fb4f13235$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $11745c1fb4f13235$var$hasProtoEnumBug = $11745c1fb4f13235$var$isEnumerable.call(function() {}, 'prototype');
    var $11745c1fb4f13235$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $11745c1fb4f13235$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $11745c1fb4f13235$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $11745c1fb4f13235$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$11745c1fb4f13235$var$excludedKeys['$' + k] && $11745c1fb4f13235$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $11745c1fb4f13235$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $11745c1fb4f13235$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$11745c1fb4f13235$var$hasAutomationEqualityBug) return $11745c1fb4f13235$var$equalsConstructorPrototype(o);
        try {
            return $11745c1fb4f13235$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $11745c1fb4f13235$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $11745c1fb4f13235$var$toStr.call(object) === '[object Function]';
        var isArguments = $11745c1fb4f13235$var$isArgs(object);
        var isString = isObject && $11745c1fb4f13235$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $11745c1fb4f13235$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$11745c1fb4f13235$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $11745c1fb4f13235$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($11745c1fb4f13235$var$hasDontEnumBug) {
            var skipConstructor = $11745c1fb4f13235$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $11745c1fb4f13235$var$dontEnums.length; ++k)if (!(skipConstructor && $11745c1fb4f13235$var$dontEnums[k] === 'constructor') && $11745c1fb4f13235$var$has.call(object, $11745c1fb4f13235$var$dontEnums[k])) theKeys.push($11745c1fb4f13235$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $11745c1fb4f13235$var$keysShim;

});




parcelRegister("jinRP", function(module, exports) {
'use strict';

var $48QMu = parcelRequire("48QMu");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $48QMu;
};

});
parcelRegister("48QMu", function(module, exports) {
'use strict';
var $3040d9fecf57432a$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($3040d9fecf57432a$var$numberIsNaN(a) && $3040d9fecf57432a$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("ISv13", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $086e6297be204f45$var$_slicedToArray(arr, i) {
    return $086e6297be204f45$var$_arrayWithHoles(arr) || $086e6297be204f45$var$_iterableToArrayLimit(arr, i) || $086e6297be204f45$var$_unsupportedIterableToArray(arr, i) || $086e6297be204f45$var$_nonIterableRest();
}
function $086e6297be204f45$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $086e6297be204f45$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $086e6297be204f45$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $086e6297be204f45$var$_arrayLikeToArray(o, minLen);
}
function $086e6297be204f45$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $086e6297be204f45$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $086e6297be204f45$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $086e6297be204f45$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $086e6297be204f45$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $086e6297be204f45$var$_typeof(o);
}
var $086e6297be204f45$var$regexFlagsSupported = /a/g.flags !== undefined;
var $086e6297be204f45$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $086e6297be204f45$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $086e6297be204f45$var$objectIs = Object.is ? Object.is : (parcelRequire("agMcO"));
var $086e6297be204f45$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $086e6297be204f45$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("ddWGc"));
function $086e6297be204f45$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $086e6297be204f45$var$hasOwnProperty = $086e6297be204f45$var$uncurryThis(Object.prototype.hasOwnProperty);
var $086e6297be204f45$var$propertyIsEnumerable = $086e6297be204f45$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $086e6297be204f45$var$objectToString = $086e6297be204f45$var$uncurryThis(Object.prototype.toString);

var $5kn9E = parcelRequire("5kn9E");
var $086e6297be204f45$require$_require$types = $5kn9E.types;
var $086e6297be204f45$var$isAnyArrayBuffer = $086e6297be204f45$require$_require$types.isAnyArrayBuffer, $086e6297be204f45$var$isArrayBufferView = $086e6297be204f45$require$_require$types.isArrayBufferView, $086e6297be204f45$var$isDate = $086e6297be204f45$require$_require$types.isDate, $086e6297be204f45$var$isMap = $086e6297be204f45$require$_require$types.isMap, $086e6297be204f45$var$isRegExp = $086e6297be204f45$require$_require$types.isRegExp, $086e6297be204f45$var$isSet = $086e6297be204f45$require$_require$types.isSet, $086e6297be204f45$var$isNativeError = $086e6297be204f45$require$_require$types.isNativeError, $086e6297be204f45$var$isBoxedPrimitive = $086e6297be204f45$require$_require$types.isBoxedPrimitive, $086e6297be204f45$var$isNumberObject = $086e6297be204f45$require$_require$types.isNumberObject, $086e6297be204f45$var$isStringObject = $086e6297be204f45$require$_require$types.isStringObject, $086e6297be204f45$var$isBooleanObject = $086e6297be204f45$require$_require$types.isBooleanObject, $086e6297be204f45$var$isBigIntObject = $086e6297be204f45$require$_require$types.isBigIntObject, $086e6297be204f45$var$isSymbolObject = $086e6297be204f45$require$_require$types.isSymbolObject, $086e6297be204f45$var$isFloat32Array = $086e6297be204f45$require$_require$types.isFloat32Array, $086e6297be204f45$var$isFloat64Array = $086e6297be204f45$require$_require$types.isFloat64Array;
function $086e6297be204f45$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $086e6297be204f45$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($086e6297be204f45$var$isNonIndex).concat($086e6297be204f45$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $086e6297be204f45$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $086e6297be204f45$var$ONLY_ENUMERABLE = undefined;
var $086e6297be204f45$var$kStrict = true;
var $086e6297be204f45$var$kLoose = false;
var $086e6297be204f45$var$kNoIterator = 0;
var $086e6297be204f45$var$kIsArray = 1;
var $086e6297be204f45$var$kIsSet = 2;
var $086e6297be204f45$var$kIsMap = 3;
// Check if they have the same source and flags
function $086e6297be204f45$var$areSimilarRegExps(a, b) {
    return $086e6297be204f45$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $086e6297be204f45$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $086e6297be204f45$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $086e6297be204f45$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $086e6297be204f45$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $086e6297be204f45$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $086e6297be204f45$var$isEqualBoxedPrimitive(val1, val2) {
    if ($086e6297be204f45$var$isNumberObject(val1)) return $086e6297be204f45$var$isNumberObject(val2) && $086e6297be204f45$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($086e6297be204f45$var$isStringObject(val1)) return $086e6297be204f45$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($086e6297be204f45$var$isBooleanObject(val1)) return $086e6297be204f45$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($086e6297be204f45$var$isBigIntObject(val1)) return $086e6297be204f45$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $086e6297be204f45$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $086e6297be204f45$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $086e6297be204f45$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($086e6297be204f45$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $086e6297be204f45$var$numberIsNaN(val1) && $086e6297be204f45$var$numberIsNaN(val2);
        if ($086e6297be204f45$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $086e6297be204f45$var$_typeof(val1) !== 'object') {
            if (val2 === null || $086e6297be204f45$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $086e6297be204f45$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $086e6297be204f45$var$objectToString(val1);
    var val2Tag = $086e6297be204f45$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $086e6297be204f45$var$getOwnNonIndexProperties(val1, $086e6297be204f45$var$ONLY_ENUMERABLE);
        var keys2 = $086e6297be204f45$var$getOwnNonIndexProperties(val2, $086e6297be204f45$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $086e6297be204f45$var$keyCheck(val1, val2, strict, memos, $086e6297be204f45$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$086e6297be204f45$var$isMap(val1) && $086e6297be204f45$var$isMap(val2) || !$086e6297be204f45$var$isSet(val1) && $086e6297be204f45$var$isSet(val2)) return false;
    }
    if ($086e6297be204f45$var$isDate(val1)) {
        if (!$086e6297be204f45$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($086e6297be204f45$var$isRegExp(val1)) {
        if (!$086e6297be204f45$var$isRegExp(val2) || !$086e6297be204f45$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($086e6297be204f45$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($086e6297be204f45$var$isArrayBufferView(val1)) {
        if (!strict && ($086e6297be204f45$var$isFloat32Array(val1) || $086e6297be204f45$var$isFloat64Array(val1))) {
            if (!$086e6297be204f45$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$086e6297be204f45$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $086e6297be204f45$var$getOwnNonIndexProperties(val1, $086e6297be204f45$var$ONLY_ENUMERABLE);
        var _keys2 = $086e6297be204f45$var$getOwnNonIndexProperties(val2, $086e6297be204f45$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $086e6297be204f45$var$keyCheck(val1, val2, strict, memos, $086e6297be204f45$var$kNoIterator, _keys);
    } else if ($086e6297be204f45$var$isSet(val1)) {
        if (!$086e6297be204f45$var$isSet(val2) || val1.size !== val2.size) return false;
        return $086e6297be204f45$var$keyCheck(val1, val2, strict, memos, $086e6297be204f45$var$kIsSet);
    } else if ($086e6297be204f45$var$isMap(val1)) {
        if (!$086e6297be204f45$var$isMap(val2) || val1.size !== val2.size) return false;
        return $086e6297be204f45$var$keyCheck(val1, val2, strict, memos, $086e6297be204f45$var$kIsMap);
    } else if ($086e6297be204f45$var$isAnyArrayBuffer(val1)) {
        if (!$086e6297be204f45$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($086e6297be204f45$var$isBoxedPrimitive(val1) && !$086e6297be204f45$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $086e6297be204f45$var$keyCheck(val1, val2, strict, memos, $086e6297be204f45$var$kNoIterator);
}
function $086e6297be204f45$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $086e6297be204f45$var$propertyIsEnumerable(val, k);
    });
}
function $086e6297be204f45$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$086e6297be204f45$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $086e6297be204f45$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($086e6297be204f45$var$propertyIsEnumerable(val1, key)) {
                    if (!$086e6297be204f45$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($086e6297be204f45$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $086e6297be204f45$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $086e6297be204f45$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $086e6297be204f45$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $086e6297be204f45$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $086e6297be204f45$var$kNoIterator || iterationType === $086e6297be204f45$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $086e6297be204f45$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $086e6297be204f45$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $086e6297be204f45$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($086e6297be204f45$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $086e6297be204f45$var$findLooseMatchingPrimitives(prim) {
    switch($086e6297be204f45$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($086e6297be204f45$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $086e6297be204f45$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $086e6297be204f45$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $086e6297be204f45$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $086e6297be204f45$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$086e6297be204f45$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $086e6297be204f45$var$innerDeepEqual(item, curB, false, memo);
}
function $086e6297be204f45$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $086e6297be204f45$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($086e6297be204f45$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$086e6297be204f45$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $086e6297be204f45$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($086e6297be204f45$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$086e6297be204f45$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$086e6297be204f45$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $086e6297be204f45$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $086e6297be204f45$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($086e6297be204f45$var$innerDeepEqual(key1, key2, strict, memo) && $086e6297be204f45$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $086e6297be204f45$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $086e6297be204f45$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $086e6297be204f45$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($086e6297be204f45$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$086e6297be204f45$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$086e6297be204f45$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $086e6297be204f45$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $086e6297be204f45$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($086e6297be204f45$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$086e6297be204f45$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$086e6297be204f45$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$086e6297be204f45$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $086e6297be204f45$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $086e6297be204f45$var$kIsSet) {
        if (!$086e6297be204f45$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $086e6297be204f45$var$kIsMap) {
        if (!$086e6297be204f45$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $086e6297be204f45$var$kIsArray) for(; i < a.length; i++){
        if ($086e6297be204f45$var$hasOwnProperty(a, i)) {
            if (!$086e6297be204f45$var$hasOwnProperty(b, i) || !$086e6297be204f45$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($086e6297be204f45$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$086e6297be204f45$var$hasOwnProperty(b, key) || !$086e6297be204f45$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$086e6297be204f45$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $086e6297be204f45$var$isDeepEqual(val1, val2) {
    return $086e6297be204f45$var$innerDeepEqual(val1, val2, $086e6297be204f45$var$kLoose);
}
function $086e6297be204f45$var$isDeepStrictEqual(val1, val2) {
    return $086e6297be204f45$var$innerDeepEqual(val1, val2, $086e6297be204f45$var$kStrict);
}
module.exports = {
    isDeepEqual: $086e6297be204f45$var$isDeepEqual,
    isDeepStrictEqual: $086e6297be204f45$var$isDeepStrictEqual
};

});
parcelRegister("agMcO", function(module, exports) {
'use strict';

var $lIiYQ = parcelRequire("lIiYQ");

var $iBdXg = parcelRequire("iBdXg");

var $48QMu = parcelRequire("48QMu");

var $jinRP = parcelRequire("jinRP");

var $fToL4 = parcelRequire("fToL4");
var $01edf2c0aad549b0$var$polyfill = $iBdXg($jinRP(), Object);
$lIiYQ($01edf2c0aad549b0$var$polyfill, {
    getPolyfill: $jinRP,
    implementation: $48QMu,
    shim: $fToL4
});
module.exports = $01edf2c0aad549b0$var$polyfill;

});
parcelRegister("lIiYQ", function(module, exports) {
'use strict';

var $lAXvK = parcelRequire("lAXvK");
var $fcec6e1e9e87a12a$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $fcec6e1e9e87a12a$var$toStr = Object.prototype.toString;
var $fcec6e1e9e87a12a$var$concat = Array.prototype.concat;

var $8RgdG = parcelRequire("8RgdG");
var $fcec6e1e9e87a12a$var$isFunction = function(fn) {
    return typeof fn === 'function' && $fcec6e1e9e87a12a$var$toStr.call(fn) === '[object Function]';
};

var $fcec6e1e9e87a12a$var$supportsDescriptors = (parcelRequire("01DxJ"))();
var $fcec6e1e9e87a12a$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$fcec6e1e9e87a12a$var$isFunction(predicate) || !predicate()) return;
    }
    if ($fcec6e1e9e87a12a$var$supportsDescriptors) $8RgdG(object, name, value, true);
    else $8RgdG(object, name, value);
};
var $fcec6e1e9e87a12a$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $lAXvK(map);
    if ($fcec6e1e9e87a12a$var$hasSymbols) props = $fcec6e1e9e87a12a$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$fcec6e1e9e87a12a$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$fcec6e1e9e87a12a$var$defineProperties.supportsDescriptors = !!$fcec6e1e9e87a12a$var$supportsDescriptors;
module.exports = $fcec6e1e9e87a12a$var$defineProperties;

});

parcelRegister("fToL4", function(module, exports) {
'use strict';

var $jinRP = parcelRequire("jinRP");

var $lIiYQ = parcelRequire("lIiYQ");
module.exports = function shimObjectIs() {
    var polyfill = $jinRP();
    $lIiYQ(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("ddWGc", function(module, exports) {
'use strict';

var $iBdXg = parcelRequire("iBdXg");

var $lIiYQ = parcelRequire("lIiYQ");

var $3OqeP = parcelRequire("3OqeP");

var $fALh4 = parcelRequire("fALh4");

var $h13wY = parcelRequire("h13wY");
var $9a0a01d19bbeada0$var$polyfill = $iBdXg($fALh4(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $lIiYQ($9a0a01d19bbeada0$var$polyfill, {
    getPolyfill: $fALh4,
    implementation: $3OqeP,
    shim: $h13wY
});
module.exports = $9a0a01d19bbeada0$var$polyfill;

});
parcelRegister("3OqeP", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("fALh4", function(module, exports) {
'use strict';

var $3OqeP = parcelRequire("3OqeP");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $3OqeP;
};

});

parcelRegister("h13wY", function(module, exports) {
'use strict';

var $lIiYQ = parcelRequire("lIiYQ");

var $fALh4 = parcelRequire("fALh4");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $fALh4();
    $lIiYQ(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("4wRhu", function(module, exports) {

var $5N3wo = parcelRequire("5N3wo");

var $5UDqS = parcelRequire("5UDqS");
/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */ function $34c37b1d8d1bab64$var$clamp(number, lower, upper) {
    if (upper === undefined) {
        upper = lower;
        lower = undefined;
    }
    if (upper !== undefined) {
        upper = $5UDqS(upper);
        upper = upper === upper ? upper : 0;
    }
    if (lower !== undefined) {
        lower = $5UDqS(lower);
        lower = lower === lower ? lower : 0;
    }
    return $5N3wo($5UDqS(number), lower, upper);
}
module.exports = $34c37b1d8d1bab64$var$clamp;

});

parcelRegister("a3b9P", function(module, exports) {
$parcel$export(module.exports, "Decoration", () => $7512d6d6ef34b779$export$10e30b733df217ea);
$parcel$export(module.exports, "DecorationSet", () => $7512d6d6ef34b779$export$93bf62eb445cec98);
$parcel$export(module.exports, "EditorView", () => $7512d6d6ef34b779$export$eece2fccabbb77c5);

var $cw0wu = parcelRequire("cw0wu");

var $kW8qW = parcelRequire("kW8qW");

var $3DNV7 = parcelRequire("3DNV7");
const $7512d6d6ef34b779$var$domIndex = function(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
};
const $7512d6d6ef34b779$var$parentNode = function(node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let $7512d6d6ef34b779$var$reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const $7512d6d6ef34b779$var$textRange = function(node, from, to) {
    let range = $7512d6d6ef34b779$var$reusedRange || ($7512d6d6ef34b779$var$reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const $7512d6d6ef34b779$var$clearReusedRange = function() {
    $7512d6d6ef34b779$var$reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const $7512d6d6ef34b779$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
    return targetNode && ($7512d6d6ef34b779$var$scanFor(node, off, targetNode, targetOff, -1) || $7512d6d6ef34b779$var$scanFor(node, off, targetNode, targetOff, 1));
};
const $7512d6d6ef34b779$var$atomElements = /^(img|br|input|textarea|hr)$/i;
function $7512d6d6ef34b779$var$scanFor(node, off, targetNode, targetOff, dir) {
    var _a;
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $7512d6d6ef34b779$var$nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || $7512d6d6ef34b779$var$hasBlockDesc(node) || $7512d6d6ef34b779$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
            off = $7512d6d6ef34b779$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            let child = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (child.nodeType == 1 && child.contentEditable == "false") {
                if ((_a = child.pmViewDesc) === null || _a === void 0 ? void 0 : _a.ignoreForSelection) off += dir;
                else return false;
            } else {
                node = child;
                off = dir < 0 ? $7512d6d6ef34b779$var$nodeSize(node) : 0;
            }
        } else return false;
    }
}
function $7512d6d6ef34b779$var$nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $7512d6d6ef34b779$var$textNodeBefore$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset) return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $7512d6d6ef34b779$var$nodeSize(node);
        } else if (node.parentNode && !$7512d6d6ef34b779$var$hasBlockDesc(node)) {
            offset = $7512d6d6ef34b779$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $7512d6d6ef34b779$var$textNodeAfter$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$7512d6d6ef34b779$var$hasBlockDesc(node)) {
            offset = $7512d6d6ef34b779$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
function $7512d6d6ef34b779$var$isOnEdge(node, offset, parent) {
    for(let atStart = offset == 0, atEnd = offset == $7512d6d6ef34b779$var$nodeSize(node); atStart || atEnd;){
        if (node == parent) return true;
        let index = $7512d6d6ef34b779$var$domIndex(node);
        node = node.parentNode;
        if (!node) return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == $7512d6d6ef34b779$var$nodeSize(node);
    }
}
function $7512d6d6ef34b779$var$hasBlockDesc(dom) {
    let desc;
    for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const $7512d6d6ef34b779$var$selectionCollapsed = function(domSel) {
    return domSel.focusNode && $7512d6d6ef34b779$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function $7512d6d6ef34b779$var$keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function $7512d6d6ef34b779$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $7512d6d6ef34b779$var$caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) try {
        let pos = doc.caretPositionFromPoint(x, y);
        // Clip the offset, because Chrome will return a text offset
        // into <input> nodes, which can't be treated as a regular DOM
        // offset
        if (pos) return {
            node: pos.offsetNode,
            offset: Math.min($7512d6d6ef34b779$var$nodeSize(pos.offsetNode), pos.offset)
        };
    } catch (_) {}
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range) return {
            node: range.startContainer,
            offset: Math.min($7512d6d6ef34b779$var$nodeSize(range.startContainer), range.startOffset)
        };
    }
}
const $7512d6d6ef34b779$var$nav = typeof navigator != "undefined" ? navigator : null;
const $7512d6d6ef34b779$var$doc = typeof document != "undefined" ? document : null;
const $7512d6d6ef34b779$var$agent = $7512d6d6ef34b779$var$nav && $7512d6d6ef34b779$var$nav.userAgent || "";
const $7512d6d6ef34b779$var$ie_edge = /Edge\/(\d+)/.exec($7512d6d6ef34b779$var$agent);
const $7512d6d6ef34b779$var$ie_upto10 = /MSIE \d/.exec($7512d6d6ef34b779$var$agent);
const $7512d6d6ef34b779$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($7512d6d6ef34b779$var$agent);
const $7512d6d6ef34b779$var$ie = !!($7512d6d6ef34b779$var$ie_upto10 || $7512d6d6ef34b779$var$ie_11up || $7512d6d6ef34b779$var$ie_edge);
const $7512d6d6ef34b779$var$ie_version = $7512d6d6ef34b779$var$ie_upto10 ? document.documentMode : $7512d6d6ef34b779$var$ie_11up ? +$7512d6d6ef34b779$var$ie_11up[1] : $7512d6d6ef34b779$var$ie_edge ? +$7512d6d6ef34b779$var$ie_edge[1] : 0;
const $7512d6d6ef34b779$var$gecko = !$7512d6d6ef34b779$var$ie && /gecko\/(\d+)/i.test($7512d6d6ef34b779$var$agent);
$7512d6d6ef34b779$var$gecko && (/Firefox\/(\d+)/.exec($7512d6d6ef34b779$var$agent) || [
    0,
    0
])[1];
const $7512d6d6ef34b779$var$_chrome = !$7512d6d6ef34b779$var$ie && /Chrome\/(\d+)/.exec($7512d6d6ef34b779$var$agent);
const $7512d6d6ef34b779$var$chrome = !!$7512d6d6ef34b779$var$_chrome;
const $7512d6d6ef34b779$var$chrome_version = $7512d6d6ef34b779$var$_chrome ? +$7512d6d6ef34b779$var$_chrome[1] : 0;
const $7512d6d6ef34b779$var$safari = !$7512d6d6ef34b779$var$ie && !!$7512d6d6ef34b779$var$nav && /Apple Computer/.test($7512d6d6ef34b779$var$nav.vendor);
// Is true for both iOS and iPadOS for convenience
const $7512d6d6ef34b779$var$ios = $7512d6d6ef34b779$var$safari && (/Mobile\/\w+/.test($7512d6d6ef34b779$var$agent) || !!$7512d6d6ef34b779$var$nav && $7512d6d6ef34b779$var$nav.maxTouchPoints > 2);
const $7512d6d6ef34b779$var$mac = $7512d6d6ef34b779$var$ios || ($7512d6d6ef34b779$var$nav ? /Mac/.test($7512d6d6ef34b779$var$nav.platform) : false);
const $7512d6d6ef34b779$var$windows = $7512d6d6ef34b779$var$nav ? /Win/.test($7512d6d6ef34b779$var$nav.platform) : false;
const $7512d6d6ef34b779$var$android = /Android \d/.test($7512d6d6ef34b779$var$agent);
const $7512d6d6ef34b779$var$webkit = !!$7512d6d6ef34b779$var$doc && "webkitFontSmoothing" in $7512d6d6ef34b779$var$doc.documentElement.style;
const $7512d6d6ef34b779$var$webkit_version = $7512d6d6ef34b779$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
    0,
    0
])[1] : 0;
function $7512d6d6ef34b779$var$windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: doc.documentElement.clientWidth,
        top: 0,
        bottom: doc.documentElement.clientHeight
    };
}
function $7512d6d6ef34b779$var$getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function $7512d6d6ef34b779$var$clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = rect.width / node.offsetWidth || 1;
    let scaleY = rect.height / node.offsetHeight || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return {
        left: rect.left,
        right: rect.left + node.clientWidth * scaleX,
        top: rect.top,
        bottom: rect.top + node.clientHeight * scaleY
    };
}
function $7512d6d6ef34b779$var$scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for(let parent = startDOM || view.dom;;){
        if (!parent) break;
        if (parent.nodeType != 1) {
            parent = $7512d6d6ef34b779$var$parentNode(parent);
            continue;
        }
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? $7512d6d6ef34b779$var$windowRect(doc) : $7512d6d6ef34b779$var$clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + $7512d6d6ef34b779$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $7512d6d6ef34b779$var$getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - $7512d6d6ef34b779$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $7512d6d6ef34b779$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $7512d6d6ef34b779$var$getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + $7512d6d6ef34b779$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $7512d6d6ef34b779$var$getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - $7512d6d6ef34b779$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $7512d6d6ef34b779$var$getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) doc.defaultView.scrollBy(moveX, moveY);
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY) elt.scrollTop += moveY;
                if (moveX) elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = {
                    left: rect.left - dX,
                    top: rect.top - dY,
                    right: rect.right - dX,
                    bottom: rect.bottom - dY
                };
            }
        }
        let pos = atTop ? "fixed" : getComputedStyle(parent).position;
        if (/^(fixed|sticky)$/.test(pos)) break;
        parent = pos == "absolute" ? parent.offsetParent : $7512d6d6ef34b779$var$parentNode(parent);
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function $7512d6d6ef34b779$var$storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return {
        refDOM: refDOM,
        refTop: refTop,
        stack: $7512d6d6ef34b779$var$scrollStack(view.dom)
    };
}
function $7512d6d6ef34b779$var$scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for(let cur = dom; cur; cur = $7512d6d6ef34b779$var$parentNode(cur)){
        stack.push({
            dom: cur,
            top: cur.scrollTop,
            left: cur.scrollLeft
        });
        if (dom == doc) break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function $7512d6d6ef34b779$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    $7512d6d6ef34b779$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function $7512d6d6ef34b779$var$restoreScrollStack(stack, dTop) {
    for(let i = 0; i < stack.length; i++){
        let { dom: dom, top: top, left: left } = stack[i];
        if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left) dom.scrollLeft = left;
    }
}
let $7512d6d6ef34b779$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $7512d6d6ef34b779$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($7512d6d6ef34b779$var$preventScrollSupported) return dom.focus($7512d6d6ef34b779$var$preventScrollSupported);
    let stored = $7512d6d6ef34b779$var$scrollStack(dom);
    dom.focus($7512d6d6ef34b779$var$preventScrollSupported == null ? {
        get preventScroll () {
            $7512d6d6ef34b779$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$7512d6d6ef34b779$var$preventScrollSupported) {
        $7512d6d6ef34b779$var$preventScrollSupported = false;
        $7512d6d6ef34b779$var$restoreScrollStack(stored, 0);
    }
}
function $7512d6d6ef34b779$var$findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
        let rects;
        if (child.nodeType == 1) rects = child.getClientRects();
        else if (child.nodeType == 3) rects = $7512d6d6ef34b779$var$textRange(child).getClientRects();
        else continue;
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = {
                    left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                    top: rect.top
                };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3) return $7512d6d6ef34b779$var$findOffsetInText(closest, coordsClosest);
    if (!closest || dxClosest && closest.nodeType == 1) return {
        node: node,
        offset: offset
    };
    return $7512d6d6ef34b779$var$findOffsetInNode(closest, coordsClosest);
}
function $7512d6d6ef34b779$var$findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange(), result;
    for(let i = 0; i < len; i++){
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = $7512d6d6ef34b779$var$singleRect(range, 1);
        if (rect.top == rect.bottom) continue;
        if ($7512d6d6ef34b779$var$inRect(coords, rect)) {
            result = {
                node: node,
                offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
            };
            break;
        }
    }
    range.detach();
    return result || {
        node: node,
        offset: 0
    };
}
function $7512d6d6ef34b779$var$inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function $7512d6d6ef34b779$var$targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
    return dom;
}
function $7512d6d6ef34b779$var$posFromElement(view, elt, coords) {
    let { node: node, offset: offset } = $7512d6d6ef34b779$var$findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function $7512d6d6ef34b779$var$posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for(let cur = node, sawBlock = false;;){
        if (cur == view.dom) break;
        let desc = view.docView.nearestDesc(cur, true), rect;
        if (!desc) return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) && // Ignore elements with zero-size bounding rectangles
        ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
            if (desc.node.isBlock && desc.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(desc.dom.nodeName)) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function $7512d6d6ef34b779$var$elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
        let child = element.childNodes[i];
        if (child.nodeType == 1) {
            let rects = child.getClientRects();
            for(let j = 0; j < rects.length; j++){
                let rect = rects[j];
                if ($7512d6d6ef34b779$var$inRect(coords, rect)) return $7512d6d6ef34b779$var$elementFromPoint(child, coords, rect);
            }
        }
        if ((i = (i + 1) % len) == startI) break;
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function $7512d6d6ef34b779$var$posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = $7512d6d6ef34b779$var$caretFromPoint(doc, coords.left, coords.top);
    if (caret) ({ node: node, offset: offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!$7512d6d6ef34b779$var$inRect(coords, box)) return null;
        elt = $7512d6d6ef34b779$var$elementFromPoint(view.dom, coords, box);
        if (!elt) return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if ($7512d6d6ef34b779$var$safari) {
        for(let p = elt; node && p; p = $7512d6d6ef34b779$var$parentNode(p))if (p.draggable) node = undefined;
    }
    elt = $7512d6d6ef34b779$var$targetKludge(elt, coords);
    if (node) {
        if ($7512d6d6ef34b779$var$gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if ($7512d6d6ef34b779$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $7512d6d6ef34b779$var$posFromCaret(view, node, offset, coords);
    }
    if (pos == null) pos = $7512d6d6ef34b779$var$posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return {
        pos: pos,
        inside: desc ? desc.posAtStart - desc.border : -1
    };
}
function $7512d6d6ef34b779$var$nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function $7512d6d6ef34b779$var$singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if ($7512d6d6ef34b779$var$nonZero(first)) return first;
    }
    return Array.prototype.find.call(rects, $7512d6d6ef34b779$var$nonZero) || target.getBoundingClientRect();
}
const $7512d6d6ef34b779$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function $7512d6d6ef34b779$var$coordsAtPos(view, pos, side) {
    let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = $7512d6d6ef34b779$var$webkit || $7512d6d6ef34b779$var$gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && ($7512d6d6ef34b779$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = $7512d6d6ef34b779$var$singleRect($7512d6d6ef34b779$var$textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if ($7512d6d6ef34b779$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = $7512d6d6ef34b779$var$singleRect($7512d6d6ef34b779$var$textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = $7512d6d6ef34b779$var$singleRect($7512d6d6ef34b779$var$textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top) return $7512d6d6ef34b779$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        } else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            } else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            } else if (side < 0) from--;
            else to++;
            return $7512d6d6ef34b779$var$flattenV($7512d6d6ef34b779$var$singleRect($7512d6d6ef34b779$var$textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == $7512d6d6ef34b779$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1) return $7512d6d6ef34b779$var$flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < $7512d6d6ef34b779$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1) return $7512d6d6ef34b779$var$flattenH(after.getBoundingClientRect(), true);
        }
        return $7512d6d6ef34b779$var$flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == $7512d6d6ef34b779$var$nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? $7512d6d6ef34b779$var$textRange(before, $7512d6d6ef34b779$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target) return $7512d6d6ef34b779$var$flattenV($7512d6d6ef34b779$var$singleRect(target, 1), false);
    }
    if (atom == null && offset < $7512d6d6ef34b779$var$nodeSize(node)) {
        let after = node.childNodes[offset];
        while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? $7512d6d6ef34b779$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
        if (target) return $7512d6d6ef34b779$var$flattenV($7512d6d6ef34b779$var$singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return $7512d6d6ef34b779$var$flattenV($7512d6d6ef34b779$var$singleRect(node.nodeType == 3 ? $7512d6d6ef34b779$var$textRange(node) : node, -side), side >= 0);
}
function $7512d6d6ef34b779$var$flattenV(rect, left) {
    if (rect.width == 0) return rect;
    let x = left ? rect.left : rect.right;
    return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x
    };
}
function $7512d6d6ef34b779$var$flattenH(rect, top) {
    if (rect.height == 0) return rect;
    let y = top ? rect.top : rect.bottom;
    return {
        top: y,
        bottom: y,
        left: rect.left,
        right: rect.right
    };
}
function $7512d6d6ef34b779$var$withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state) view.updateState(state);
    if (active != view.dom) view.focus();
    try {
        return f();
    } finally{
        if (viewState != state) view.updateState(viewState);
        if (active != view.dom && active) active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function $7512d6d6ef34b779$var$endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return $7512d6d6ef34b779$var$withFlushedState(view, state, ()=>{
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for(;;){
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest) break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = $7512d6d6ef34b779$var$coordsAtPos(view, $pos.pos, 1);
        for(let child = dom.firstChild; child; child = child.nextSibling){
            let boxes;
            if (child.nodeType == 1) boxes = child.getClientRects();
            else if (child.nodeType == 3) boxes = $7512d6d6ef34b779$var$textRange(child, 0, child.nodeValue.length).getClientRects();
            else continue;
            for(let i = 0; i < boxes.length; i++){
                let box = boxes[i];
                if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
            }
        }
        return true;
    });
}
const $7512d6d6ef34b779$var$maybeRTL = /[\u0590-\u08ac]/;
function $7512d6d6ef34b779$var$endOfTextblockHorizontal(view, state, dir) {
    let { $head: $head } = state.selection;
    if (!$head.parent.isTextblock) return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!$7512d6d6ef34b779$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
    return $7512d6d6ef34b779$var$withFlushedState(view, state, ()=>{
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
        } catch (_) {}
        if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let $7512d6d6ef34b779$var$cachedState = null;
let $7512d6d6ef34b779$var$cachedDir = null;
let $7512d6d6ef34b779$var$cachedResult = false;
function $7512d6d6ef34b779$var$endOfTextblock(view, state, dir) {
    if ($7512d6d6ef34b779$var$cachedState == state && $7512d6d6ef34b779$var$cachedDir == dir) return $7512d6d6ef34b779$var$cachedResult;
    $7512d6d6ef34b779$var$cachedState = state;
    $7512d6d6ef34b779$var$cachedDir = dir;
    return $7512d6d6ef34b779$var$cachedResult = dir == "up" || dir == "down" ? $7512d6d6ef34b779$var$endOfTextblockVertical(view, state, dir) : $7512d6d6ef34b779$var$endOfTextblockHorizontal(view, state, dir);
}
// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const $7512d6d6ef34b779$var$NOT_DIRTY = 0, $7512d6d6ef34b779$var$CHILD_DIRTY = 1, $7512d6d6ef34b779$var$CONTENT_DIRTY = 2, $7512d6d6ef34b779$var$NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class $7512d6d6ef34b779$var$ViewDesc {
    constructor(parent, children, dom, // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM){
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = $7512d6d6ef34b779$var$NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) {
        return false;
    }
    matchesMark(mark) {
        return false;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return false;
    }
    matchesHack(nodeName) {
        return false;
    }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() {
        return null;
    }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) {
        return false;
    }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() {
        return 0;
    }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
        for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
    }
    posBeforeChild(child) {
        for(let i = 0, pos = this.posAtStart;; i++){
            let cur = this.children[i];
            if (cur == child) return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            } else {
                let domAfter, desc;
                if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) atEnd = offset > $7512d6d6ef34b779$var$domIndex(this.contentDOM);
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        else if (this.dom.firstChild) {
            if (offset == 0) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = false;
                    break;
                }
                if (search.previousSibling) break;
            }
            if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = true;
                    break;
                }
                if (search.nextSibling) break;
            }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for(let first = true, cur = dom; cur; cur = cur.parentNode){
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                else return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
    }
    posFromDOM(dom, offset, bias) {
        for(let scan = dom; scan; scan = scan.parentNode){
            let desc = this.getDesc(scan);
            if (desc) return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while(!child.border && child.children.length)for(let i = 0; i < child.children.length; i++){
                    let inner = child.children[i];
                    if (inner.size) {
                        child = inner;
                        break;
                    }
                }
                return child;
            }
            if (pos < end) return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM) return {
            node: this.dom,
            offset: 0,
            atom: pos + 1
        };
        // First find the position in the child array
        let i = 0, offset = 0;
        for(let curPos = 0; i < this.children.length; i++){
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof $7512d6d6ef34b779$var$TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $7512d6d6ef34b779$var$WidgetViewDesc && prev.side >= 0; i--);
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for(;; i--, enter = false){
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM) break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
            return {
                node: this.contentDOM,
                offset: prev ? $7512d6d6ef34b779$var$domIndex(prev.dom) + 1 : 0
            };
        } else {
            let next, enter = true;
            for(;; i++, enter = false){
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM) break;
            }
            if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
            return {
                node: this.contentDOM,
                offset: next ? $7512d6d6ef34b779$var$domIndex(next.dom) : this.contentDOM.childNodes.length
            };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0) return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: 0,
            toOffset: this.contentDOM.childNodes.length
        };
        let fromOffset = -1, toOffset = -1;
        for(let offset = base, i = 0;; i++){
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                from = offset;
                for(let j = i; j > 0; j--){
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = $7512d6d6ef34b779$var$domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1) fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for(let j = i + 1; j < this.children.length; j++){
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = $7512d6d6ef34b779$var$domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: fromOffset,
            toOffset: toOffset
        };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length) return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node: node, offset: offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, view, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, view, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = view.root.getSelection();
        let selRange = view.domSelectionRange();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if (($7512d6d6ef34b779$var$gecko || $7512d6d6ef34b779$var$safari) && anchor == head) {
            let { node: node, offset: offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                    if (after = scan.nextSibling) {
                        if (after.nodeName == "BR") anchorDOM = headDOM = {
                            node: after.parentNode,
                            offset: $7512d6d6ef34b779$var$domIndex(after) + 1
                        };
                        break;
                    }
                    let desc = scan.pmViewDesc;
                    if (desc && desc.node && desc.node.isBlock) break;
                }
            } else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if ($7512d6d6ef34b779$var$gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
            let after = selRange.focusNode.childNodes[selRange.focusOffset];
            if (after && after.contentEditable == "false") force = true;
        }
        if (!(force || brKludge && $7512d6d6ef34b779$var$safari) && $7512d6d6ef34b779$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) && $7512d6d6ef34b779$var$isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset)) return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !(brKludge && $7512d6d6ef34b779$var$gecko)) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            } catch (_) {
            // In some cases with Chrome the selection is empty after calling
            // collapse, even when it should be valid. This appears to be a bug, but
            // it is difficult to isolate. If this happens fallback to the old path
            // without using extend.
            // Similarly, this could crash on Safari if the editor is hidden, and
            // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for(let offset = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? $7512d6d6ef34b779$var$CONTENT_DIRTY : $7512d6d6ef34b779$var$CHILD_DIRTY;
                    if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $7512d6d6ef34b779$var$NODE_DIRTY;
                    else child.markDirty(from - startInside, to - startInside);
                    return;
                } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $7512d6d6ef34b779$var$CONTENT_DIRTY : $7512d6d6ef34b779$var$NODE_DIRTY;
            }
            offset = end;
        }
        this.dirty = $7512d6d6ef34b779$var$CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for(let node = this.parent; node; node = node.parent, level++){
            let dirty = level == 1 ? $7512d6d6ef34b779$var$CONTENT_DIRTY : $7512d6d6ef34b779$var$CHILD_DIRTY;
            if (node.dirty < dirty) node.dirty = dirty;
        }
    }
    get domAtom() {
        return false;
    }
    get ignoreForCoords() {
        return false;
    }
    get ignoreForSelection() {
        return false;
    }
    isText(text) {
        return false;
    }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class $7512d6d6ef34b779$var$WidgetViewDesc extends $7512d6d6ef34b779$var$ViewDesc {
    constructor(parent, widget, view, pos){
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function") dom = dom(view, ()=>{
            if (!self) return pos;
            if (self.parent) return self.parent.posBeforeChild(self);
        });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
    matchesWidget(widget) {
        return this.dirty == $7512d6d6ef34b779$var$NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() {
        return {
            ignore: true
        };
    }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() {
        return true;
    }
    get ignoreForSelection() {
        return !!this.widget.type.spec.relaxedSide;
    }
    get side() {
        return this.widget.type.side;
    }
}
class $7512d6d6ef34b779$var$CompositionViewDesc extends $7512d6d6ef34b779$var$ViewDesc {
    constructor(parent, dom, textDOM, text){
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
    get size() {
        return this.text.length;
    }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return {
            node: this.textDOM,
            offset: pos
        };
    }
    ignoreMutation(mut) {
        return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class $7512d6d6ef34b779$var$MarkViewDesc extends $7512d6d6ef34b779$var$ViewDesc {
    constructor(parent, mark, dom, contentDOM, spec){
        super(parent, [], dom, contentDOM);
        this.mark = mark;
        this.spec = spec;
    }
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom) spec = (0, $kW8qW.DOMSerializer).renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
        return new $7512d6d6ef34b779$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
    }
    parseRule() {
        if (this.dirty & $7512d6d6ef34b779$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
        return {
            mark: this.mark.type.name,
            attrs: this.mark.attrs,
            contentElement: this.contentDOM
        };
    }
    matchesMark(mark) {
        return this.dirty != $7512d6d6ef34b779$var$NODE_DIRTY && this.mark.eq(mark);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != $7512d6d6ef34b779$var$NOT_DIRTY) {
            let parent = this.parent;
            while(!parent.node)parent = parent.parent;
            if (parent.dirty < this.dirty) parent.dirty = this.dirty;
            this.dirty = $7512d6d6ef34b779$var$NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = $7512d6d6ef34b779$var$MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size) nodes = $7512d6d6ef34b779$var$replaceNodes(nodes, to, size, view);
        if (from > 0) nodes = $7512d6d6ef34b779$var$replaceNodes(nodes, 0, from, view);
        for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class $7512d6d6ef34b779$var$NodeViewDesc extends $7512d6d6ef34b779$var$ViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, ()=>{
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj) return pos;
            if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom) dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
        } else if (!dom) {
            let spec = (0, $kW8qW.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
            ({ dom: dom, contentDOM: contentDOM } = spec);
        }
        if (!contentDOM && !node.isText && dom.nodeName != "BR") {
            if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
            if (node.type.spec.draggable) dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = $7512d6d6ef34b779$var$applyOuterDeco(dom, outerDeco, node);
        if (spec) return descObj = new $7512d6d6ef34b779$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText) return new $7512d6d6ef34b779$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else return new $7512d6d6ef34b779$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView) return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = {
            node: this.node.type.name,
            attrs: this.node.attrs
        };
        if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
        if (!this.contentDOM) rule.getContent = ()=>this.node.content;
        else if (!this.contentLost) rule.contentElement = this.contentDOM;
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for(let i = this.children.length - 1; i >= 0; i--){
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) rule.getContent = ()=>(0, $kW8qW.Fragment).empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == $7512d6d6ef34b779$var$NOT_DIRTY && node.eq(this.node) && $7512d6d6ef34b779$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() {
        return this.node.nodeSize;
    }
    get border() {
        return this.node.isLeaf ? 0 : 1;
    }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new $7512d6d6ef34b779$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
        $7512d6d6ef34b779$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
            if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view, i);
            else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, $kW8qW.Mark).none : this.node.child(i).marks, inline, view, i);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i)=>{
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view, i);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else // Add it as a new view
            updater.addNode(child, outerDeco, innerDeco, view, off);
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view, 0);
        if (this.node.isTextblock) updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == $7512d6d6ef34b779$var$CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition) this.protectLocalComposition(view, localComposition);
            $7512d6d6ef34b779$var$renderDescs(this.contentDOM, this.children, view);
            if ($7512d6d6ef34b779$var$ios) $7512d6d6ef34b779$var$iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from: from, to: to } = view.state.selection;
        if (!(view.state.selection instanceof (0, $cw0wu.TextSelection)) || from < pos || to > pos + this.node.content.size) return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = $7512d6d6ef34b779$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : {
                node: textNode,
                pos: textPos,
                text: text
            };
        } else return {
            node: textNode,
            pos: -1,
            text: ""
        };
    }
    protectLocalComposition(view, { node: node, pos: pos, text: text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node)) return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for(;; topNode = topNode.parentNode){
            if (topNode.parentNode == this.contentDOM) break;
            while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
            while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
        }
        let desc = new $7512d6d6ef34b779$var$CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = $7512d6d6ef34b779$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $7512d6d6ef34b779$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM) this.updateChildren(view, this.posAtStart);
        this.dirty = $7512d6d6ef34b779$var$NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if ($7512d6d6ef34b779$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = $7512d6d6ef34b779$var$patchOuterDeco(this.dom, this.nodeDOM, $7512d6d6ef34b779$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $7512d6d6ef34b779$var$computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.add("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.nodeDOM.draggable = true;
        }
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.nodeDOM.removeAttribute("draggable");
        }
    }
    get domAtom() {
        return this.node.isAtom;
    }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function $7512d6d6ef34b779$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    $7512d6d6ef34b779$var$applyOuterDeco(dom, outerDeco, doc);
    let docView = new $7512d6d6ef34b779$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM) docView.updateChildren(view, 0);
    return docView;
}
class $7512d6d6ef34b779$var$TextViewDesc extends $7512d6d6ef34b779$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
        return {
            skip: skip || true
        };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $7512d6d6ef34b779$var$NODE_DIRTY || this.dirty != $7512d6d6ef34b779$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != $7512d6d6ef34b779$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
        }
        this.node = node;
        this.dirty = $7512d6d6ef34b779$var$NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
        return false;
    }
    domFromPos(pos) {
        return {
            node: this.nodeDOM,
            offset: pos
        };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new $7512d6d6ef34b779$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $7512d6d6ef34b779$var$NODE_DIRTY;
    }
    get domAtom() {
        return false;
    }
    isText(text) {
        return this.node.text == text;
    }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class $7512d6d6ef34b779$var$TrailingHackViewDesc extends $7512d6d6ef34b779$var$ViewDesc {
    parseRule() {
        return {
            ignore: true
        };
    }
    matchesHack(nodeName) {
        return this.dirty == $7512d6d6ef34b779$var$NOT_DIRTY && this.dom.nodeName == nodeName;
    }
    get domAtom() {
        return true;
    }
    get ignoreForCoords() {
        return this.dom.nodeName == "IMG";
    }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class $7512d6d6ef34b779$var$CustomNodeViewDesc extends $7512d6d6ef34b779$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $7512d6d6ef34b779$var$NODE_DIRTY) return false;
        if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result) this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        } else if (!this.contentDOM && !node.isLeaf) return false;
        else return super.update(node, outerDeco, innerDeco, view);
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, view, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root) : super.setSelection(anchor, head, view, force);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function $7512d6d6ef34b779$var$renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for(let i = 0; i < descs.length; i++){
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while(childDOM != dom){
                dom = $7512d6d6ef34b779$var$rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        } else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof $7512d6d6ef34b779$var$MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            $7512d6d6ef34b779$var$renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while(dom){
        dom = $7512d6d6ef34b779$var$rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
const $7512d6d6ef34b779$var$OuterDecoLevel = function(nodeName) {
    if (nodeName) this.nodeName = nodeName;
};
$7512d6d6ef34b779$var$OuterDecoLevel.prototype = Object.create(null);
const $7512d6d6ef34b779$var$noDeco = [
    new $7512d6d6ef34b779$var$OuterDecoLevel
];
function $7512d6d6ef34b779$var$computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0) return $7512d6d6ef34b779$var$noDeco;
    let top = needsWrap ? $7512d6d6ef34b779$var$noDeco[0] : new $7512d6d6ef34b779$var$OuterDecoLevel, result = [
        top
    ];
    for(let i = 0; i < outerDeco.length; i++){
        let attrs = outerDeco[i].type.attrs;
        if (!attrs) continue;
        if (attrs.nodeName) result.push(top = new $7512d6d6ef34b779$var$OuterDecoLevel(attrs.nodeName));
        for(let name in attrs){
            let val = attrs[name];
            if (val == null) continue;
            if (needsWrap && result.length == 1) result.push(top = new $7512d6d6ef34b779$var$OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName") top[name] = val;
        }
    }
    return result;
}
function $7512d6d6ef34b779$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == $7512d6d6ef34b779$var$noDeco && curComputed == $7512d6d6ef34b779$var$noDeco) return nodeDOM;
    let curDOM = nodeDOM;
    for(let i = 0; i < curComputed.length; i++){
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = $7512d6d6ef34b779$var$noDeco[0];
                curDOM = parent;
            }
        }
        $7512d6d6ef34b779$var$patchAttributes(curDOM, prev || $7512d6d6ef34b779$var$noDeco[0], deco);
    }
    return curDOM;
}
function $7512d6d6ef34b779$var$patchAttributes(dom, prev, cur) {
    for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
    for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
        for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
        if (dom.classList.length == 0) dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
        }
        if (cur.style) dom.style.cssText += cur.style;
    }
}
function $7512d6d6ef34b779$var$applyOuterDeco(dom, deco, node) {
    return $7512d6d6ef34b779$var$patchOuterDeco(dom, dom, $7512d6d6ef34b779$var$noDeco, $7512d6d6ef34b779$var$computeOuterDeco(deco, node, dom.nodeType != 1));
}
function $7512d6d6ef34b779$var$sameOuterDeco(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function $7512d6d6ef34b779$var$rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class $7512d6d6ef34b779$var$ViewTreeUpdater {
    constructor(top, lock, view){
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = $7512d6d6ef34b779$var$preMatch(top.node.content, top);
    }
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end) return;
        for(let i = start; i < end; i++)this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view, parentIndex) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
        while(keep < depth){
            this.destroyRest();
            this.top.dirty = $7512d6d6ef34b779$var$NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while(depth < marks.length){
            this.stack.push(this.top, this.index + 1);
            let found = -1, scanTo = this.top.children.length;
            if (parentIndex < this.preMatch.index) scanTo = Math.min(this.index + 3, scanTo);
            for(let i = this.index; i < scanTo; i++){
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            } else {
                let markDesc = $7512d6d6ef34b779$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
        else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
            let child = this.top.children[i];
            if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                found = i;
                break;
            }
        }
        if (found < 0) return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == $7512d6d6ef34b779$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $7512d6d6ef34b779$var$CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view)) return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for(;;){
            let parent = domNode.parentNode;
            if (!parent) return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc) for(let i = this.index; i < this.top.children.length; i++){
                    if (this.top.children[i] == desc) return i;
                }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for(let i = this.index; i < this.top.children.length; i++){
            let next = this.top.children[i];
            if (next instanceof $7512d6d6ef34b779$var$NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index) return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $7512d6d6ef34b779$var$NODE_DIRTY && $7512d6d6ef34b779$var$sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM) this.changed = true;
                    this.index++;
                    return true;
                } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.destroyBetween(this.index, i);
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = $7512d6d6ef34b779$var$CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = $7512d6d6ef34b779$var$NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content) || !$7512d6d6ef34b779$var$sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco)) return null;
        let wrapper = $7512d6d6ef34b779$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = $7512d6d6ef34b779$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM) desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
        else {
            let desc = new $7512d6d6ef34b779$var$WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while(lastChild instanceof $7512d6d6ef34b779$var$MarkViewDesc){
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
        !(lastChild instanceof $7512d6d6ef34b779$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if (($7512d6d6ef34b779$var$safari || $7512d6d6ef34b779$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
            let hack = new $7512d6d6ef34b779$var$TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top) parent.children.push(hack);
            else parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes.
function $7512d6d6ef34b779$var$preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while(fI > 0){
        let desc;
        for(;;){
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof $7512d6d6ef34b779$var$MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                } else {
                    desc = next;
                    descI--;
                    break;
                }
            } else if (curDesc == parentDesc) break outer;
            else {
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node) continue;
        if (node != frag.child(fI - 1)) break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return {
        index: fI,
        matched: matched,
        matches: matches.reverse()
    };
}
function $7512d6d6ef34b779$var$compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function $7512d6d6ef34b779$var$iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for(let i = 0; i < parent.childCount; i++){
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for(let parentIndex = 0;;){
        let widget, widgets;
        while(decoIndex < locals.length && locals[decoIndex].to == offset){
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget) widget = next;
                else (widgets || (widgets = [
                    widget
                ])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort($7512d6d6ef34b779$var$compareSide);
                for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
            } else onWidget(widget, parentIndex, !!restNode);
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        } else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        } else break;
        for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
        while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
            for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
        let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function $7512d6d6ef34b779$var$iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function $7512d6d6ef34b779$var$findTextInFragment(frag, text, from, to) {
    for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText) continue;
        let str = child.text;
        while(i < frag.childCount){
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText) break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
            if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function $7512d6d6ef34b779$var$replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for(let i = 0, off = 0; i < nodes.length; i++){
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) result.push(child);
        else {
            if (start < from) result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to) result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}
function $7512d6d6ef34b779$var$selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode) return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0) return null;
    let $head = doc.resolve(head), anchor, selection;
    if ($7512d6d6ef34b779$var$selectionCollapsed(domSel)) {
        anchor = head;
        while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && (0, $cw0wu.NodeSelection).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $7512d6d6ef34b779$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new (0, $cw0wu.NodeSelection)(head == pos ? $head : doc.resolve(pos));
        }
    } else {
        if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
            let min = head, max = head;
            for(let i = 0; i < domSel.rangeCount; i++){
                let range = domSel.getRangeAt(i);
                min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
                max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
            }
            if (min < 0) return null;
            [anchor, head] = max == view.state.selection.anchor ? [
                max,
                min
            ] : [
                min,
                max
            ];
            $head = doc.resolve(head);
        } else anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        if (anchor < 0) return null;
    }
    let $anchor = doc.resolve(anchor);
    if (!selection) {
        let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
        selection = $7512d6d6ef34b779$var$selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function $7512d6d6ef34b779$var$editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() : $7512d6d6ef34b779$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function $7512d6d6ef34b779$var$selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    $7512d6d6ef34b779$var$syncNodeSelection(view, sel);
    if (!$7512d6d6ef34b779$var$editorOwnsSelection(view)) return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $7512d6d6ef34b779$var$chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode && $7512d6d6ef34b779$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) $7512d6d6ef34b779$var$selectCursorWrapper(view);
    else {
        let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
        if ($7512d6d6ef34b779$var$brokenSelectBetweenUneditable && !(sel instanceof (0, $cw0wu.TextSelection))) {
            if (!sel.$from.parent.inlineContent) resetEditableFrom = $7512d6d6ef34b779$var$temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $7512d6d6ef34b779$var$temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view, force);
        if ($7512d6d6ef34b779$var$brokenSelectBetweenUneditable) {
            if (resetEditableFrom) $7512d6d6ef34b779$var$resetEditable(resetEditableFrom);
            if (resetEditableTo) $7512d6d6ef34b779$var$resetEditable(resetEditableTo);
        }
        if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document) $7512d6d6ef34b779$var$removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const $7512d6d6ef34b779$var$brokenSelectBetweenUneditable = $7512d6d6ef34b779$var$safari || $7512d6d6ef34b779$var$chrome && $7512d6d6ef34b779$var$chrome_version < 63;
function $7512d6d6ef34b779$var$temporarilyEditableNear(view, pos) {
    let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if ($7512d6d6ef34b779$var$safari && after && after.contentEditable == "false") return $7512d6d6ef34b779$var$setEditable(after);
    if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
        if (after) return $7512d6d6ef34b779$var$setEditable(after);
        else if (before) return $7512d6d6ef34b779$var$setEditable(before);
    }
}
function $7512d6d6ef34b779$var$setEditable(element) {
    element.contentEditable = "true";
    if ($7512d6d6ef34b779$var$safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function $7512d6d6ef34b779$var$resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function $7512d6d6ef34b779$var$removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(()=>{
                if (!$7512d6d6ef34b779$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function $7512d6d6ef34b779$var$selectCursorWrapper(view) {
    let domSel = view.domSelection();
    if (!domSel) return;
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img) domSel.collapse(node.parentNode, $7512d6d6ef34b779$var$domIndex(node) + 1);
    else domSel.collapse(node, 0);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && $7512d6d6ef34b779$var$ie && $7512d6d6ef34b779$var$ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function $7512d6d6ef34b779$var$syncNodeSelection(view, sel) {
    if (sel instanceof (0, $cw0wu.NodeSelection)) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            $7512d6d6ef34b779$var$clearNodeSelection(view);
            if (desc) desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    } else $7512d6d6ef34b779$var$clearNodeSelection(view);
}
// Clear all DOM statefulness of the last node selection.
function $7512d6d6ef34b779$var$clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function $7512d6d6ef34b779$var$selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, $cw0wu.TextSelection).between($anchor, $head, bias);
}
function $7512d6d6ef34b779$var$hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus()) return false;
    return $7512d6d6ef34b779$var$hasSelection(view);
}
function $7512d6d6ef34b779$var$hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    } catch (_) {
        return false;
    }
}
function $7512d6d6ef34b779$var$anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return $7512d6d6ef34b779$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function $7512d6d6ef34b779$var$moveSelectionBlock(state, dir) {
    let { $anchor: $anchor, $head: $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && (0, $cw0wu.Selection).findFrom($start, dir);
}
function $7512d6d6ef34b779$var$apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function $7512d6d6ef34b779$var$selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $cw0wu.TextSelection)) {
        if (mods.indexOf("s") > -1) {
            let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf) return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return $7512d6d6ef34b779$var$apply(view, new (0, $cw0wu.TextSelection)(sel.$anchor, $newHead));
        } else if (!sel.empty) return false;
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = $7512d6d6ef34b779$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, $cw0wu.NodeSelection)) return $7512d6d6ef34b779$var$apply(view, next);
            return false;
        } else if (!($7512d6d6ef34b779$var$mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText) return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
            if ((0, $cw0wu.NodeSelection).isSelectable(node)) return $7512d6d6ef34b779$var$apply(view, new (0, $cw0wu.NodeSelection)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            else if ($7512d6d6ef34b779$var$webkit) // Chrome and Safari will introduce extra pointless cursor
            // positions around inline uneditable nodes, so we have to
            // take over and move the cursor past them (#937)
            return $7512d6d6ef34b779$var$apply(view, new (0, $cw0wu.TextSelection)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            else return false;
        }
    } else if (sel instanceof (0, $cw0wu.NodeSelection) && sel.node.isInline) return $7512d6d6ef34b779$var$apply(view, new (0, $cw0wu.TextSelection)(dir > 0 ? sel.$to : sel.$from));
    else {
        let next = $7512d6d6ef34b779$var$moveSelectionBlock(view.state, dir);
        if (next) return $7512d6d6ef34b779$var$apply(view, next);
        return false;
    }
}
function $7512d6d6ef34b779$var$nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $7512d6d6ef34b779$var$isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function $7512d6d6ef34b779$var$skipIgnoredNodes(view, dir) {
    return dir < 0 ? $7512d6d6ef34b779$var$skipIgnoredNodesBefore(view) : $7512d6d6ef34b779$var$skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function $7512d6d6ef34b779$var$skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if ($7512d6d6ef34b779$var$gecko && node.nodeType == 1 && offset < $7512d6d6ef34b779$var$nodeLen(node) && $7512d6d6ef34b779$var$isIgnorable(node.childNodes[offset], -1)) force = true;
    for(;;){
        if (offset > 0) {
            if (node.nodeType != 1) break;
            else {
                let before = node.childNodes[offset - 1];
                if ($7512d6d6ef34b779$var$isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                } else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                } else break;
            }
        } else if ($7512d6d6ef34b779$var$isBlockNode(node)) break;
        else {
            let prev = node.previousSibling;
            while(prev && $7512d6d6ef34b779$var$isIgnorable(prev, -1)){
                moveNode = node.parentNode;
                moveOffset = $7512d6d6ef34b779$var$domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = 0;
            } else {
                node = prev;
                offset = $7512d6d6ef34b779$var$nodeLen(node);
            }
        }
    }
    if (force) $7512d6d6ef34b779$var$setSelFocus(view, node, offset);
    else if (moveNode) $7512d6d6ef34b779$var$setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function $7512d6d6ef34b779$var$skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let len = $7512d6d6ef34b779$var$nodeLen(node);
    let moveNode, moveOffset;
    for(;;){
        if (offset < len) {
            if (node.nodeType != 1) break;
            let after = node.childNodes[offset];
            if ($7512d6d6ef34b779$var$isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            } else break;
        } else if ($7512d6d6ef34b779$var$isBlockNode(node)) break;
        else {
            let next = node.nextSibling;
            while(next && $7512d6d6ef34b779$var$isIgnorable(next, 1)){
                moveNode = next.parentNode;
                moveOffset = $7512d6d6ef34b779$var$domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = len = 0;
            } else {
                node = next;
                offset = 0;
                len = $7512d6d6ef34b779$var$nodeLen(node);
            }
        }
    }
    if (moveNode) $7512d6d6ef34b779$var$setSelFocus(view, moveNode, moveOffset);
}
function $7512d6d6ef34b779$var$isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function $7512d6d6ef34b779$var$textNodeAfter(node, offset) {
    while(node && offset == node.childNodes.length && !$7512d6d6ef34b779$var$hasBlockDesc(node)){
        offset = $7512d6d6ef34b779$var$domIndex(node) + 1;
        node = node.parentNode;
    }
    while(node && offset < node.childNodes.length){
        let next = node.childNodes[offset];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = 0;
    }
}
function $7512d6d6ef34b779$var$textNodeBefore(node, offset) {
    while(node && !offset && !$7512d6d6ef34b779$var$hasBlockDesc(node)){
        offset = $7512d6d6ef34b779$var$domIndex(node);
        node = node.parentNode;
    }
    while(node && offset){
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = node.childNodes.length;
    }
}
function $7512d6d6ef34b779$var$setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = $7512d6d6ef34b779$var$textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        } else if (before = $7512d6d6ef34b779$var$textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if (!sel) return;
    if ($7512d6d6ef34b779$var$selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (sel.extend) sel.extend(node, offset);
    view.domObserver.setCurSelection();
    let { state: state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(()=>{
        if (view.state == state) $7512d6d6ef34b779$var$selectionToDOM(view);
    }, 50);
}
function $7512d6d6ef34b779$var$findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!($7512d6d6ef34b779$var$chrome || $7512d6d6ef34b779$var$windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function $7512d6d6ef34b779$var$selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $cw0wu.TextSelection) && !sel.empty || mods.indexOf("s") > -1) return false;
    if ($7512d6d6ef34b779$var$mac && mods.indexOf("m") > -1) return false;
    let { $from: $from, $to: $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = $7512d6d6ef34b779$var$moveSelectionBlock(view.state, dir);
        if (next && next instanceof (0, $cw0wu.NodeSelection)) return $7512d6d6ef34b779$var$apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof (0, $cw0wu.AllSelection) ? (0, $cw0wu.Selection).near(side, dir) : (0, $cw0wu.Selection).findFrom(side, dir);
        return beyond ? $7512d6d6ef34b779$var$apply(view, beyond) : false;
    }
    return false;
}
function $7512d6d6ef34b779$var$stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof (0, $cw0wu.TextSelection))) return true;
    let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
    if (!$head.sameParent($anchor)) return true;
    if (!empty) return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function $7512d6d6ef34b779$var$switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function $7512d6d6ef34b779$var$safariDownArrowBug(view) {
    if (!$7512d6d6ef34b779$var$safari || view.state.selection.$head.parentOffset > 0) return false;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        $7512d6d6ef34b779$var$switchEditable(view, child, "true");
        setTimeout(()=>$7512d6d6ef34b779$var$switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function $7512d6d6ef34b779$var$getMods(event) {
    let result = "";
    if (event.ctrlKey) result += "c";
    if (event.metaKey) result += "m";
    if (event.altKey) result += "a";
    if (event.shiftKey) result += "s";
    return result;
}
function $7512d6d6ef34b779$var$captureKeyDown(view, event) {
    let code = event.keyCode, mods = $7512d6d6ef34b779$var$getMods(event);
    if (code == 8 || $7512d6d6ef34b779$var$mac && code == 72 && mods == "c") return $7512d6d6ef34b779$var$stopNativeHorizontalDelete(view, -1) || $7512d6d6ef34b779$var$skipIgnoredNodes(view, -1);
    else if (code == 46 && !event.shiftKey || $7512d6d6ef34b779$var$mac && code == 68 && mods == "c") return $7512d6d6ef34b779$var$stopNativeHorizontalDelete(view, 1) || $7512d6d6ef34b779$var$skipIgnoredNodes(view, 1);
    else if (code == 13 || code == 27) return true;
    else if (code == 37 || $7512d6d6ef34b779$var$mac && code == 66 && mods == "c") {
        let dir = code == 37 ? $7512d6d6ef34b779$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
        return $7512d6d6ef34b779$var$selectHorizontally(view, dir, mods) || $7512d6d6ef34b779$var$skipIgnoredNodes(view, dir);
    } else if (code == 39 || $7512d6d6ef34b779$var$mac && code == 70 && mods == "c") {
        let dir = code == 39 ? $7512d6d6ef34b779$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
        return $7512d6d6ef34b779$var$selectHorizontally(view, dir, mods) || $7512d6d6ef34b779$var$skipIgnoredNodes(view, dir);
    } else if (code == 38 || $7512d6d6ef34b779$var$mac && code == 80 && mods == "c") return $7512d6d6ef34b779$var$selectVertically(view, -1, mods) || $7512d6d6ef34b779$var$skipIgnoredNodes(view, -1);
    else if (code == 40 || $7512d6d6ef34b779$var$mac && code == 78 && mods == "c") return $7512d6d6ef34b779$var$safariDownArrowBug(view) || $7512d6d6ef34b779$var$selectVertically(view, 1, mods) || $7512d6d6ef34b779$var$skipIgnoredNodes(view, 1);
    else if (mods == ($7512d6d6ef34b779$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
    return false;
}
function $7512d6d6ef34b779$var$serializeForClipboard(view, slice) {
    view.someProp("transformCopied", (f)=>{
        slice = f(slice, view);
    });
    let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
    while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || (0, $kW8qW.DOMSerializer).fromSchema(view.state.schema);
    let doc = $7512d6d6ef34b779$var$detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, {
        document: doc
    }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while(firstChild && firstChild.nodeType == 1 && (needsWrap = $7512d6d6ef34b779$var$wrapMap[firstChild.nodeName.toLowerCase()])){
        for(let i = needsWrap.length - 1; i >= 0; i--){
            let wrapper = doc.createElement(needsWrap[i]);
            while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
    return {
        dom: wrap,
        text: text,
        slice: slice
    };
}
// Read a slice of content from the clipboard (or drop data).
function $7512d6d6ef34b779$var$parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text) return null;
    let asText = !!text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", (f)=>{
            text = f(text, inCode || plainText, view);
        });
        if (inCode) {
            slice = new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0);
            view.someProp("transformPasted", (f)=>{
                slice = f(slice, view, true);
            });
            return slice;
        }
        let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
        if (parsed) slice = parsed;
        else {
            let marks = $context.marks();
            let { schema: schema } = view.state, serializer = (0, $kW8qW.DOMSerializer).fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                let p = dom.appendChild(document.createElement("p"));
                if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    } else {
        view.someProp("transformPastedHTML", (f)=>{
            html = f(html, view);
        });
        dom = $7512d6d6ef34b779$var$readHTML(html);
        if ($7512d6d6ef34b779$var$webkit) $7512d6d6ef34b779$var$restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
        let child = dom.firstChild;
        while(child && child.nodeType != 1)child = child.nextSibling;
        if (!child) break;
        dom = child;
    }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, $kW8qW.DOMParser).fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode (dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$7512d6d6ef34b779$var$inlineParents.test(dom.parentNode.nodeName)) return {
                    ignore: true
                };
                return null;
            }
        });
    }
    if (sliceData) slice = $7512d6d6ef34b779$var$addContext($7512d6d6ef34b779$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    else {
        slice = (0, $kW8qW.Slice).maxOpen($7512d6d6ef34b779$var$normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
            for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
            slice = $7512d6d6ef34b779$var$closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", (f)=>{
        slice = f(slice, view, asText);
    });
    return slice;
}
const $7512d6d6ef34b779$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function $7512d6d6ef34b779$var$normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2) return fragment;
    for(let d = $context.depth; d >= 0; d--){
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach((node)=>{
            if (!result) return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap) return result = null;
            if (inLast = result.length && lastWrap.length && $7512d6d6ef34b779$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
            else {
                if (result.length) result[result.length - 1] = $7512d6d6ef34b779$var$closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = $7512d6d6ef34b779$var$withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result) return (0, $kW8qW.Fragment).from(result);
    }
    return fragment;
}
function $7512d6d6ef34b779$var$withWrappers(node, wrap, from = 0) {
    for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, $kW8qW.Fragment).from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function $7512d6d6ef34b779$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = $7512d6d6ef34b779$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, $kW8qW.Fragment).from($7512d6d6ef34b779$var$withWrappers(node, wrap, depth + 1))));
    }
}
function $7512d6d6ef34b779$var$closeRight(node, depth) {
    if (depth == 0) return node;
    let fragment = node.content.replaceChild(node.childCount - 1, $7512d6d6ef34b779$var$closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore((0, $kW8qW.Fragment).empty, true);
    return node.copy(fragment.append(fill));
}
function $7512d6d6ef34b779$var$closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1) openEnd = 0;
    if (depth < to - 1) inner = $7512d6d6ef34b779$var$closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, $kW8qW.Fragment).empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function $7512d6d6ef34b779$var$closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart) slice = new (0, $kW8qW.Slice)($7512d6d6ef34b779$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd) slice = new (0, $kW8qW.Slice)($7512d6d6ef34b779$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const $7512d6d6ef34b779$var$wrapMap = {
    thead: [
        "table"
    ],
    tbody: [
        "table"
    ],
    tfoot: [
        "table"
    ],
    caption: [
        "table"
    ],
    colgroup: [
        "table"
    ],
    col: [
        "table",
        "colgroup"
    ],
    tr: [
        "table",
        "tbody"
    ],
    td: [
        "table",
        "tbody",
        "tr"
    ],
    th: [
        "table",
        "tbody",
        "tr"
    ]
};
let $7512d6d6ef34b779$var$_detachedDoc = null;
function $7512d6d6ef34b779$var$detachedDoc() {
    return $7512d6d6ef34b779$var$_detachedDoc || ($7512d6d6ef34b779$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
}
let $7512d6d6ef34b779$var$_policy = null;
function $7512d6d6ef34b779$var$maybeWrapTrusted(html) {
    let trustedTypes = window.trustedTypes;
    if (!trustedTypes) return html;
    // With the require-trusted-types-for CSP, Chrome will block
    // innerHTML, even on a detached document. This wraps the string in
    // a way that makes the browser allow us to use its parser again.
    if (!$7512d6d6ef34b779$var$_policy) $7512d6d6ef34b779$var$_policy = trustedTypes.defaultPolicy || trustedTypes.createPolicy("ProseMirrorClipboard", {
        createHTML: (s)=>s
    });
    return $7512d6d6ef34b779$var$_policy.createHTML(html);
}
function $7512d6d6ef34b779$var$readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas) html = html.slice(metas[0].length);
    let elt = $7512d6d6ef34b779$var$detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && $7512d6d6ef34b779$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
    elt.innerHTML = $7512d6d6ef34b779$var$maybeWrapTrusted(html);
    if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function $7512d6d6ef34b779$var$restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll($7512d6d6ef34b779$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for(let i = 0; i < nodes.length; i++){
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\u00a0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function $7512d6d6ef34b779$var$addContext(slice, context) {
    if (!slice.size) return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    } catch (e) {
        return slice;
    }
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    for(let i = array.length - 2; i >= 0; i -= 2){
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs()) break;
        content = (0, $kW8qW.Fragment).from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new (0, $kW8qW.Slice)(content, openStart, openEnd);
}
// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const $7512d6d6ef34b779$var$handlers = {};
const $7512d6d6ef34b779$var$editHandlers = {};
const $7512d6d6ef34b779$var$passiveHandlers = {
    touchstart: true,
    touchmove: true
};
class $7512d6d6ef34b779$var$InputState {
    constructor(){
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = {
            time: 0,
            x: 0,
            y: 0,
            type: "",
            button: 0
        };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastChromeDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -200000000;
        this.compositionID = 1;
        this.badSafariComposition = false;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function $7512d6d6ef34b779$var$initInput(view) {
    for(let event in $7512d6d6ef34b779$var$handlers){
        let handler = $7512d6d6ef34b779$var$handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
            if ($7512d6d6ef34b779$var$eventBelongsToView(view, event) && !$7512d6d6ef34b779$var$runCustomHandler(view, event) && (view.editable || !(event.type in $7512d6d6ef34b779$var$editHandlers))) handler(view, event);
        }, $7512d6d6ef34b779$var$passiveHandlers[event] ? {
            passive: true
        } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if ($7512d6d6ef34b779$var$safari) view.dom.addEventListener("input", ()=>null);
    $7512d6d6ef34b779$var$ensureListeners(view);
}
function $7512d6d6ef34b779$var$setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function $7512d6d6ef34b779$var$destroyInput(view) {
    view.domObserver.stop();
    for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function $7512d6d6ef34b779$var$ensureListeners(view) {
    view.someProp("handleDOMEvents", (currentHandlers)=>{
        for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$7512d6d6ef34b779$var$runCustomHandler(view, event));
    });
}
function $7512d6d6ef34b779$var$runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", (handlers)=>{
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function $7512d6d6ef34b779$var$eventBelongsToView(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
    return true;
}
function $7512d6d6ef34b779$var$dispatchEvent(view, event) {
    if (!$7512d6d6ef34b779$var$runCustomHandler(view, event) && $7512d6d6ef34b779$var$handlers[event.type] && (view.editable || !(event.type in $7512d6d6ef34b779$var$editHandlers))) $7512d6d6ef34b779$var$handlers[event.type](view, event);
}
$7512d6d6ef34b779$var$editHandlers.keydown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if ($7512d6d6ef34b779$var$inOrNearComposition(view, event)) return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if ($7512d6d6ef34b779$var$android && $7512d6d6ef34b779$var$chrome && event.keyCode == 13) return;
    if (event.keyCode != 229) view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if ($7512d6d6ef34b779$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", (f)=>f(view, $7512d6d6ef34b779$var$keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $7512d6d6ef34b779$var$captureKeyDown(view, event)) event.preventDefault();
    else $7512d6d6ef34b779$var$setSelectionOrigin(view, "key");
};
$7512d6d6ef34b779$var$editHandlers.keyup = (view, event)=>{
    if (event.keyCode == 16) view.input.shiftKey = false;
};
$7512d6d6ef34b779$var$editHandlers.keypress = (view, _event)=>{
    let event = _event;
    if ($7512d6d6ef34b779$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $7512d6d6ef34b779$var$mac && event.metaKey) return;
    if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof (0, $cw0wu.TextSelection)) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        let deflt = ()=>view.state.tr.insertText(text).scrollIntoView();
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text, deflt))) view.dispatch(deflt());
        event.preventDefault();
    }
};
function $7512d6d6ef34b779$var$eventCoords(event) {
    return {
        left: event.clientX,
        top: event.clientY
    };
}
function $7512d6d6ef34b779$var$isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function $7512d6d6ef34b779$var$runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
    }
    return false;
}
function $7512d6d6ef34b779$var$updateSelection(view, selection, origin) {
    if (!view.focused) view.focus();
    if (view.state.selection.eq(selection)) return;
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer") tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function $7512d6d6ef34b779$var$selectClickedLeaf(view, inside) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && (0, $cw0wu.NodeSelection).isSelectable(node)) {
        $7512d6d6ef34b779$var$updateSelection(view, new (0, $cw0wu.NodeSelection)($pos), "pointer");
        return true;
    }
    return false;
}
function $7512d6d6ef34b779$var$selectClickedNode(view, inside) {
    if (inside == -1) return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof (0, $cw0wu.NodeSelection)) selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if ((0, $cw0wu.NodeSelection).isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
            else selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        $7512d6d6ef34b779$var$updateSelection(view, (0, $cw0wu.NodeSelection).create(view.state.doc, selectAt), "pointer");
        return true;
    } else return false;
}
function $7512d6d6ef34b779$var$handleSingleClick(view, pos, inside, event, selectNode) {
    return $7512d6d6ef34b779$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $7512d6d6ef34b779$var$selectClickedNode(view, inside) : $7512d6d6ef34b779$var$selectClickedLeaf(view, inside));
}
function $7512d6d6ef34b779$var$handleDoubleClick(view, pos, inside, event) {
    return $7512d6d6ef34b779$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
}
function $7512d6d6ef34b779$var$handleTripleClick(view, pos, inside, event) {
    return $7512d6d6ef34b779$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $7512d6d6ef34b779$var$defaultTripleClick(view, inside, event);
}
function $7512d6d6ef34b779$var$defaultTripleClick(view, inside, event) {
    if (event.button != 0) return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            $7512d6d6ef34b779$var$updateSelection(view, (0, $cw0wu.TextSelection).create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent) $7512d6d6ef34b779$var$updateSelection(view, (0, $cw0wu.TextSelection).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if ((0, $cw0wu.NodeSelection).isSelectable(node)) $7512d6d6ef34b779$var$updateSelection(view, (0, $cw0wu.NodeSelection).create(doc, nodePos), "pointer");
        else continue;
        return true;
    }
}
function $7512d6d6ef34b779$var$forceDOMFlush(view) {
    return $7512d6d6ef34b779$var$endComposition(view);
}
const $7512d6d6ef34b779$var$selectNodeModifier = $7512d6d6ef34b779$var$mac ? "metaKey" : "ctrlKey";
$7512d6d6ef34b779$var$handlers.mousedown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = $7512d6d6ef34b779$var$forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && $7512d6d6ef34b779$var$isNear(event, view.input.lastClick) && !event[$7512d6d6ef34b779$var$selectNodeModifier] && view.input.lastClick.button == event.button) {
        if (view.input.lastClick.type == "singleClick") type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
    }
    view.input.lastClick = {
        time: now,
        x: event.clientX,
        y: event.clientY,
        type: type,
        button: event.button
    };
    let pos = view.posAtCoords($7512d6d6ef34b779$var$eventCoords(event));
    if (!pos) return;
    if (type == "singleClick") {
        if (view.input.mouseDown) view.input.mouseDown.done();
        view.input.mouseDown = new $7512d6d6ef34b779$var$MouseDown(view, pos, event, !!flushed);
    } else if ((type == "doubleClick" ? $7512d6d6ef34b779$var$handleDoubleClick : $7512d6d6ef34b779$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
    else $7512d6d6ef34b779$var$setSelectionOrigin(view, "pointer");
};
class $7512d6d6ef34b779$var$MouseDown {
    constructor(view, pos, event, flushed){
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[$7512d6d6ef34b779$var$selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        } else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.nodeDOM.nodeType == 1 ? targetDesc.nodeDOM : null;
        let { selection: selection } = view.state;
        if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, $cw0wu.NodeSelection) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
            node: targetNode,
            pos: targetPos,
            addAttr: !!(this.target && !this.target.draggable),
            setUneditable: !!(this.target && $7512d6d6ef34b779$var$gecko && !this.target.hasAttribute("contentEditable"))
        };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.draggable = true;
            if (this.mightDrag.setUneditable) setTimeout(()=>{
                if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
            }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        $7512d6d6ef34b779$var$setSelectionOrigin(view, "pointer");
    }
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync) setTimeout(()=>$7512d6d6ef34b779$var$selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target)) return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($7512d6d6ef34b779$var$eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) $7512d6d6ef34b779$var$setSelectionOrigin(this.view, "pointer");
        else if ($7512d6d6ef34b779$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
        else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
        $7512d6d6ef34b779$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
        // cursor, but still report that the node is selected
        // when asked through getSelection. You'll then get a
        // situation where clicking at the point where that
        // (hidden) cursor is doesn't change the selection, and
        // thus doesn't get a reaction from ProseMirror. This
        // works around that.
        $7512d6d6ef34b779$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
            $7512d6d6ef34b779$var$updateSelection(this.view, (0, $cw0wu.Selection).near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        } else $7512d6d6ef34b779$var$setSelectionOrigin(this.view, "pointer");
    }
    move(event) {
        this.updateAllowDefault(event);
        $7512d6d6ef34b779$var$setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0) this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
}
$7512d6d6ef34b779$var$handlers.touchstart = (view)=>{
    view.input.lastTouch = Date.now();
    $7512d6d6ef34b779$var$forceDOMFlush(view);
    $7512d6d6ef34b779$var$setSelectionOrigin(view, "pointer");
};
$7512d6d6ef34b779$var$handlers.touchmove = (view)=>{
    view.input.lastTouch = Date.now();
    $7512d6d6ef34b779$var$setSelectionOrigin(view, "pointer");
};
$7512d6d6ef34b779$var$handlers.contextmenu = (view)=>$7512d6d6ef34b779$var$forceDOMFlush(view);
function $7512d6d6ef34b779$var$inOrNearComposition(view, event) {
    if (view.composing) return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if ($7512d6d6ef34b779$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -200000000;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const $7512d6d6ef34b779$var$timeoutComposition = $7512d6d6ef34b779$var$android ? 5000 : -1;
$7512d6d6ef34b779$var$editHandlers.compositionstart = $7512d6d6ef34b779$var$editHandlers.compositionupdate = (view)=>{
    if (!view.composing) {
        view.domObserver.flush();
        let { state: state } = view, $pos = state.selection.$to;
        if (state.selection instanceof (0, $cw0wu.TextSelection) && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false) || $7512d6d6ef34b779$var$chrome && $7512d6d6ef34b779$var$windows && $7512d6d6ef34b779$var$selectionBeforeUneditable(view))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            $7512d6d6ef34b779$var$endComposition(view, true);
            view.markCursor = null;
        } else {
            $7512d6d6ef34b779$var$endComposition(view, !state.selection.empty);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if ($7512d6d6ef34b779$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before) break;
                    if (before.nodeType == 3) {
                        let sel = view.domSelection();
                        if (sel) sel.collapse(before, before.nodeValue.length);
                        break;
                    } else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    $7512d6d6ef34b779$var$scheduleComposeEnd(view, $7512d6d6ef34b779$var$timeoutComposition);
};
function $7512d6d6ef34b779$var$selectionBeforeUneditable(view) {
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (!focusNode || focusNode.nodeType != 1 || focusOffset >= focusNode.childNodes.length) return false;
    let next = focusNode.childNodes[focusOffset];
    return next.nodeType == 1 && next.contentEditable == "false";
}
$7512d6d6ef34b779$var$editHandlers.compositionend = (view, event)=>{
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.badSafariComposition) view.domObserver.forceFlush();
        else if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
        view.input.compositionID++;
        $7512d6d6ef34b779$var$scheduleComposeEnd(view, 20);
    }
};
function $7512d6d6ef34b779$var$scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1) view.input.composingTimeout = setTimeout(()=>$7512d6d6ef34b779$var$endComposition(view), delay);
}
function $7512d6d6ef34b779$var$clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = $7512d6d6ef34b779$var$timestampFromCustomEvent();
    }
    while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
}
function $7512d6d6ef34b779$var$findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode) return null;
    let textBefore = $7512d6d6ef34b779$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = $7512d6d6ef34b779$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
        }
    }
    return textBefore || textAfter;
}
function $7512d6d6ef34b779$var$timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/ function $7512d6d6ef34b779$var$endComposition(view, restarting = false) {
    if ($7512d6d6ef34b779$var$android && view.domObserver.flushingSoon >= 0) return;
    view.domObserver.forceFlush();
    $7512d6d6ef34b779$var$clearComposition(view);
    if (restarting || view.docView && view.docView.dirty) {
        let sel = $7512d6d6ef34b779$var$selectionFromDOM(view), cur = view.state.selection;
        if (sel && !sel.eq(cur)) view.dispatch(view.state.tr.setSelection(sel));
        else if ((view.markCursor || restarting) && !cur.$from.node(cur.$from.sharedDepth(cur.to)).inlineContent) view.dispatch(view.state.tr.deleteSelection());
        else view.updateState(view.state);
        return true;
    }
    return false;
}
function $7512d6d6ef34b779$var$captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode) return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(()=>{
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $7512d6d6ef34b779$var$brokenClipboardAPI = $7512d6d6ef34b779$var$ie && $7512d6d6ef34b779$var$ie_version < 15 || $7512d6d6ef34b779$var$ios && $7512d6d6ef34b779$var$webkit_version < 604;
$7512d6d6ef34b779$var$handlers.copy = $7512d6d6ef34b779$var$editHandlers.cut = (view, _event)=>{
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty) return;
    // IE and Edge's clipboard interface is completely broken
    let data = $7512d6d6ef34b779$var$brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom: dom, text: text } = $7512d6d6ef34b779$var$serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    } else $7512d6d6ef34b779$var$captureCopy(view, dom);
    if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function $7512d6d6ef34b779$var$sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function $7512d6d6ef34b779$var$capturePaste(view, event) {
    if (!view.dom.parentNode) return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText) target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(()=>{
        view.focus();
        if (target.parentNode) target.parentNode.removeChild(target);
        if (plainText) $7512d6d6ef34b779$var$doPaste(view, target.value, null, plain, event);
        else $7512d6d6ef34b779$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function $7512d6d6ef34b779$var$doPaste(view, text, html, preferPlain, event) {
    let slice = $7512d6d6ef34b779$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, $kW8qW.Slice).empty))) return true;
    if (!slice) return false;
    let singleNode = $7512d6d6ef34b779$var$sliceSingleNode(slice);
    let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function $7512d6d6ef34b779$var$getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text) return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
$7512d6d6ef34b779$var$editHandlers.paste = (view, _event)=>{
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !$7512d6d6ef34b779$var$android) return;
    let data = $7512d6d6ef34b779$var$brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && $7512d6d6ef34b779$var$doPaste(view, $7512d6d6ef34b779$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
    else $7512d6d6ef34b779$var$capturePaste(view, event);
};
class $7512d6d6ef34b779$var$Dragging {
    constructor(slice, move, node){
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const $7512d6d6ef34b779$var$dragCopyModifier = $7512d6d6ef34b779$var$mac ? "altKey" : "ctrlKey";
function $7512d6d6ef34b779$var$dragMoves(view, event) {
    let moves = view.someProp("dragCopies", (test)=>!test(event));
    return moves != null ? moves : !event[$7512d6d6ef34b779$var$dragCopyModifier];
}
$7512d6d6ef34b779$var$handlers.dragstart = (view, _event)=>{
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown) mouseDown.done();
    if (!event.dataTransfer) return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords($7512d6d6ef34b779$var$eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, $cw0wu.NodeSelection) ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) node = (0, $cw0wu.NodeSelection).create(view.state.doc, mouseDown.mightDrag.pos);
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, $cw0wu.NodeSelection).create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom: dom, text: text, slice: slice } = $7512d6d6ef34b779$var$serializeForClipboard(view, draggedSlice);
    // Pre-120 Chrome versions clear files when calling `clearData` (#1472)
    if (!event.dataTransfer.files.length || !$7512d6d6ef34b779$var$chrome || $7512d6d6ef34b779$var$chrome_version > 120) event.dataTransfer.clearData();
    event.dataTransfer.setData($7512d6d6ef34b779$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!$7512d6d6ef34b779$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
    view.dragging = new $7512d6d6ef34b779$var$Dragging(slice, $7512d6d6ef34b779$var$dragMoves(view, event), node);
};
$7512d6d6ef34b779$var$handlers.dragend = (view)=>{
    let dragging = view.dragging;
    window.setTimeout(()=>{
        if (view.dragging == dragging) view.dragging = null;
    }, 50);
};
$7512d6d6ef34b779$var$editHandlers.dragover = $7512d6d6ef34b779$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
$7512d6d6ef34b779$var$editHandlers.drop = (view, event)=>{
    try {
        $7512d6d6ef34b779$var$handleDrop(view, event, view.dragging);
    } finally{
        view.dragging = null;
    }
};
function $7512d6d6ef34b779$var$handleDrop(view, event, dragging) {
    if (!event.dataTransfer) return;
    let eventPos = view.posAtCoords($7512d6d6ef34b779$var$eventCoords(event));
    if (!eventPos) return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) view.someProp("transformPasted", (f)=>{
        slice = f(slice, view, false);
    });
    else slice = $7512d6d6ef34b779$var$parseFromClipboard(view, $7512d6d6ef34b779$var$getText(event.dataTransfer), $7512d6d6ef34b779$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    let move = !!(dragging && $7512d6d6ef34b779$var$dragMoves(view, event));
    if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, $kW8qW.Slice).empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice) return;
    event.preventDefault();
    let insertPos = slice ? (0, $3DNV7.dropPoint)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null) insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node: node } = dragging;
        if (node) node.replace(tr);
        else tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert)) return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && (0, $cw0wu.NodeSelection).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, $cw0wu.NodeSelection)($pos));
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
        tr.setSelection($7512d6d6ef34b779$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
}
$7512d6d6ef34b779$var$handlers.focus = (view)=>{
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(()=>{
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $7512d6d6ef34b779$var$selectionToDOM(view);
        }, 20);
    }
};
$7512d6d6ef34b779$var$handlers.blur = (view, _event)=>{
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
$7512d6d6ef34b779$var$handlers.beforeinput = (view, _event)=>{
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if ($7512d6d6ef34b779$var$chrome && $7512d6d6ef34b779$var$android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount: domChangeCount } = view.input;
        setTimeout(()=>{
            if (view.input.domChangeCount != domChangeCount) return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", (f)=>f(view, $7512d6d6ef34b779$var$keyEvent(8, "Backspace")))) return;
            let { $cursor: $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for(let prop in $7512d6d6ef34b779$var$editHandlers)$7512d6d6ef34b779$var$handlers[prop] = $7512d6d6ef34b779$var$editHandlers[prop];
function $7512d6d6ef34b779$var$compareObjs(a, b) {
    if (a == b) return true;
    for(let p in a)if (a[p] !== b[p]) return false;
    for(let p in b)if (!(p in a)) return false;
    return true;
}
class $7512d6d6ef34b779$var$WidgetType {
    constructor(toDOM, spec){
        this.toDOM = toDOM;
        this.spec = spec || $7512d6d6ef34b779$var$noSpec;
        this.side = this.spec.side || 0;
    }
    map(mapping, span, offset, oldOffset) {
        let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new $7512d6d6ef34b779$export$10e30b733df217ea(pos - offset, pos - offset, this);
    }
    valid() {
        return true;
    }
    eq(other) {
        return this == other || other instanceof $7512d6d6ef34b779$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $7512d6d6ef34b779$var$compareObjs(this.spec, other.spec));
    }
    destroy(node) {
        if (this.spec.destroy) this.spec.destroy(node);
    }
}
class $7512d6d6ef34b779$var$InlineType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $7512d6d6ef34b779$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new $7512d6d6ef34b779$export$10e30b733df217ea(from, to, this);
    }
    valid(_, span) {
        return span.from < span.to;
    }
    eq(other) {
        return this == other || other instanceof $7512d6d6ef34b779$var$InlineType && $7512d6d6ef34b779$var$compareObjs(this.attrs, other.attrs) && $7512d6d6ef34b779$var$compareObjs(this.spec, other.spec);
    }
    static is(span) {
        return span.type instanceof $7512d6d6ef34b779$var$InlineType;
    }
    destroy() {}
}
class $7512d6d6ef34b779$var$NodeType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $7512d6d6ef34b779$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted) return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos) return null;
        return new $7512d6d6ef34b779$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index: index, offset: offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other || other instanceof $7512d6d6ef34b779$var$NodeType && $7512d6d6ef34b779$var$compareObjs(this.attrs, other.attrs) && $7512d6d6ef34b779$var$compareObjs(this.spec, other.spec);
    }
    destroy() {}
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/ class $7512d6d6ef34b779$export$10e30b733df217ea {
    /**
    @internal
    */ constructor(/**
    The start position of the decoration.
    */ from, /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */ to, /**
    @internal
    */ type){
        this.from = from;
        this.to = to;
        this.type = type;
    }
    /**
    @internal
    */ copy(from, to) {
        return new $7512d6d6ef34b779$export$10e30b733df217ea(from, to, this.type);
    }
    /**
    @internal
    */ eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */ map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */ static widget(pos, toDOM, spec) {
        return new $7512d6d6ef34b779$export$10e30b733df217ea(pos, pos, new $7512d6d6ef34b779$var$WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */ static inline(from, to, attrs, spec) {
        return new $7512d6d6ef34b779$export$10e30b733df217ea(from, to, new $7512d6d6ef34b779$var$InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */ static node(from, to, attrs, spec) {
        return new $7512d6d6ef34b779$export$10e30b733df217ea(from, to, new $7512d6d6ef34b779$var$NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */ get spec() {
        return this.type.spec;
    }
    /**
    @internal
    */ get inline() {
        return this.type instanceof $7512d6d6ef34b779$var$InlineType;
    }
    /**
    @internal
    */ get widget() {
        return this.type instanceof $7512d6d6ef34b779$var$WidgetType;
    }
}
const $7512d6d6ef34b779$var$none = [], $7512d6d6ef34b779$var$noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/ class $7512d6d6ef34b779$export$93bf62eb445cec98 {
    /**
    @internal
    */ constructor(local, children){
        this.local = local.length ? local : $7512d6d6ef34b779$var$none;
        this.children = children.length ? children : $7512d6d6ef34b779$var$none;
    }
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */ static create(doc, decorations) {
        return decorations.length ? $7512d6d6ef34b779$var$buildTree(decorations, doc, 0, $7512d6d6ef34b779$var$noSpec) : $7512d6d6ef34b779$var$empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */ find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for(let i = 0; i < this.local.length; i++){
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
        }
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
            let childOff = this.children[i] + 1;
            this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */ map(mapping, doc, options) {
        if (this == $7512d6d6ef34b779$var$empty || mapping.maps.length == 0) return this;
        return this.mapInner(mapping, doc, 0, 0, options || $7512d6d6ef34b779$var$noSpec);
    }
    /**
    @internal
    */ mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for(let i = 0; i < this.local.length; i++){
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove) options.onRemove(this.local[i].spec);
        }
        if (this.children.length) return $7512d6d6ef34b779$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else return newLocal ? new $7512d6d6ef34b779$export$93bf62eb445cec98(newLocal.sort($7512d6d6ef34b779$var$byPos), $7512d6d6ef34b779$var$none) : $7512d6d6ef34b779$var$empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */ add(doc, decorations) {
        if (!decorations.length) return this;
        if (this == $7512d6d6ef34b779$var$empty) return $7512d6d6ef34b779$export$93bf62eb445cec98.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset)=>{
            let baseOffset = childOffset + offset, found;
            if (!(found = $7512d6d6ef34b779$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
            if (!children) children = this.children.slice();
            while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
            if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $7512d6d6ef34b779$var$buildTree(found, childNode, baseOffset + 1, $7512d6d6ef34b779$var$noSpec));
            childIndex += 3;
        });
        let local = $7512d6d6ef34b779$var$moveSpans(childIndex ? $7512d6d6ef34b779$var$withoutNulls(decorations) : decorations, -offset);
        for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
        return new $7512d6d6ef34b779$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($7512d6d6ef34b779$var$byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */ remove(decorations) {
        if (decorations.length == 0 || this == $7512d6d6ef34b779$var$empty) return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for(let i = 0; i < children.length; i += 3){
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                if (span.from > from && span.to < to) {
                    decorations[j] = null;
                    (found || (found = [])).push(span);
                }
            }
            if (!found) continue;
            if (children == this.children) children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != $7512d6d6ef34b779$var$empty) children[i + 2] = removed;
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length) {
            for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                    if (local == this.local) local = this.local.slice();
                    local.splice(j--, 1);
                }
            }
        }
        if (children == this.children && local == this.local) return this;
        return local.length || children.length ? new $7512d6d6ef34b779$export$93bf62eb445cec98(local, children) : $7512d6d6ef34b779$var$empty;
    }
    forChild(offset, node) {
        if (this == $7512d6d6ef34b779$var$empty) return this;
        if (node.isLeaf) return $7512d6d6ef34b779$export$93bf62eb445cec98.empty;
        let child, local;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
            if (this.children[i] == offset) child = this.children[i + 2];
            break;
        }
        let start = offset + 1, end = start + node.content.size;
        for(let i = 0; i < this.local.length; i++){
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && dec.type instanceof $7512d6d6ef34b779$var$InlineType) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to) (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new $7512d6d6ef34b779$export$93bf62eb445cec98(local.sort($7512d6d6ef34b779$var$byPos), $7512d6d6ef34b779$var$none);
            return child ? new $7512d6d6ef34b779$var$DecorationGroup([
                localSet,
                child
            ]) : localSet;
        }
        return child || $7512d6d6ef34b779$var$empty;
    }
    /**
    @internal
    */ eq(other) {
        if (this == other) return true;
        if (!(other instanceof $7512d6d6ef34b779$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
        for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
        return true;
    }
    /**
    @internal
    */ locals(node) {
        return $7512d6d6ef34b779$var$removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */ localsInner(node) {
        if (this == $7512d6d6ef34b779$var$empty) return $7512d6d6ef34b779$var$none;
        if (node.inlineContent || !this.local.some($7512d6d6ef34b779$var$InlineType.is)) return this.local;
        let result = [];
        for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $7512d6d6ef34b779$var$InlineType)) result.push(this.local[i]);
        return result;
    }
    forEachSet(f) {
        f(this);
    }
}
/**
The empty set of decorations.
*/ $7512d6d6ef34b779$export$93bf62eb445cec98.empty = new $7512d6d6ef34b779$export$93bf62eb445cec98([], []);
/**
@internal
*/ $7512d6d6ef34b779$export$93bf62eb445cec98.removeOverlap = $7512d6d6ef34b779$var$removeOverlap;
const $7512d6d6ef34b779$var$empty = $7512d6d6ef34b779$export$93bf62eb445cec98.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class $7512d6d6ef34b779$var$DecorationGroup {
    constructor(members){
        this.members = members;
    }
    map(mapping, doc) {
        const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $7512d6d6ef34b779$var$noSpec));
        return $7512d6d6ef34b779$var$DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf) return $7512d6d6ef34b779$export$93bf62eb445cec98.empty;
        let found = [];
        for(let i = 0; i < this.members.length; i++){
            let result = this.members[i].forChild(offset, child);
            if (result == $7512d6d6ef34b779$var$empty) continue;
            if (result instanceof $7512d6d6ef34b779$var$DecorationGroup) found = found.concat(result.members);
            else found.push(result);
        }
        return $7512d6d6ef34b779$var$DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof $7512d6d6ef34b779$var$DecorationGroup) || other.members.length != this.members.length) return false;
        for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for(let i = 0; i < this.members.length; i++){
            let locals = this.members[i].localsInner(node);
            if (!locals.length) continue;
            if (!result) result = locals;
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for(let j = 0; j < locals.length; j++)result.push(locals[j]);
            }
        }
        return result ? $7512d6d6ef34b779$var$removeOverlap(sorted ? result : result.sort($7512d6d6ef34b779$var$byPos)) : $7512d6d6ef34b779$var$none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch(members.length){
            case 0:
                return $7512d6d6ef34b779$var$empty;
            case 1:
                return members[0];
            default:
                return new $7512d6d6ef34b779$var$DecorationGroup(members.every((m)=>m instanceof $7512d6d6ef34b779$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $7512d6d6ef34b779$export$93bf62eb445cec98 ? m : m.members), []));
        }
    }
    forEachSet(f) {
        for(let i = 0; i < this.members.length; i++)this.members[i].forEachSet(f);
    }
}
function $7512d6d6ef34b779$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
            let dSize = newEnd - newStart - (oldEnd - oldStart);
            for(let i = 0; i < children.length; i += 3){
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved) continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
        if (children[i + 1] == -2) {
            mustRebuild = true;
            children[i + 1] = -1;
            continue;
        }
        let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
        if (fromLocal < 0 || fromLocal >= node.content.size) {
            mustRebuild = true;
            continue;
        }
        // Must read oldChildren because children was tagged with -1
        let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
        let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
        let childNode = node.maybeChild(index);
        if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
            let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
            if (mapped != $7512d6d6ef34b779$var$empty) {
                children[i] = fromLocal;
                children[i + 1] = toLocal;
                children[i + 2] = mapped;
            } else {
                children[i + 1] = -2;
                mustRebuild = true;
            }
        } else mustRebuild = true;
    }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = $7512d6d6ef34b779$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = $7512d6d6ef34b779$var$buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            children.splice(i, 3);
            i -= 3;
        }
        for(let i = 0, j = 0; i < built.children.length; i += 3){
            let from = built.children[i];
            while(j < children.length && children[j] < from)j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new $7512d6d6ef34b779$export$93bf62eb445cec98(newLocal.sort($7512d6d6ef34b779$var$byPos), children);
}
function $7512d6d6ef34b779$var$moveSpans(spans, offset) {
    if (!offset || !spans.length) return spans;
    let result = [];
    for(let i = 0; i < spans.length; i++){
        let span = spans[i];
        result.push(new $7512d6d6ef34b779$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function $7512d6d6ef34b779$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for(let i = 0; i < set.local.length; i++){
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped) decorations.push(mapped);
            else if (options.onRemove) options.onRemove(set.local[i].spec);
        }
        for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function $7512d6d6ef34b779$var$takeSpansForNode(spans, node, offset) {
    if (node.isLeaf) return null;
    let end = offset + node.nodeSize, found = null;
    for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
        (found || (found = [])).push(span);
        spans[i] = null;
    }
    return found;
}
function $7512d6d6ef34b779$var$withoutNulls(array) {
    let result = [];
    for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function $7512d6d6ef34b779$var$buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart)=>{
        let found = $7512d6d6ef34b779$var$takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = $7512d6d6ef34b779$var$buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != $7512d6d6ef34b779$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = $7512d6d6ef34b779$var$moveSpans(hasNulls ? $7512d6d6ef34b779$var$withoutNulls(spans) : spans, -offset).sort($7512d6d6ef34b779$var$byPos);
    for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
        if (options.onRemove) options.onRemove(locals[i].spec);
        locals.splice(i--, 1);
    }
    return locals.length || children.length ? new $7512d6d6ef34b779$export$93bf62eb445cec98(locals, children) : $7512d6d6ef34b779$var$empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function $7512d6d6ef34b779$var$byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function $7512d6d6ef34b779$var$removeOverlap(spans) {
    let working = spans;
    for(let i = 0; i < working.length - 1; i++){
        let span = working[i];
        if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
            let next = working[j];
            if (next.from == span.from) {
                if (next.to != span.to) {
                    if (working == spans) working = spans.slice();
                    // Followed by a partially overlapping larger span. Split that
                    // span.
                    working[j] = next.copy(next.from, span.to);
                    $7512d6d6ef34b779$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                }
                continue;
            } else {
                if (next.from < span.to) {
                    if (working == spans) working = spans.slice();
                    // The end of this one overlaps with a subsequent span. Split
                    // this one.
                    working[i] = span.copy(span.from, next.from);
                    $7512d6d6ef34b779$var$insertAhead(working, j, span.copy(next.from, span.to));
                }
                break;
            }
        }
    }
    return working;
}
function $7512d6d6ef34b779$var$insertAhead(array, i, deco) {
    while(i < array.length && $7512d6d6ef34b779$var$byPos(deco, array[i]) > 0)i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function $7512d6d6ef34b779$var$viewDecorations(view) {
    let found = [];
    view.someProp("decorations", (f)=>{
        let result = f(view.state);
        if (result && result != $7512d6d6ef34b779$var$empty) found.push(result);
    });
    if (view.cursorWrapper) found.push($7512d6d6ef34b779$export$93bf62eb445cec98.create(view.state.doc, [
        view.cursorWrapper.deco
    ]));
    return $7512d6d6ef34b779$var$DecorationGroup.from(found);
}
const $7512d6d6ef34b779$var$observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const $7512d6d6ef34b779$var$useCharData = $7512d6d6ef34b779$var$ie && $7512d6d6ef34b779$var$ie_version <= 11;
class $7512d6d6ef34b779$var$SelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
}
class $7512d6d6ef34b779$var$DOMObserver {
    constructor(view, handleDOMChange){
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new $7512d6d6ef34b779$var$SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
            for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
            if ($7512d6d6ef34b779$var$ie && $7512d6d6ef34b779$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) // IE11 will sometimes (on backspacing out a single character
            // text node after a BR node) call the observer callback
            // before actually updating the DOM, which will cause
            // ProseMirror to miss the change (see #930)
            this.flushSoon();
            else if ($7512d6d6ef34b779$var$safari && view.composing && mutations.some((m)=>m.type == "childList" && m.target.nodeName == "TR")) {
                // Safari does weird stuff when finishing a composition in a
                // table cell, which tends to involve inserting inappropriate
                // nodes in the table row.
                view.input.badSafariComposition = true;
                this.flushSoon();
            } else this.flush();
        });
        if ($7512d6d6ef34b779$var$useCharData) this.onCharData = (e)=>{
            this.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
    flushSoon() {
        if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
            this.flushingSoon = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, $7512d6d6ef34b779$var$observeOptions);
        }
        if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                window.setTimeout(()=>this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!$7512d6d6ef34b779$var$hasFocusAndSelection(this.view)) return;
        if (this.suppressingSelectionUpdates) return $7512d6d6ef34b779$var$selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if ($7512d6d6ef34b779$var$ie && $7512d6d6ef34b779$var$ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && $7512d6d6ef34b779$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode) return true;
        let ancestors = new Set, container;
        for(let scan = sel.focusNode; scan; scan = $7512d6d6ef34b779$var$parentNode(scan))ancestors.add(scan);
        for(let scan = sel.anchorNode; scan; scan = $7512d6d6ef34b779$var$parentNode(scan))if (ancestors.has(scan)) {
            container = scan;
            break;
        }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    flush() {
        let { view: view } = this;
        if (!view.docView || this.flushingSoon > -1) return;
        let mutations = this.pendingRecords();
        if (mutations.length) this.queue = [];
        let sel = view.domSelectionRange();
        let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $7512d6d6ef34b779$var$hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) for(let i = 0; i < mutations.length; i++){
            let result = this.registerMutation(mutations[i], added);
            if (result) {
                from = from < 0 ? result.from : Math.min(result.from, from);
                to = to < 0 ? result.to : Math.max(result.to, to);
                if (result.typeOver) typeOver = true;
            }
        }
        if ($7512d6d6ef34b779$var$gecko && added.length) {
            let brs = added.filter((n)=>n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                else a.remove();
            } else {
                let { focusNode: focusNode } = this.currentSelection;
                for (let br of brs){
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || $7512d6d6ef34b779$var$blockParent(view, focusNode) != parent)) br.remove();
                }
            }
        } else if (($7512d6d6ef34b779$var$chrome || $7512d6d6ef34b779$var$safari) && added.some((n)=>n.nodeName == "BR") && (view.input.lastKeyCode == 8 || view.input.lastKeyCode == 46)) {
            // Chrome/Safari sometimes insert a bogus break node if you
            // backspace out the last bit of text before an inline-flex node (#1552)
            for (let node of added)if (node.nodeName == "BR" && node.parentNode) {
                let after = node.nextSibling;
                if (after && after.nodeType == 1 && after.contentEditable == "false") node.parentNode.removeChild(node);
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $7512d6d6ef34b779$var$selectionCollapsed(sel) && (readSel = $7512d6d6ef34b779$var$selectionFromDOM(view)) && readSel.eq((0, $cw0wu.Selection).near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            $7512d6d6ef34b779$var$selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        } else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                $7512d6d6ef34b779$var$checkCSS(view);
            }
            if (view.input.badSafariComposition) {
                view.input.badSafariComposition = false;
                $7512d6d6ef34b779$var$fixUpBadSafariComposition(view, added);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty) view.updateState(view.state);
            else if (!this.currentSelection.eq(sel)) $7512d6d6ef34b779$var$selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1) return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
        mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
        if (!desc || desc.ignoreMutation(mut)) return null;
        if (mut.type == "childList") {
            for(let i = 0; i < mut.addedNodes.length; i++){
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3) this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                from: desc.posBefore,
                to: desc.posAfter
            };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if ($7512d6d6ef34b779$var$ie && $7512d6d6ef34b779$var$ie_version <= 11 && mut.addedNodes.length) // IE11 gives us incorrect next/prev siblings for some
            // insertions, so if there are added nodes, recompute those
            for(let i = 0; i < mut.addedNodes.length; i++){
                let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
            }
            let fromOffset = prev && prev.parentNode == mut.target ? $7512d6d6ef34b779$var$domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target ? $7512d6d6ef34b779$var$domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return {
                from: from,
                to: to
            };
        } else if (mut.type == "attributes") return {
            from: desc.posAtStart - desc.border,
            to: desc.posAtEnd + desc.border
        };
        else {
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
}
let $7512d6d6ef34b779$var$cssChecked = new WeakMap();
let $7512d6d6ef34b779$var$cssCheckWarned = false;
function $7512d6d6ef34b779$var$checkCSS(view) {
    if ($7512d6d6ef34b779$var$cssChecked.has(view)) return;
    $7512d6d6ef34b779$var$cssChecked.set(view, null);
    if ([
        'normal',
        'nowrap',
        'pre-line'
    ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = $7512d6d6ef34b779$var$gecko;
        if ($7512d6d6ef34b779$var$cssCheckWarned) return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        $7512d6d6ef34b779$var$cssCheckWarned = true;
    }
}
function $7512d6d6ef34b779$var$rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($7512d6d6ef34b779$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function $7512d6d6ef34b779$var$safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $7512d6d6ef34b779$var$rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? $7512d6d6ef34b779$var$rangeToSelectionRange(view, found) : null;
}
function $7512d6d6ef34b779$var$blockParent(view, node) {
    for(let p = node.parentNode; p && p != view.dom; p = p.parentNode){
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock) return p;
    }
    return null;
}
// Kludge for a Safari bug where, on ending a composition in an
// otherwise empty table cell, it randomly moves the composed text
// into the table row around that cell, greatly confusing everything
// (#188).
function $7512d6d6ef34b779$var$fixUpBadSafariComposition(view, addedNodes) {
    var _a;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    for (let node of addedNodes)if (((_a = node.parentNode) === null || _a === void 0 ? void 0 : _a.nodeName) == "TR") {
        let nextCell = node.nextSibling;
        while(nextCell && nextCell.nodeName != "TD" && nextCell.nodeName != "TH")nextCell = nextCell.nextSibling;
        if (nextCell) {
            let parent = nextCell;
            for(;;){
                let first = parent.firstChild;
                if (!first || first.nodeType != 1 || first.contentEditable == "false" || /^(BR|IMG)$/.test(first.nodeName)) break;
                parent = first;
            }
            parent.insertBefore(node, parent.firstChild);
            if (focusNode == node) view.domSelection().collapse(node, focusOffset);
        } else node.parentNode.removeChild(node);
    }
}
// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function $7512d6d6ef34b779$var$parseBetween(view, from_, to_) {
    let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [
            {
                node: anchor,
                offset: domSel.anchorOffset
            }
        ];
        if (!$7512d6d6ef34b779$var$selectionCollapsed(domSel)) find.push({
            node: domSel.focusNode,
            offset: domSel.focusOffset
        });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if ($7512d6d6ef34b779$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
        let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
        if (node.nodeName == "BR" && !desc) {
            toOffset = off;
            break;
        }
        if (!desc || desc.size) break;
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || (0, $kW8qW.DOMParser).fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: $7512d6d6ef34b779$var$ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null) head = anchor;
        sel = {
            anchor: anchor + from,
            head: head + from
        };
    }
    return {
        doc: doc,
        sel: sel,
        from: from,
        to: to
    };
}
function $7512d6d6ef34b779$var$ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) return desc.parseRule();
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if ($7512d6d6ef34b779$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return {
                skip: skip
            };
        } else if (dom.parentNode.lastChild == dom || $7512d6d6ef34b779$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
            ignore: true
        };
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
        ignore: true
    };
    return null;
}
const $7512d6d6ef34b779$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $7512d6d6ef34b779$var$readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = $7512d6d6ef34b779$var$selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if ($7512d6d6ef34b779$var$chrome && $7512d6d6ef34b779$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $7512d6d6ef34b779$var$keyEvent(13, "Enter")))) return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer") tr.setMeta("pointer", true);
            else if (origin == "key") tr.scrollIntoView();
            if (compositionID) tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = $7512d6d6ef34b779$var$parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    } else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = $7512d6d6ef34b779$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (change) view.input.domChangeCount++;
    if (($7512d6d6ef34b779$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $7512d6d6ef34b779$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$7512d6d6ef34b779$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $7512d6d6ef34b779$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof (0, $cw0wu.TextSelection) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
            start: sel.from,
            endA: sel.to,
            endB: sel.to
        };
        else {
            if (parse.sel) {
                let sel = $7512d6d6ef34b779$var$resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID) tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, $cw0wu.TextSelection)) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
            change.endB += view.state.selection.to - change.endA;
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if ($7512d6d6ef34b779$var$ie && $7512d6d6ef34b779$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (($7512d6d6ef34b779$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && (!$from.sameParent($to) || !$from.parent.inlineContent) && $from.pos < $to.pos && !/\S/.test(parse.doc.textBetween($from.pos, $to.pos, "", ""))) && view.someProp("handleKeyDown", (f)=>f(view, $7512d6d6ef34b779$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start && $7512d6d6ef34b779$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $7512d6d6ef34b779$var$keyEvent(8, "Backspace")))) {
        if ($7512d6d6ef34b779$var$android && $7512d6d6ef34b779$var$chrome) view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if ($7512d6d6ef34b779$var$chrome && change.endB == change.start) view.input.lastChromeDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if ($7512d6d6ef34b779$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(()=>{
            view.someProp("handleKeyDown", function(f) {
                return f(view, $7512d6d6ef34b779$var$keyEvent(13, "Enter"));
            });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let mkTr = (base)=>{
        let tr = base || view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
        if (parse.sel) {
            let sel = $7512d6d6ef34b779$var$resolveSelection(view, tr.doc, parse.sel);
            // Chrome will sometimes, during composition, report the
            // selection in the wrong place. If it looks like that is
            // happening, don't update the selection.
            // Edge just doesn't move the cursor forward when you start typing
            // in an empty block or between br nodes.
            if (sel && !($7512d6d6ef34b779$var$chrome && view.composing && sel.empty && (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $7512d6d6ef34b779$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
        }
        if (compositionID) tr.setMeta("composition", compositionID);
        return tr.scrollIntoView();
    };
    let markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) {
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if ($7512d6d6ef34b779$var$ie && $7512d6d6ef34b779$var$ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(()=>$7512d6d6ef34b779$var$selectionToDOM(view), 20);
            }
            let tr = mkTr(view.state.tr.delete(chFrom, chTo));
            let marks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
            if (marks) tr.ensureMarks(marks);
            view.dispatch(tr);
        } else if (change.endA == change.endB && (markChange = $7512d6d6ef34b779$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            let tr = mkTr(view.state.tr);
            if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
            else tr.removeMark(chFrom, chTo, markChange.mark);
            view.dispatch(tr);
        } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            let deflt = ()=>mkTr(view.state.tr.insertText(text, chFrom, chTo));
            if (!view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text, deflt))) view.dispatch(deflt());
        } else view.dispatch(mkTr());
    } else view.dispatch(mkTr());
}
function $7512d6d6ef34b779$var$resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
    return $7512d6d6ef34b779$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function $7512d6d6ef34b779$var$isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
    for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node)=>node.mark(mark.addToSet(node.marks));
    } else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node)=>node.mark(mark.removeFromSet(node.marks));
    } else return null;
    let updated = [];
    for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
    if ((0, $kW8qW.Fragment).from(updated).eq(cur)) return {
        mark: mark,
        type: type
    };
}
function $7512d6d6ef34b779$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if (end - start <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    $7512d6d6ef34b779$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
    let $next = old.resolve($7512d6d6ef34b779$var$skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end || $7512d6d6ef34b779$var$skipClosingAndOpening($next, true, false) < end) return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function $7512d6d6ef34b779$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while(next && !next.isLeaf){
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function $7512d6d6ef34b779$var$findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null) return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && $7512d6d6ef34b779$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    } else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && $7512d6d6ef34b779$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return {
        start: start,
        endA: endA,
        endB: endB
    };
}
function $7512d6d6ef34b779$var$isSurrogatePair(str) {
    if (str.length != 2) return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
/**
@internal
*/ const $7512d6d6ef34b779$export$5d42ca91c11c9e4d = $7512d6d6ef34b779$var$parseFromClipboard;
/**
@internal
*/ const $7512d6d6ef34b779$export$76b14d3c719c32fc = $7512d6d6ef34b779$var$endComposition;
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/ class $7512d6d6ef34b779$export$eece2fccabbb77c5 {
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */ constructor(place, props){
        this._root = null;
        /**
        @internal
        */ this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */ this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */ this.markCursor = null;
        /**
        @internal
        */ this.cursorWrapper = null;
        /**
        @internal
        */ this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */ this.input = new $7512d6d6ef34b779$var$InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */ this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */ this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach($7512d6d6ef34b779$var$checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = place && place.mount || document.createElement("div");
        if (place) {
            if (place.appendChild) place.appendChild(this.dom);
            else if (typeof place == "function") place(this.dom);
            else if (place.mount) this.mounted = true;
        }
        this.editable = $7512d6d6ef34b779$var$getEditable(this);
        $7512d6d6ef34b779$var$updateCursorWrapper(this);
        this.nodeViews = $7512d6d6ef34b779$var$buildNodeViews(this);
        this.docView = $7512d6d6ef34b779$var$docViewDesc(this.state.doc, $7512d6d6ef34b779$var$computeDocDeco(this), $7512d6d6ef34b779$var$viewDecorations(this), this.dom, this);
        this.domObserver = new $7512d6d6ef34b779$var$DOMObserver(this, (from, to, typeOver, added)=>$7512d6d6ef34b779$var$readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        $7512d6d6ef34b779$var$initInput(this);
        this.updatePluginViews();
    }
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */ get composing() {
        return this.input.composing;
    }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */ get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for(let name in prev)this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */ update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents) $7512d6d6ef34b779$var$ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach($7512d6d6ef34b779$var$checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */ setProps(props) {
        let updated = {};
        for(let name in this._props)updated[name] = this._props[name];
        updated.state = this.state;
        for(let name in props)updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */ updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            $7512d6d6ef34b779$var$clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = $7512d6d6ef34b779$var$buildNodeViews(this);
            if ($7512d6d6ef34b779$var$changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $7512d6d6ef34b779$var$ensureListeners(this);
        this.editable = $7512d6d6ef34b779$var$getEditable(this);
        $7512d6d6ef34b779$var$updateCursorWrapper(this);
        let innerDeco = $7512d6d6ef34b779$var$viewDecorations(this), outerDeco = $7512d6d6ef34b779$var$computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $7512d6d6ef34b779$var$storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && ($7512d6d6ef34b779$var$ie || $7512d6d6ef34b779$var$chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && $7512d6d6ef34b779$var$selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = $7512d6d6ef34b779$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                if (this.composing) this.input.compositionNode = $7512d6d6ef34b779$var$findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = $7512d6d6ef34b779$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && (!this.trackWrites || !this.dom.contains(this.trackWrites))) forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $7512d6d6ef34b779$var$anchorInRightPlace(this))) $7512d6d6ef34b779$var$selectionToDOM(this, forceSelUpdate);
            else {
                $7512d6d6ef34b779$var$syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") this.dom.scrollTop = 0;
        else if (scroll == "to selection") this.scrollToSelection();
        else if (oldScrollPos) $7512d6d6ef34b779$var$resetScrollPos(oldScrollPos);
    }
    /**
    @internal
    */ scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (!startDOM || !this.dom.contains(startDOM.nodeType == 1 ? startDOM : startDOM.parentNode)) ;
        else if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
        else if (this.state.selection instanceof (0, $cw0wu.NodeSelection)) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1) $7512d6d6ef34b779$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        } else $7512d6d6ef34b779$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
    destroyPluginViews() {
        let view;
        while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for(let i = 0; i < this.directPlugins.length; i++){
                let plugin = this.directPlugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
            for(let i = 0; i < this.state.plugins.length; i++){
                let plugin = this.state.plugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
        } else for(let i = 0; i < this.pluginViews.length; i++){
            let pluginView = this.pluginViews[i];
            if (pluginView.update) pluginView.update(this, prevState);
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node) found = movedPos;
        }
        this.dragging = new $7512d6d6ef34b779$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, $cw0wu.NodeSelection).create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop)) return value;
        for(let i = 0; i < this.directPlugins.length; i++){
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
        let plugins = this.state.plugins;
        if (plugins) for(let i = 0; i < plugins.length; i++){
            let prop = plugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
    }
    /**
    Query whether the view has focus.
    */ hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if ($7512d6d6ef34b779$var$ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom) return true;
            if (!node || !this.dom.contains(node)) return false;
            while(node && this.dom != node && this.dom.contains(node)){
                if (node.contentEditable == 'false') return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */ focus() {
        this.domObserver.stop();
        if (this.editable) $7512d6d6ef34b779$var$focusPreventScroll(this.dom);
        $7512d6d6ef34b779$var$selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */ get root() {
        let cached = this._root;
        if (cached == null) {
            for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                return this._root = search;
            }
        }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */ updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */ posAtCoords(coords) {
        return $7512d6d6ef34b779$var$posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */ coordsAtPos(pos, side = 1) {
        return $7512d6d6ef34b779$var$coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */ domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */ nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */ posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null) throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */ endOfTextblock(dir, state) {
        return $7512d6d6ef34b779$var$endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */ pasteHTML(html, event) {
        return $7512d6d6ef34b779$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */ pasteText(text, event) {
        return $7512d6d6ef34b779$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Serialize the given slice as it would be if it was copied from
    this editor. Returns a DOM element that contains a
    representation of the slice as its children, a textual
    representation, and the transformed slice (which can be
    different from the given input due to hooks like
    [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
    */ serializeForClipboard(slice) {
        return $7512d6d6ef34b779$var$serializeForClipboard(this, slice);
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */ destroy() {
        if (!this.docView) return;
        $7512d6d6ef34b779$var$destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], $7512d6d6ef34b779$var$viewDecorations(this), this);
            this.dom.textContent = "";
        } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
        this.docView.destroy();
        this.docView = null;
        $7512d6d6ef34b779$var$clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */ get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */ dispatchEvent(event) {
        return $7512d6d6ef34b779$var$dispatchEvent(this, event);
    }
    /**
    @internal
    */ domSelectionRange() {
        let sel = this.domSelection();
        if (!sel) return {
            focusNode: null,
            focusOffset: 0,
            anchorNode: null,
            anchorOffset: 0
        };
        return $7512d6d6ef34b779$var$safari && this.root.nodeType === 11 && $7512d6d6ef34b779$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $7512d6d6ef34b779$var$safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */ domSelection() {
        return this.root.getSelection();
    }
}
$7512d6d6ef34b779$export$eece2fccabbb77c5.prototype.dispatch = function(tr) {
    let dispatchTransaction = this._props.dispatchTransaction;
    if (dispatchTransaction) dispatchTransaction.call(this, tr);
    else this.updateState(this.state.apply(tr));
};
function $7512d6d6ef34b779$var$computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", (value)=>{
        if (typeof value == "function") value = value(view.state);
        if (value) for(let attr in value){
            if (attr == "class") attrs.class += " " + value[attr];
            else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
            else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
        }
    });
    if (!attrs.translate) attrs.translate = "no";
    return [
        $7512d6d6ef34b779$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
    ];
}
function $7512d6d6ef34b779$var$updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = {
            dom: dom,
            deco: $7512d6d6ef34b779$export$10e30b733df217ea.widget(view.state.selection.from, dom, {
                raw: true,
                marks: view.markCursor
            })
        };
    } else view.cursorWrapper = null;
}
function $7512d6d6ef34b779$var$getEditable(view) {
    return !view.someProp("editable", (value)=>value(view.state) === false);
}
function $7512d6d6ef34b779$var$selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function $7512d6d6ef34b779$var$buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function $7512d6d6ef34b779$var$changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for(let prop in a){
        if (a[prop] != b[prop]) return true;
        nA++;
    }
    for(let _ in b)nB++;
    return nA != nB;
}
function $7512d6d6ef34b779$var$checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}

});

parcelRegister("5FzRL", function(module, exports) {
$parcel$export(module.exports, "deleteSelection", () => $420c9a61844833cb$export$e9a518a637d1e641);
$parcel$export(module.exports, "selectNodeBackward", () => $420c9a61844833cb$export$52b8a4af68d19794);
$parcel$export(module.exports, "exitCode", () => $420c9a61844833cb$export$634b78845598ff5b);
$parcel$export(module.exports, "createParagraphNear", () => $420c9a61844833cb$export$d0f80ac1b4510888);
$parcel$export(module.exports, "splitBlockAs", () => $420c9a61844833cb$export$8bf8350f33b1e5ab);
$parcel$export(module.exports, "splitBlock", () => $420c9a61844833cb$export$e99155638ff4dff0);
$parcel$export(module.exports, "selectAll", () => $420c9a61844833cb$export$90aca4adda6ff0f5);
$parcel$export(module.exports, "toggleMark", () => $420c9a61844833cb$export$797ad2667b8015a8);
$parcel$export(module.exports, "autoJoin", () => $420c9a61844833cb$export$29903073afddcd8b);
$parcel$export(module.exports, "chainCommands", () => $420c9a61844833cb$export$146a774cdef7663a);
$parcel$export(module.exports, "baseKeymap", () => $420c9a61844833cb$export$4a0c2b85b1f0a889);

var $3DNV7 = parcelRequire("3DNV7");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");
/**
Delete the selection, if there is one.
*/ const $420c9a61844833cb$export$e9a518a637d1e641 = (state, dispatch)=>{
    if (state.selection.empty) return false;
    if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function $420c9a61844833cb$var$atBlockStart(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/ const $420c9a61844833cb$export$979097b097459299 = (state, dispatch, view)=>{
    let $cursor = $420c9a61844833cb$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $420c9a61844833cb$var$findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && (0, $3DNV7.liftTarget)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if ($420c9a61844833cb$var$deleteBarrier(state, $cut, dispatch, -1)) return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 && ($420c9a61844833cb$var$textblockAt(before, "end") || (0, $cw0wu.NodeSelection).isSelectable(before))) for(let depth = $cursor.depth;; depth--){
        let delStep = (0, $3DNV7.replaceStep)(state.doc, $cursor.before(depth), $cursor.after(depth), (0, $kW8qW.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($420c9a61844833cb$var$textblockAt(before, "end") ? (0, $cw0wu.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : (0, $cw0wu.NodeSelection).create(tr.doc, $cut.pos - before.nodeSize));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/ const $420c9a61844833cb$export$1dce4f5c74f5f90f = (state, dispatch, view)=>{
    let $cursor = $420c9a61844833cb$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $420c9a61844833cb$var$findCutBefore($cursor);
    return $cut ? $420c9a61844833cb$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/ const $420c9a61844833cb$export$e796bb96d22be2cd = (state, dispatch, view)=>{
    let $cursor = $420c9a61844833cb$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $420c9a61844833cb$var$findCutAfter($cursor);
    return $cut ? $420c9a61844833cb$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
function $420c9a61844833cb$var$joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for(; !beforeText.isTextblock; beforePos--){
        if (beforeText.type.spec.isolating) return false;
        let child = beforeText.lastChild;
        if (!child) return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for(; !afterText.isTextblock; afterPos++){
        if (afterText.type.spec.isolating) return false;
        let child = afterText.firstChild;
        if (!child) return false;
        afterText = child;
    }
    let step = (0, $3DNV7.replaceStep)(state.doc, beforePos, afterPos, (0, $kW8qW.Slice).empty);
    if (!step || step.from != beforePos || step instanceof (0, $3DNV7.ReplaceStep) && step.slice.size >= afterPos - beforePos) return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection((0, $cw0wu.TextSelection).create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function $420c9a61844833cb$var$textblockAt(node, side, only = false) {
    for(let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild){
        if (scan.isTextblock) return true;
        if (only && scan.childCount != 1) return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/ const $420c9a61844833cb$export$52b8a4af68d19794 = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
        $cut = $420c9a61844833cb$var$findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !(0, $cw0wu.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $cw0wu.NodeSelection).create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function $420c9a61844833cb$var$findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $420c9a61844833cb$var$atBlockEnd(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/ const $420c9a61844833cb$export$bf432e340007f9ef = (state, dispatch, view)=>{
    let $cursor = $420c9a61844833cb$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $420c9a61844833cb$var$findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut) return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if ($420c9a61844833cb$var$deleteBarrier(state, $cut, dispatch, 1)) return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 && ($420c9a61844833cb$var$textblockAt(after, "start") || (0, $cw0wu.NodeSelection).isSelectable(after))) {
        let delStep = (0, $3DNV7.replaceStep)(state.doc, $cursor.before(), $cursor.after(), (0, $kW8qW.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($420c9a61844833cb$var$textblockAt(after, "start") ? (0, $cw0wu.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : (0, $cw0wu.NodeSelection).create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/ const $420c9a61844833cb$export$5835b52680b80cfd = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
        $cut = $420c9a61844833cb$var$findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !(0, $cw0wu.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $cw0wu.NodeSelection).create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function $420c9a61844833cb$var$findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        let parent = $pos.node(i);
        if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
        if (parent.type.spec.isolating) break;
    }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/ const $420c9a61844833cb$export$4bb15e6d4372b393 = (state, dispatch)=>{
    let sel = state.selection, nodeSel = sel instanceof (0, $cw0wu.NodeSelection), point;
    if (nodeSel) {
        if (sel.node.isTextblock || !(0, $3DNV7.canJoin)(state.doc, sel.from)) return false;
        point = sel.from;
    } else {
        point = (0, $3DNV7.joinPoint)(state.doc, sel.from, -1);
        if (point == null) return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel) tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/ const $420c9a61844833cb$export$8dd967a262b064bb = (state, dispatch)=>{
    let sel = state.selection, point;
    if (sel instanceof (0, $cw0wu.NodeSelection)) {
        if (sel.node.isTextblock || !(0, $3DNV7.canJoin)(state.doc, sel.to)) return false;
        point = sel.to;
    } else {
        point = (0, $3DNV7.joinPoint)(state.doc, sel.to, 1);
        if (point == null) return false;
    }
    if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/ const $420c9a61844833cb$export$590e8b2c435046d9 = (state, dispatch)=>{
    let { $from: $from, $to: $to } = state.selection;
    let range = $from.blockRange($to), target = range && (0, $3DNV7.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/ const $420c9a61844833cb$export$a5d02b4b65e94f91 = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function $420c9a61844833cb$var$defaultBlockAt(match) {
    for(let i = 0; i < match.edgeCount; i++){
        let { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/ const $420c9a61844833cb$export$634b78845598ff5b = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = $420c9a61844833cb$var$defaultBlockAt(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type)) return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection((0, $cw0wu.Selection).near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/ const $420c9a61844833cb$export$d0f80ac1b4510888 = (state, dispatch)=>{
    let sel = state.selection, { $from: $from, $to: $to } = sel;
    if (sel instanceof (0, $cw0wu.AllSelection) || $from.parent.inlineContent || $to.parent.inlineContent) return false;
    let type = $420c9a61844833cb$var$defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock) return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection((0, $cw0wu.TextSelection).create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/ const $420c9a61844833cb$export$a3574cc681852c08 = (state, dispatch)=>{
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size) return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if ((0, $3DNV7.canSplit)(state.doc, before)) {
            if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && (0, $3DNV7.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Create a variant of [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock) that uses
a custom function to determine the type of the newly split off block.
*/ function $420c9a61844833cb$export$8bf8350f33b1e5ab(splitNode) {
    return (state, dispatch)=>{
        let { $from: $from, $to: $to } = state.selection;
        if (state.selection instanceof (0, $cw0wu.NodeSelection) && state.selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $3DNV7.canSplit)(state.doc, $from.pos)) return false;
            if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
            return true;
        }
        if (!$from.depth) return false;
        let types = [];
        let splitDepth, deflt, atEnd = false, atStart = false;
        for(let d = $from.depth;; d--){
            let node = $from.node(d);
            if (node.isBlock) {
                atEnd = $from.end(d) == $from.pos + ($from.depth - d);
                atStart = $from.start(d) == $from.pos - ($from.depth - d);
                deflt = $420c9a61844833cb$var$defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
                let splitType = splitNode && splitNode($to.parent, atEnd, $from);
                types.unshift(splitType || (atEnd && deflt ? {
                    type: deflt
                } : null));
                splitDepth = d;
                break;
            } else {
                if (d == 1) return false;
                types.unshift(null);
            }
        }
        let tr = state.tr;
        if (state.selection instanceof (0, $cw0wu.TextSelection) || state.selection instanceof (0, $cw0wu.AllSelection)) tr.deleteSelection();
        let splitPos = tr.mapping.map($from.pos);
        let can = (0, $3DNV7.canSplit)(tr.doc, splitPos, types.length, types);
        if (!can) {
            types[0] = deflt ? {
                type: deflt
            } : null;
            can = (0, $3DNV7.canSplit)(tr.doc, splitPos, types.length, types);
        }
        if (!can) return false;
        tr.split(splitPos, types.length, types);
        if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
            let first = tr.mapping.map($from.before(splitDepth)), $first = tr.doc.resolve(first);
            if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before(splitDepth)), deflt);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Split the parent block of the selection. If the selection is a text
selection, also delete its content.
*/ const $420c9a61844833cb$export$e99155638ff4dff0 = $420c9a61844833cb$export$8bf8350f33b1e5ab();
/**
Acts like [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock), but without
resetting the set of active marks at the cursor.
*/ const $420c9a61844833cb$export$eeb429476568b72b = (state, dispatch)=>{
    return $420c9a61844833cb$export$e99155638ff4dff0(state, dispatch && ((tr)=>{
        let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
        if (marks) tr.ensureMarks(marks);
        dispatch(tr);
    }));
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/ const $420c9a61844833cb$export$a37f6aaa9169911d = (state, dispatch)=>{
    let { $from: $from, to: to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0) return false;
    pos = $from.before(same);
    if (dispatch) dispatch(state.tr.setSelection((0, $cw0wu.NodeSelection).create(state.doc, pos)));
    return true;
};
/**
Select the whole document.
*/ const $420c9a61844833cb$export$90aca4adda6ff0f5 = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.setSelection(new (0, $cw0wu.AllSelection)(state.doc)));
    return true;
};
function $420c9a61844833cb$var$joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type)) return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || (0, $3DNV7.canJoin)(state.doc, $pos.pos))) return false;
    if (dispatch) dispatch(state.tr.join($pos.pos).scrollIntoView());
    return true;
}
function $420c9a61844833cb$var$deleteBarrier(state, $cut, dispatch, dir) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    let isolated = before.type.spec.isolating || after.type.spec.isolating;
    if (!isolated && $420c9a61844833cb$var$joinMaybeClear(state, $cut, dispatch)) return true;
    let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = (0, $kW8qW.Fragment).empty;
            for(let i = conn.length - 1; i >= 0; i--)wrap = (0, $kW8qW.Fragment).from(conn[i].create(null, wrap));
            wrap = (0, $kW8qW.Fragment).from(before.copy(wrap));
            let tr = state.tr.step(new (0, $3DNV7.ReplaceAroundStep)($cut.pos - 1, end, $cut.pos, end, new (0, $kW8qW.Slice)(wrap, 1, 0), conn.length, true));
            let $joinAt = tr.doc.resolve(end + 2 * conn.length);
            if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && (0, $3DNV7.canJoin)(tr.doc, $joinAt.pos)) tr.join($joinAt.pos);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : (0, $cw0wu.Selection).findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && (0, $3DNV7.liftTarget)(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && $420c9a61844833cb$var$textblockAt(after, "start", true) && $420c9a61844833cb$var$textblockAt(before, "end")) {
        let at = before, wrap = [];
        for(;;){
            wrap.push(at);
            if (at.isTextblock) break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for(; !afterText.isTextblock; afterText = afterText.firstChild)afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = (0, $kW8qW.Fragment).empty;
                for(let i = wrap.length - 1; i >= 0; i--)end = (0, $kW8qW.Fragment).from(wrap[i].copy(end));
                let tr = state.tr.step(new (0, $3DNV7.ReplaceAroundStep)($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new (0, $kW8qW.Slice)(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function $420c9a61844833cb$var$selectTextblockSide(side) {
    return function(state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while($pos.node(depth).isInline){
            if (!depth) return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, $cw0wu.TextSelection).create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/ const $420c9a61844833cb$export$c3a64f3c9604a1b1 = $420c9a61844833cb$var$selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/ const $420c9a61844833cb$export$a66c1876556415e5 = $420c9a61844833cb$var$selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/ function $420c9a61844833cb$export$6e5e3c49755affd0(nodeType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && (0, $3DNV7.findWrapping)(range, nodeType, attrs);
        if (!wrapping) return false;
        if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/ function $420c9a61844833cb$export$36987f561c736aad(nodeType, attrs = null) {
    return function(state, dispatch) {
        let applicable = false;
        for(let i = 0; i < state.selection.ranges.length && !applicable; i++){
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (applicable) return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
                if (node.type == nodeType) applicable = true;
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable) return false;
        if (dispatch) {
            let tr = state.tr;
            for(let i = 0; i < state.selection.ranges.length; i++){
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
function $420c9a61844833cb$var$markApplies(doc, ranges, type, enterAtoms) {
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) return true;
    }
    return false;
}
function $420c9a61844833cb$var$removeInlineAtoms(ranges) {
    let result = [];
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        $from.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
                if (pos + 1 > $from.pos) result.push(new (0, $cw0wu.SelectionRange)($from, $from.doc.resolve(pos + 1)));
                $from = $from.doc.resolve(pos + 1 + node.content.size);
                return false;
            }
        });
        if ($from.pos < $to.pos) result.push(new (0, $cw0wu.SelectionRange)($from, $to));
    }
    return result;
}
/**
Create a command function that toggles the given mark with the
given attributes. Will return `false` when the current selection
doesn't support that mark. This will remove the mark if any marks
of that type exist in the selection, or add it otherwise. If the
selection is empty, this applies to the [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks) instead of a range of the
document.
*/ function $420c9a61844833cb$export$797ad2667b8015a8(markType, attrs = null, options) {
    let removeWhenPresent = (options && options.removeWhenPresent) !== false;
    let enterAtoms = (options && options.enterInlineAtoms) !== false;
    let dropSpace = !(options && options.includeWhitespace);
    return function(state, dispatch) {
        let { empty: empty, $cursor: $cursor, ranges: ranges } = state.selection;
        if (empty && !$cursor || !$420c9a61844833cb$var$markApplies(state.doc, ranges, markType, enterAtoms)) return false;
        if (dispatch) {
            if ($cursor) {
                if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));
                else dispatch(state.tr.addStoredMark(markType.create(attrs)));
            } else {
                let add, tr = state.tr;
                if (!enterAtoms) ranges = $420c9a61844833cb$var$removeInlineAtoms(ranges);
                if (removeWhenPresent) add = !ranges.some((r)=>state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType));
                else add = !ranges.every((r)=>{
                    let missing = false;
                    tr.doc.nodesBetween(r.$from.pos, r.$to.pos, (node, pos, parent)=>{
                        if (missing) return false;
                        missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) && !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
                    });
                    return !missing;
                });
                for(let i = 0; i < ranges.length; i++){
                    let { $from: $from, $to: $to } = ranges[i];
                    if (!add) tr.removeMark($from.pos, $to.pos, markType);
                    else {
                        let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                        let spaceStart = dropSpace && start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                        let spaceEnd = dropSpace && end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                        if (from + spaceStart < to) {
                            from += spaceStart;
                            to -= spaceEnd;
                        }
                        tr.addMark(from, to, markType.create(attrs));
                    }
                }
                dispatch(tr.scrollIntoView());
            }
        }
        return true;
    };
}
function $420c9a61844833cb$var$wrapDispatchForJoin(dispatch, isJoinable) {
    return (tr)=>{
        if (!tr.isGeneric) return dispatch(tr);
        let ranges = [];
        for(let i = 0; i < tr.mapping.maps.length; i++){
            let map = tr.mapping.maps[i];
            for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to)=>ranges.push(from, to));
        }
        // Figure out which joinable points exist inside those ranges,
        // by checking all node boundaries in their parent nodes.
        let joinable = [];
        for(let i = 0; i < ranges.length; i += 2){
            let from = ranges[i], to = ranges[i + 1];
            let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
            for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                let after = parent.maybeChild(index);
                if (!after) break;
                if (index && joinable.indexOf(pos) == -1) {
                    let before = parent.child(index - 1);
                    if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        // Join the joinable points
        joinable.sort((a, b)=>a - b);
        for(let i = joinable.length - 1; i >= 0; i--)if ((0, $3DNV7.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
        dispatch(tr);
    };
}
/**
Wrap a command so that, when it produces a transform that causes
two joinable nodes to end up next to each other, those are joined.
Nodes are considered joinable when they are of the same type and
when the `isJoinable` predicate returns true for them or, if an
array of strings was passed, if their node type name is in that
array.
*/ function $420c9a61844833cb$export$29903073afddcd8b(command, isJoinable) {
    let canJoin = Array.isArray(isJoinable) ? (node)=>isJoinable.indexOf(node.type.name) > -1 : isJoinable;
    return (state, dispatch, view)=>command(state, dispatch && $420c9a61844833cb$var$wrapDispatchForJoin(dispatch, canJoin), view);
}
/**
Combine a number of command functions into a single function (which
calls them one by one until one returns true).
*/ function $420c9a61844833cb$export$146a774cdef7663a(...commands) {
    return function(state, dispatch, view) {
        for(let i = 0; i < commands.length; i++)if (commands[i](state, dispatch, view)) return true;
        return false;
    };
}
let $420c9a61844833cb$var$backspace = $420c9a61844833cb$export$146a774cdef7663a($420c9a61844833cb$export$e9a518a637d1e641, $420c9a61844833cb$export$979097b097459299, $420c9a61844833cb$export$52b8a4af68d19794);
let $420c9a61844833cb$var$del = $420c9a61844833cb$export$146a774cdef7663a($420c9a61844833cb$export$e9a518a637d1e641, $420c9a61844833cb$export$bf432e340007f9ef, $420c9a61844833cb$export$5835b52680b80cfd);
/**
A basic keymap containing bindings not specific to any schema.
Binds the following keys (when multiple commands are listed, they
are chained with [`chainCommands`](https://prosemirror.net/docs/ref/#commands.chainCommands)):

* **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
* **Mod-Enter** to `exitCode`
* **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
* **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-a** to `selectAll`
*/ const $420c9a61844833cb$export$eb36e8971b04df36 = {
    "Enter": $420c9a61844833cb$export$146a774cdef7663a($420c9a61844833cb$export$a5d02b4b65e94f91, $420c9a61844833cb$export$d0f80ac1b4510888, $420c9a61844833cb$export$a3574cc681852c08, $420c9a61844833cb$export$e99155638ff4dff0),
    "Mod-Enter": $420c9a61844833cb$export$634b78845598ff5b,
    "Backspace": $420c9a61844833cb$var$backspace,
    "Mod-Backspace": $420c9a61844833cb$var$backspace,
    "Shift-Backspace": $420c9a61844833cb$var$backspace,
    "Delete": $420c9a61844833cb$var$del,
    "Mod-Delete": $420c9a61844833cb$var$del,
    "Mod-a": $420c9a61844833cb$export$90aca4adda6ff0f5
};
/**
A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
**Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
**Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
Ctrl-Delete.
*/ const $420c9a61844833cb$export$f292ad8dbd5063c8 = {
    "Ctrl-h": $420c9a61844833cb$export$eb36e8971b04df36["Backspace"],
    "Alt-Backspace": $420c9a61844833cb$export$eb36e8971b04df36["Mod-Backspace"],
    "Ctrl-d": $420c9a61844833cb$export$eb36e8971b04df36["Delete"],
    "Ctrl-Alt-Backspace": $420c9a61844833cb$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-Delete": $420c9a61844833cb$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-d": $420c9a61844833cb$export$eb36e8971b04df36["Mod-Delete"],
    "Ctrl-a": $420c9a61844833cb$export$c3a64f3c9604a1b1,
    "Ctrl-e": $420c9a61844833cb$export$a66c1876556415e5
};
for(let key in $420c9a61844833cb$export$eb36e8971b04df36)$420c9a61844833cb$export$f292ad8dbd5063c8[key] = $420c9a61844833cb$export$eb36e8971b04df36[key];
const $420c9a61844833cb$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
/**
Depending on the detected platform, this will hold
[`pcBasekeymap`](https://prosemirror.net/docs/ref/#commands.pcBaseKeymap) or
[`macBaseKeymap`](https://prosemirror.net/docs/ref/#commands.macBaseKeymap).
*/ const $420c9a61844833cb$export$4a0c2b85b1f0a889 = $420c9a61844833cb$var$mac ? $420c9a61844833cb$export$f292ad8dbd5063c8 : $420c9a61844833cb$export$eb36e8971b04df36;

});

parcelRegister("5Aczr", function(module, exports) {
$parcel$export(module.exports, "history", () => $477d9b7bc448bc6a$export$55abd4691b317664);

var $cw0wu = parcelRequire("cw0wu");

var $lFPYK = parcelRequire("lFPYK");

var $ft3yp = parcelRequire("ft3yp");

var $6xrPZ = parcelRequire("6xrPZ");

var $1TYBU = parcelRequire("1TYBU");

var $gNUrD = parcelRequire("gNUrD");

var $jVAei = parcelRequire("jVAei");

var $8mpUq = parcelRequire("8mpUq");

var $i4H9h = parcelRequire("i4H9h");

var $96Q2j = parcelRequire("96Q2j");

var $2556L = parcelRequire("2556L");
function $477d9b7bc448bc6a$export$55abd4691b317664(config = {}) {
    config = {
        depth: config.depth || 100,
        newGroupDelay: config.newGroupDelay || 500
    };
    return new (0, $cw0wu.Plugin)({
        key: (0, $6xrPZ.historyKey),
        state: {
            init () {
                return new (0, $1TYBU.HistoryState)((0, $lFPYK.Branch).empty, (0, $lFPYK.Branch).empty, null, 0, -1);
            },
            apply (tr, hist, state) {
                return $477d9b7bc448bc6a$var$applyTransaction(hist, state, tr, config);
            }
        },
        config: config,
        props: {
            handleDOMEvents: {
                beforeinput (view, e) {
                    const inputType = e.inputType;
                    const command = // To match existing behaviour of prosemirror-history
                    // eslint-disable-next-line eqeqeq
                    inputType == 'historyUndo' ? (0, $jVAei.undo) : inputType == 'historyRedo' ? (0, $gNUrD.redo) : null;
                    if (!command || !view.editable) return false;
                    e.preventDefault();
                    return command(view.state, view.dispatch);
                }
            }
        }
    });
}
// Record a transformation in undo history.
function $477d9b7bc448bc6a$var$applyTransaction(history, state, tr, options) {
    var _history;
    const historyTr = tr.getMeta((0, $6xrPZ.historyKey));
    let rebased;
    if (historyTr) return historyTr.historyState;
    /**
   * ===
   * FORK ADDITION START
   * If history slicing is active, we want to continue the current slice
   */ if ((tr.getMeta('startHistorySlice') === true || (_history = history) !== null && _history !== void 0 && _history.historySliceActive) && tr.getMeta('endHistorySlice') !== true) {
        const shouldIgnoreChange = tr.getMeta('isRemote');
        if (shouldIgnoreChange) {
            // For addToHistory=false transactions during a slice, we need to:
            // 1. Update the mapping for done/undone branches
            // 2. Map the existing steps
            // 3. Update the document to rebaseline
            const mappedRanges = history.prevRanges ? $477d9b7bc448bc6a$var$mapRanges(history.prevRanges, tr.mapping) : null;
            return new (0, $1TYBU.HistoryState)(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), mappedRanges, history.prevTime, history.prevComposition, true, (0, $96Q2j.mapInvertableSteps)(history.trackedSteps, tr), history.selectionBookmark);
        }
        const startHistorySlice = tr.getMeta('startHistorySlice') === true;
        const newTrackedSteps = [
            ...history.trackedSteps || [],
            ...tr.steps.map((s, idx)=>new (0, $i4H9h.InvertableStep)(s, s.invert(tr.docs[idx])))
        ];
        const mappedRanges = history.prevRanges ? $477d9b7bc448bc6a$var$mapRanges(history.prevRanges, tr.mapping) : null;
        return new (0, $1TYBU.HistoryState)(history.done, startHistorySlice ? (0, $lFPYK.Branch).empty : history.undone, mappedRanges, history.prevTime, history.prevComposition, true, newTrackedSteps, startHistorySlice ? state.selection.getBookmark() : history.selectionBookmark);
    } else if (tr.getMeta('endHistorySlice') === true && history.historySliceActive) {
        const trackedSteps = history.historySliceActive ? history.trackedSteps || [] : [];
        // Create transform that represents the changes made during the slice
        // Use the original slice document as the base
        const transform = (0, $8mpUq.createTransformFromSteps)(trackedSteps, tr.doc);
        const mappedRanges = history.prevRanges ? $477d9b7bc448bc6a$var$mapRanges(history.prevRanges, tr.mapping) : null;
        return new (0, $1TYBU.HistoryState)(history.done.addMaps(tr.mapping.maps).addTransform(transform, history.selectionBookmark, options, (0, $2556L.mustPreserveItems)(state)), history.undone.addMaps(tr.mapping.maps), mappedRanges, history.prevTime, history.prevComposition);
    }
    /**
   * FORK ADDITION END
   * ===
   */ if (tr.getMeta((0, $ft3yp.closeHistoryKey))) history = new (0, $1TYBU.HistoryState)(history.done, history.undone, null, 0, -1);
    const appended = tr.getMeta('appendedTransaction');
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line eqeqeq
    if (tr.steps.length == 0) return history;
    else if (appended && appended.getMeta((0, $6xrPZ.historyKey))) {
        if (appended.getMeta((0, $6xrPZ.historyKey)).redo) return new (0, $1TYBU.HistoryState)(history.done.addTransform(tr, undefined, options, (0, $2556L.mustPreserveItems)(state)), history.undone, $477d9b7bc448bc6a$var$rangesFor(tr.mapping.maps), history.prevTime, history.prevComposition);
        else return new (0, $1TYBU.HistoryState)(history.done, history.undone.addTransform(tr, undefined, options, (0, $2556L.mustPreserveItems)(state)), null, history.prevTime, history.prevComposition);
    } else if (tr.getMeta('addToHistory') !== false && !(appended && appended.getMeta('addToHistory') === false)) {
        // Group transforms that occur in quick succession into one event.
        const composition = tr.getMeta('composition');
        const newGroup = // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        history.prevTime == 0 || !appended && // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        history.prevComposition != composition && (history.prevTime < (tr.time || 0) - options.newGroupDelay || // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        !$477d9b7bc448bc6a$var$isAdjacentTo(tr, history.prevRanges));
        const prevRanges = appended ? // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $477d9b7bc448bc6a$var$mapRanges(history.prevRanges, tr.mapping) : $477d9b7bc448bc6a$var$rangesFor(tr.mapping.maps);
        return new (0, $1TYBU.HistoryState)(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, (0, $2556L.mustPreserveItems)(state)), (0, $lFPYK.Branch).empty, prevRanges, tr.time, // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        composition == null ? history.prevComposition : composition);
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line no-cond-assign
    } else if (rebased = tr.getMeta('rebased')) // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new (0, $1TYBU.HistoryState)(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $477d9b7bc448bc6a$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    else return new (0, $1TYBU.HistoryState)(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $477d9b7bc448bc6a$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
}
function $477d9b7bc448bc6a$var$isAdjacentTo(transform, prevRanges) {
    if (!prevRanges) return false;
    if (!transform.docChanged) return true;
    let adjacent = false;
    transform.mapping.maps[0].forEach((start, end)=>{
        for(let i = 0; i < prevRanges.length; i += 2)if (start <= prevRanges[i + 1] && end >= prevRanges[i]) adjacent = true;
    });
    return adjacent;
}
function $477d9b7bc448bc6a$var$rangesFor(maps) {
    const result = [];
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line eqeqeq
    for(let i = maps.length - 1; i >= 0 && result.length == 0; i--)maps[i].forEach((_from, _to, from, to)=>result.push(from, to));
    return result;
}
function $477d9b7bc448bc6a$var$mapRanges(ranges, mapping) {
    if (!ranges) return null;
    const result = [];
    for(let i = 0; i < ranges.length; i += 2){
        const from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
        if (from <= to) result.push(from, to);
    }
    return result;
}

});
parcelRegister("lFPYK", function(module, exports) {
$parcel$export(module.exports, "Branch", () => $14f6ec349713ffc6$export$aecb2ddcb55c95be);

var $iSySZ = parcelRequire("iSySZ");

var $3DNV7 = parcelRequire("3DNV7");
// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)
// Used to schedule history compression
const $14f6ec349713ffc6$var$max_empty_items = 500;
const $14f6ec349713ffc6$var$DEPTH_OVERFLOW = 20;
class $14f6ec349713ffc6$export$aecb2ddcb55c95be {
    constructor(items, eventCount){
        this.items = items;
        this.eventCount = eventCount;
    }
    // Pop the latest event off the branch's history and apply it
    // to a document transform.
    popEvent(state, preserveItems) {
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (this.eventCount == 0) return null;
        let end = this.items.length;
        for(;; end--){
            const next = this.items.get(end - 1);
            if (next.selection) {
                --end;
                break;
            }
        }
        let remap, mapFrom;
        if (preserveItems) {
            remap = this.remapping(end, this.items.length);
            mapFrom = remap.maps.length;
        }
        const transform = state.tr;
        let selection, remaining;
        const addAfter = [], addBefore = [];
        this.items.forEach((item, i)=>{
            if (!item.step) {
                if (!remap) {
                    remap = this.remapping(end, i + 1);
                    mapFrom = remap.maps.length;
                }
                // To match existing behaviour of prosemirror-history
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mapFrom--;
                addBefore.push(item);
                return;
            }
            if (remap) {
                addBefore.push(new $14f6ec349713ffc6$var$Item(item.map));
                const step = item.step.map(remap.slice(mapFrom));
                let map;
                if (step && transform.maybeStep(step).doc) {
                    map = transform.mapping.maps[transform.mapping.maps.length - 1];
                    addAfter.push(new $14f6ec349713ffc6$var$Item(map, undefined, undefined, addAfter.length + addBefore.length));
                }
                // To match existing behaviour of prosemirror-history
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
            } else transform.maybeStep(item.step);
            if (item.selection) {
                selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
                remaining = new $14f6ec349713ffc6$export$aecb2ddcb55c95be(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
                return false;
            }
        }, this.items.length, 0);
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return {
            remaining: remaining,
            transform: transform,
            selection: selection
        };
    }
    // Create a new branch with the given transform added.
    addTransform(transform, selection, histOptions, preserveItems) {
        const newItems = [];
        let eventCount = this.eventCount;
        let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
        for(let i = 0; i < transform.steps.length; i++){
            const step = transform.steps[i].invert(transform.docs[i]);
            let item = new $14f6ec349713ffc6$var$Item(transform.mapping.maps[i], step, selection), merged;
            // To match existing behaviour of prosemirror-history
            // eslint-disable-next-line no-cond-assign
            if (merged = lastItem && lastItem.merge(item)) {
                item = merged;
                if (i) newItems.pop();
                else oldItems = oldItems.slice(0, oldItems.length - 1);
            }
            newItems.push(item);
            if (selection) {
                eventCount++;
                selection = undefined;
            }
            if (!preserveItems) lastItem = item;
        }
        const overflow = eventCount - histOptions.depth;
        if (overflow > $14f6ec349713ffc6$var$DEPTH_OVERFLOW) {
            oldItems = $14f6ec349713ffc6$var$cutOffEvents(oldItems, overflow);
            eventCount -= overflow;
        }
        return new $14f6ec349713ffc6$export$aecb2ddcb55c95be(oldItems.append(newItems), eventCount);
    }
    remapping(from, to) {
        const maps = new (0, $3DNV7.Mapping)();
        this.items.forEach((item, i)=>{
            const mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from ? maps.maps.length - item.mirrorOffset : undefined;
            maps.appendMap(item.map, mirrorPos);
        }, from, to);
        return maps;
    }
    addMaps(array) {
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (this.eventCount == 0) return this;
        return new $14f6ec349713ffc6$export$aecb2ddcb55c95be(this.items.append(array.map((map)=>new $14f6ec349713ffc6$var$Item(map))), this.eventCount);
    }
    // When the collab module receives remote changes, the history has
    // to know about those, so that it can adjust the steps that were
    // rebased on top of the remote changes, and include the position
    // maps for the remote changes in its array of items.
    rebased(rebasedTransform, rebasedCount) {
        if (!this.eventCount) return this;
        const rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
        const mapping = rebasedTransform.mapping;
        let newUntil = rebasedTransform.steps.length;
        let eventCount = this.eventCount;
        this.items.forEach((item)=>{
            if (item.selection) eventCount--;
        }, start);
        let iRebased = rebasedCount;
        this.items.forEach((item)=>{
            const pos = mapping.getMirror(--iRebased);
            // To match existing behaviour of prosemirror-history
            // eslint-disable-next-line eqeqeq
            if (pos == null) return;
            newUntil = Math.min(newUntil, pos);
            const map = mapping.maps[pos];
            if (item.step) {
                const step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
                const selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
                if (selection) eventCount++;
                rebasedItems.push(new $14f6ec349713ffc6$var$Item(map, step, selection));
            } else rebasedItems.push(new $14f6ec349713ffc6$var$Item(map));
        }, start);
        const newMaps = [];
        for(let i = rebasedCount; i < newUntil; i++)newMaps.push(new $14f6ec349713ffc6$var$Item(mapping.maps[i]));
        const items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
        let branch = new $14f6ec349713ffc6$export$aecb2ddcb55c95be(items, eventCount);
        if (branch.emptyItemCount() > $14f6ec349713ffc6$var$max_empty_items) branch = branch.compress(this.items.length - rebasedItems.length);
        return branch;
    }
    emptyItemCount() {
        let count = 0;
        this.items.forEach((item)=>{
            if (!item.step) count++;
        });
        return count;
    }
    // Compressing a branch means rewriting it to push the air (map-only
    // items) out. During collaboration, these naturally accumulate
    // because each remote change adds one. The `upto` argument is used
    // to ensure that only the items below a given level are compressed,
    // because `rebased` relies on a clean, untouched set of items in
    // order to associate old items with rebased steps.
    compress(upto = this.items.length) {
        const remap = this.remapping(0, upto);
        let mapFrom = remap.maps.length;
        const items = [];
        let events = 0;
        this.items.forEach((item, i)=>{
            if (i >= upto) {
                items.push(item);
                if (item.selection) events++;
            } else if (item.step) {
                const step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
                if (step) {
                    const selection = item.selection && item.selection.map(remap.slice(mapFrom));
                    if (selection) events++;
                    // To match existing behaviour of prosemirror-history
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const newItem = new $14f6ec349713ffc6$var$Item(map.invert(), step, selection);
                    let merged;
                    const last = items.length - 1;
                    // To match existing behaviour of prosemirror-history
                    // eslint-disable-next-line no-cond-assign
                    if (merged = items.length && items[last].merge(newItem)) items[last] = merged;
                    else items.push(newItem);
                }
            } else if (item.map) mapFrom--;
        }, this.items.length, 0);
        return new $14f6ec349713ffc6$export$aecb2ddcb55c95be((0, $iSySZ.default).from(items.reverse()), events);
    }
    static #_ = this.empty = new $14f6ec349713ffc6$export$aecb2ddcb55c95be((0, $iSySZ.default).empty, 0);
}
function $14f6ec349713ffc6$var$cutOffEvents(items, n) {
    let cutPoint;
    items.forEach((item, i)=>{
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (item.selection && n-- == 0) {
            cutPoint = i;
            return false;
        }
    });
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return items.slice(cutPoint);
}
class $14f6ec349713ffc6$var$Item {
    constructor(// The (forward) step map for this item.
    map, // The inverted step
    step, // If this is non-null, this item is the start of a group, and
    // this selection is the starting selection for the group (the one
    // that was active before the first step was applied)
    selection, // If this item is the inverse of a previous mapping on the stack,
    // this points at the inverse's offset
    mirrorOffset){
        this.map = map;
        this.step = step;
        this.selection = selection;
        this.mirrorOffset = mirrorOffset;
    }
    merge(other) {
        if (this.step && other.step && !other.selection) {
            const step = other.step.merge(this.step);
            if (step) return new $14f6ec349713ffc6$var$Item(step.getMap().invert(), step, this.selection);
        }
    }
}

});
parcelRegister("iSySZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $dbe854c62d6f9f01$export$2e2bcd8739ae039);
var $dbe854c62d6f9f01$var$GOOD_LEAF_SIZE = 200;
// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var $dbe854c62d6f9f01$var$RopeSequence = function RopeSequence() {};
$dbe854c62d6f9f01$var$RopeSequence.prototype.append = function append(other) {
    if (!other.length) return this;
    other = $dbe854c62d6f9f01$var$RopeSequence.from(other);
    return !this.length && other || other.length < $dbe854c62d6f9f01$var$GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < $dbe854c62d6f9f01$var$GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
};
// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
$dbe854c62d6f9f01$var$RopeSequence.prototype.prepend = function prepend(other) {
    if (!other.length) return this;
    return $dbe854c62d6f9f01$var$RopeSequence.from(other).append(this);
};
$dbe854c62d6f9f01$var$RopeSequence.prototype.appendInner = function appendInner(other) {
    return new $dbe854c62d6f9f01$var$Append(this, other);
};
// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
$dbe854c62d6f9f01$var$RopeSequence.prototype.slice = function slice(from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from >= to) return $dbe854c62d6f9f01$var$RopeSequence.empty;
    return this.sliceInner(Math.max(0, from), Math.min(this.length, to));
};
// :: (number) → T
// Retrieve the element at the given position from this rope.
$dbe854c62d6f9f01$var$RopeSequence.prototype.get = function get(i) {
    if (i < 0 || i >= this.length) return undefined;
    return this.getInner(i);
};
// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
$dbe854c62d6f9f01$var$RopeSequence.prototype.forEach = function forEach(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from <= to) this.forEachInner(f, from, to, 0);
    else this.forEachInvertedInner(f, from, to, 0);
};
// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
$dbe854c62d6f9f01$var$RopeSequence.prototype.map = function map(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    var result = [];
    this.forEach(function(elt, i) {
        return result.push(f(elt, i));
    }, from, to);
    return result;
};
// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
$dbe854c62d6f9f01$var$RopeSequence.from = function from(values) {
    if (values instanceof $dbe854c62d6f9f01$var$RopeSequence) return values;
    return values && values.length ? new $dbe854c62d6f9f01$var$Leaf(values) : $dbe854c62d6f9f01$var$RopeSequence.empty;
};
var $dbe854c62d6f9f01$var$Leaf = /*@__PURE__*/ function(RopeSequence) {
    function Leaf(values) {
        RopeSequence.call(this);
        this.values = values;
    }
    if (RopeSequence) Leaf.__proto__ = RopeSequence;
    Leaf.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Leaf.prototype.constructor = Leaf;
    var prototypeAccessors = {
        length: {
            configurable: true
        },
        depth: {
            configurable: true
        }
    };
    Leaf.prototype.flatten = function flatten() {
        return this.values;
    };
    Leaf.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        return new Leaf(this.values.slice(from, to));
    };
    Leaf.prototype.getInner = function getInner(i) {
        return this.values[i];
    };
    Leaf.prototype.forEachInner = function forEachInner(f, from, to, start) {
        for(var i = from; i < to; i++){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        for(var i = from - 1; i >= to; i--){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.leafAppend = function leafAppend(other) {
        if (this.length + other.length <= $dbe854c62d6f9f01$var$GOOD_LEAF_SIZE) return new Leaf(this.values.concat(other.flatten()));
    };
    Leaf.prototype.leafPrepend = function leafPrepend(other) {
        if (this.length + other.length <= $dbe854c62d6f9f01$var$GOOD_LEAF_SIZE) return new Leaf(other.flatten().concat(this.values));
    };
    prototypeAccessors.length.get = function() {
        return this.values.length;
    };
    prototypeAccessors.depth.get = function() {
        return 0;
    };
    Object.defineProperties(Leaf.prototype, prototypeAccessors);
    return Leaf;
}($dbe854c62d6f9f01$var$RopeSequence);
// :: RopeSequence
// The empty rope sequence.
$dbe854c62d6f9f01$var$RopeSequence.empty = new $dbe854c62d6f9f01$var$Leaf([]);
var $dbe854c62d6f9f01$var$Append = /*@__PURE__*/ function(RopeSequence) {
    function Append(left, right) {
        RopeSequence.call(this);
        this.left = left;
        this.right = right;
        this.length = left.length + right.length;
        this.depth = Math.max(left.depth, right.depth) + 1;
    }
    if (RopeSequence) Append.__proto__ = RopeSequence;
    Append.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Append.prototype.constructor = Append;
    Append.prototype.flatten = function flatten() {
        return this.left.flatten().concat(this.right.flatten());
    };
    Append.prototype.getInner = function getInner(i) {
        return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
    };
    Append.prototype.forEachInner = function forEachInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from < leftLen && this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false) return false;
        if (to > leftLen && this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false) return false;
    };
    Append.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from > leftLen && this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false) return false;
        if (to < leftLen && this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false) return false;
    };
    Append.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        var leftLen = this.left.length;
        if (to <= leftLen) return this.left.slice(from, to);
        if (from >= leftLen) return this.right.slice(from - leftLen, to - leftLen);
        return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen));
    };
    Append.prototype.leafAppend = function leafAppend(other) {
        var inner = this.right.leafAppend(other);
        if (inner) return new Append(this.left, inner);
    };
    Append.prototype.leafPrepend = function leafPrepend(other) {
        var inner = this.left.leafPrepend(other);
        if (inner) return new Append(inner, this.right);
    };
    Append.prototype.appendInner = function appendInner(other) {
        if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) return new Append(this.left, new Append(this.right, other));
        return new Append(this, other);
    };
    return Append;
}($dbe854c62d6f9f01$var$RopeSequence);
var $dbe854c62d6f9f01$export$2e2bcd8739ae039 = $dbe854c62d6f9f01$var$RopeSequence;

});


parcelRegister("ft3yp", function(module, exports) {
$parcel$export(module.exports, "closeHistoryKey", () => $84959915b785c31c$export$88d5c5940bb51262);

var $cw0wu = parcelRequire("cw0wu");
const $84959915b785c31c$export$88d5c5940bb51262 = new (0, $cw0wu.PluginKey)('closeHistory');

});

parcelRegister("6xrPZ", function(module, exports) {
$parcel$export(module.exports, "historyKey", () => $78e7f55887e29388$export$7f87c7786a9ef8f7);

var $cw0wu = parcelRequire("cw0wu");
const $78e7f55887e29388$export$7f87c7786a9ef8f7 = new (0, $cw0wu.PluginKey)('history');

});

parcelRegister("1TYBU", function(module, exports) {
$parcel$export(module.exports, "HistoryState", () => $facf767a9f5a2f69$export$95c891a1f5736881);
class $facf767a9f5a2f69$export$95c891a1f5736881 {
    constructor(done, undone, prevRanges, prevTime, prevComposition, /**
   * ===
   * FORK ADDITION START
   * Allow for "history slicing" which groups together changes regardless of time / position adjacency
   */ historySliceActive, trackedSteps, selectionBookmark){
        this.done = done;
        this.undone = undone;
        this.prevRanges = prevRanges;
        this.prevTime = prevTime;
        this.prevComposition = prevComposition;
        this.historySliceActive = historySliceActive;
        this.trackedSteps = trackedSteps;
        this.selectionBookmark = selectionBookmark;
    }
}

});

parcelRegister("gNUrD", function(module, exports) {
$parcel$export(module.exports, "redo", () => $bd4751e470a40982$export$1688e416fee0a49e);

var $8ZU5G = parcelRequire("8ZU5G");
const $bd4751e470a40982$export$1688e416fee0a49e = (0, $8ZU5G.buildCommand)(true, true);

});
parcelRegister("8ZU5G", function(module, exports) {
$parcel$export(module.exports, "buildCommand", () => $a3fe684c3abec8f9$export$b31cc894333c4bfb);
// oxlint-disable-next-line import/no-duplicates

var $6xrPZ = parcelRequire("6xrPZ");

var $1TYBU = parcelRequire("1TYBU");

var $96Q2j = parcelRequire("96Q2j");

var $2556L = parcelRequire("2556L");
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function $a3fe684c3abec8f9$var$histTransaction(history, state, redo) {
    var _history$selectionBoo;
    const preserveItems = (0, $2556L.mustPreserveItems)(state);
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-explicit-any
    const histOptions = (0, $6xrPZ.historyKey).get(state).spec.config;
    const pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
    if (!pop) return null;
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const selection = pop.selection.resolve(pop.transform.doc);
    const added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
    /**
   * ===
   * FORK ADDITION START
   * If history slicing is active when we undo/redo, when we perform an undo/redo we want to
   * map and keep the relevant steps in the new history state
   */ const newHist = history.historySliceActive ? new (0, $1TYBU.HistoryState)(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1, history.historySliceActive, (0, $96Q2j.mapInvertableSteps)(history.trackedSteps, pop.transform), (_history$selectionBoo = history.selectionBookmark) === null || _history$selectionBoo === void 0 ? void 0 : _history$selectionBoo.map(pop.transform.mapping)) : new (0, $1TYBU.HistoryState)(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
    /**
   * FORK ADDITION END
   * ===
   */ return pop.transform.setSelection(selection).setMeta((0, $6xrPZ.historyKey), {
        redo: redo,
        historyState: newHist
    });
}
function $a3fe684c3abec8f9$export$b31cc894333c4bfb(redo, scroll) {
    return (state, dispatch)=>{
        const hist = (0, $6xrPZ.historyKey).getState(state);
        // To match existing behaviour of prosemirror-history
        // eslint-disable-next-line eqeqeq
        if (!hist || (redo ? hist.undone : hist.done).eventCount == 0) return false;
        if (dispatch) {
            const tr = $a3fe684c3abec8f9$var$histTransaction(hist, state, redo);
            if (tr) dispatch(scroll ? tr.scrollIntoView() : tr);
        }
        return true;
    };
}

});
parcelRegister("96Q2j", function(module, exports) {
$parcel$export(module.exports, "mapInvertableSteps", () => $7c52ca29932826fc$export$3cddda3829daa1af);

var $i4H9h = parcelRequire("i4H9h");
function $7c52ca29932826fc$export$3cddda3829daa1af(steps, tr) {
    if (steps === undefined) return undefined;
    return steps.map((step)=>{
        const newStep = step.step.map(tr.mapping);
        const newInvertedStep = step.inverted.map(tr.mapping);
        if (newStep && newInvertedStep) return new (0, $i4H9h.InvertableStep)(newStep, newInvertedStep);
        return undefined;
    }).filter((s)=>!!s);
}

});
parcelRegister("i4H9h", function(module, exports) {
$parcel$export(module.exports, "InvertableStep", () => $f86f72eacb0c0007$export$ebdc1f934f4dd665);
class $f86f72eacb0c0007$export$ebdc1f934f4dd665 {
    constructor(step, inverted){
        this.step = step;
        this.inverted = inverted;
    }
}

});


parcelRegister("2556L", function(module, exports) {
$parcel$export(module.exports, "mustPreserveItems", () => $6cab17f5a70cf0f8$export$107f10aa87a66306);
let $6cab17f5a70cf0f8$var$cachedPreserveItems = false, $6cab17f5a70cf0f8$var$cachedPreserveItemsPlugins = null;
function $6cab17f5a70cf0f8$export$107f10aa87a66306(state) {
    const plugins = state.plugins;
    // To match existing behaviour of prosemirror-history
    // eslint-disable-next-line eqeqeq
    if ($6cab17f5a70cf0f8$var$cachedPreserveItemsPlugins != plugins) {
        $6cab17f5a70cf0f8$var$cachedPreserveItems = false;
        $6cab17f5a70cf0f8$var$cachedPreserveItemsPlugins = plugins;
        for(let i = 0; i < plugins.length; i++)// To match existing behaviour of prosemirror-history
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (plugins[i].spec.historyPreserveItems) {
            $6cab17f5a70cf0f8$var$cachedPreserveItems = true;
            break;
        }
    }
    return $6cab17f5a70cf0f8$var$cachedPreserveItems;
}

});



parcelRegister("jVAei", function(module, exports) {
$parcel$export(module.exports, "undo", () => $2de4e57063b7e5c4$export$21f930c44940fd98);

var $8ZU5G = parcelRequire("8ZU5G");
const $2de4e57063b7e5c4$export$21f930c44940fd98 = (0, $8ZU5G.buildCommand)(false, true);

});

parcelRegister("8mpUq", function(module, exports) {
$parcel$export(module.exports, "createTransformFromSteps", () => $0c969ca0c0755cb6$export$6137dcc98f08e76);

var $3DNV7 = parcelRequire("3DNV7");
function $0c969ca0c0755cb6$export$6137dcc98f08e76(steps, finalDoc) {
    for (const step of steps.slice().reverse())try {
        const result = step.inverted.apply(finalDoc);
        if (result.failed === null && result.doc) finalDoc = result.doc;
    } catch (e) {
    //TODO: EDITOR-2471 - Log the error
    }
    let tr = new (0, $3DNV7.Transform)(finalDoc);
    for (const step of steps)try {
        tr = tr.step(step.step);
    } catch (e) {
    //TODO: EDITOR-2471 - Log the error
    }
    return tr;
}

});



//# sourceMappingURL=shared.84b5a31c.js.map
